var _g, _defs, _g2, _defs2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholderNoticia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 720",
    style: {
      enableBackground: "new 0 0 1280 720"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Camada_3"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -1.7,
    y: -0.7,
    width: 1280,
    height: 720
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -6.4,
    y: -298.8,
    style: {
      fill: "#9DBDE0"
    },
    width: 1292.7,
    height: 1292.7
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.16
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M784.6,577.8c-0.6,1.4-0.1,4.2-0.8,5.1c-2.3,2.7-6.7,9.1-9.9,11.4c-4.1,2.9-9.2,2.4-9.2,10.7 c0,2.7,2.1,7,2.1,8.8c0,0.3-2.8,7.6-2.8,7.6c-0.3,0-2.8,2.7-2.8,3.4c0,2.5,0,5.3,1.7,6.8c0.1,1.2-0.3,2-0.3,4.2 c0,4.4,3.1,9.3,6.6,9.3c8.6,0,9.9-11.3,12.4-19c3.1-9.7,6.4-18.2,6.4-30.5c0.3,0,1.7,0.5,2.4,0.8v-2.5 C789,589.5,789.4,578.5,784.6,577.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M908.4,484.1c0,2.4,1.6,4.7,3.5,4.7c2.7,0,4.5-3.9,4.5-6.9c0-5.4-4.1-7.5-6.1-11.5 C910.4,475.4,908.4,479.2,908.4,484.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1013.4,543.1c0-1.7-0.7-4.1,0.7-4.7V531c0-1.7-2-2.2-2.8-3.2c-1.6-1.9-3.3-2.9-3.3-6.4 c-1.6,0-2.7-0.5-2.7-2.7l0.6-1.7c-0.3-0.7-0.7-1.5-1.3-1.5h-1.1c0-0.2,0.3-0.7,0.3-0.8c0-2.6-2.4-3.4-4.5-4.3 c-4-1.5-5.5-3.7-8.2-6.9c-1.4-1.7-2.4-3.7-4.5-4.6c-0.6-0.2-1.3,0-1.5-0.9c-1.1-2.7-2.1-5.2-5.2-6.4h-4.7 c-1.1-0.7-1.4-1.5-2.8-1.5h-0.9v1.4c0.4,1.7,2.7,6.4,3.8,6.8c1.3,0.3,2.7,0,3.2,1.5c0.9,2,1.3,3.1,2.1,5.1 c1,2.4,4.2,1.7,5.2,5.6c0.3,1.4,1.3,5.4,2,5.9c0.4,0.3,2.1,0.5,2.3,0.9c0.3,0.5,0,1.5,0.4,1.5c0.4,0,2.1,3.4,2.4,4.2 c1.6,3.9,2.7,6.9,5.5,10.3c2.5,3.1,5.1,4.4,7.8,7.6c0.1,0.2,2.7,4.6,3.4,4.6C1010.6,545.4,1013.4,544.9,1013.4,543.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1026.6,513.2c0,0.8,1.4,6.9,2.1,7.1c0.7,0.2,1.6,0.2,1.8,1c0,0.2-0.1,0.7-0.1,0.8 c1.8,3.4-0.4,9.3,4.8,9.3c1.1,0,1.8-1,3-0.9c0.1,0.7,0,2.5,0.3,2.5c0.4,0,0.7,0.8,1.1,0.8c1.7,0,2.4-1.9,3.5-1.9 c2.4,0,4,2,6.2,2.7c0,1,0.4,2.4,1.8,2.4c1.9,0,2.1-2,4.4-2.7c0-1.9,1.7-4.4,1.7-5.8c0-0.8-0.7-1.2-0.7-2.4c0-1,1.4-3.6,3.1-3.9 c0-2.9,1.1-3.9,1.9-7.6l0.7-1.7c0.4-0.2,1-0.3,1.4-0.3c1.5,0,2.7,0.8,3.1-1.7c-2.5,0-6.4-8.5-6.4-11c0-0.5,0.6-1,1-1.2 c-0.1-0.5-0.4-1-0.6-1.5c0,0,3.8-1.9,4.1-2.4c-0.3,0-0.6-0.5-0.6-0.9c0-1.5,3.1-0.5,3.1-2c0-3.4-5.9-1.4-5.9-4.9 c0-2.5,0.3-4.2-2.1-4.2c-2.3,0-5.4,6.4-6.5,9.1c-0.6,1.4-3.8,0.5-5.1,2c-0.3,0.3-0.4,1.2-0.9,1.4c-0.7,0.3-0.5,0.7-1.4,1.2 c0,0-1.5,1.4-1,2c-1.1,1.4-1.1,3.1-3.3,3.6c-1.6,0.3-3,0.3-4,1.5c-2,2.4-1.4,7.6-5.8,7.6 C1029.6,511.5,1026.6,510.4,1026.6,513.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1076.4,515.3c2.4,0,3.4-0.7,5.4-0.7c1.8,0,3.1,1.2,4.9,1.2c2.8,0,3.8-2.9,4.2-5.4 c0.4,0,0.6-0.8,0.7-1.4h-0.8c-1.7,1.4-3.7,2.9-4.5,3.9h-1.1l-9.9-2c-3.7,0-5.4,5.6-5.4,9.7c0,1-1.1,1.9-1.3,2.6 c-1,3.9-2.5,5.4-2.5,9.1c0,2,2,2,2.8,2.2v8.1c0,1,1.1,2.2,2.3,2.2c1.6,0,2.1-5.9,2.1-6.8c0-2.2-1.3-3.4-1.3-5.6 c0-1.2,1.1-2,2.1-2c0.4,0,0.7,0.2,1.1,0l-0.6,3.6c0,2.2,2.3,3,2.3,5.2c0,0.5,0.1,1,0,1.5h1.8c0-1.9,3.1-1.7,3.1-3.6 c-0.6-0.2-2-2-2-3.1c0-0.3,0.4-0.7,0.6-1c-0.8-0.5-3.5-6.6-3.5-7.1c4,0,4.2-3.7,7.5-4.9v-1.4c-0.9-0.2-8.4,2.5-8.5,3l0.3-0.7 c-0.6,0.9-0.7,1.7-1.6,1.7c-2.1,0-3-3.2-3-5.8C1071.7,514.6,1074,515.3,1076.4,515.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1049.2,558.2c1.7,0,1.6,1.2,3,1.2c0.3,0,1.3-1.2,1.5-1.9c-1-0.5-1-1-2.3-1.5 c-1.3-0.5-2.4,0.9-3.4-0.3c-0.3-0.3-0.3-1.5-1.2-1.5c-2.5,0-4.4-0.4-5.9-2.2c0.3,0.2,5.1-0.3,5.2-1.2h-1.1l-4.2,0.7 c-2.6,0-3.5-3.1-6.4-3.1c-1.7,0-2.1,2.5-4.2,2.5c-4.7,0-6.5-5.4-10.8-5.4c-0.9,0-1.4,1-2.3,1c-0.4,0-0.7-0.7-1.1-0.7 c-0.8,0-3.4,3.1-3.5,3.6c2.1,0,3.3,2,4.7,3.7c1.4,1.7,3.5,0,5.6,0.9c2.8,1,5.1,1.2,7.8,1.2c1.4,0,1.9,2.2,3.5,2.2 c5.5,0,10.3,0.3,15,2.5C1049.1,559.3,1048.8,558.2,1049.2,558.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1078.9,560.4c1.8-0.7,3.1-1.2,4.1-3.4c-1.3,0.7-2,1.7-4.1,1.7c-2.1,0-3.1-1.2-5.7-1.2 c-1,0-2.6-0.2-2.6,1.2c0,1.9,2.1,1.7,3.1,1.7H1078.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1063.6,557.6c0,0.5-0.1,0.9-0.1,1.4c-0.7-0.3-1.4-0.7-2.7-0.7c-1.3,0-2.4-0.2-2.4,1.7 c0,0.7,1.7,1.2,2.8,1.2c1.4,0,2-1,3.4-1.7l1.1,0.7h1.3c-0.3-0.3,0-1.2,0-2.5H1063.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1071.7,562.4h-1.4c-1,0-2.7-0.3-2.7,1c0,1.7,2.3,1.8,3.7,1.8c0,0.5,0.1,2.2,0.8,2.2h0.6 c0.4,0,1.1-0.7,1.1-1.2C1073.8,564.3,1071.7,564.8,1071.7,562.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1056.4,557.5h-1.3v1.7c0,0.5,0.7,1.2,1.1,1.2c0.7,0,1.3-0.7,1.4-1.7 C1057.1,558.3,1057.1,557.5,1056.4,557.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1091.4,562.8c2.3,0,6.9-1.4,8.4-3.9c-1.3-1-7.5-0.3-8.9,1.4c-0.3,0.3-0.3,1.3-0.7,1.5 c-2.1,0.8-4.8,0.8-4.8,4.6c0,0.7,0.4,1.5,1,1.5c1.6,0,4-2,4.7-2.9C1091.4,564.4,1090.7,562.8,1091.4,562.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1130.4,545.8c0-1.2-0.3-0.5-0.6-1.8c-1,0.1-0.8,1.7-0.8,2.9c0,1-1.4,1.2-1.4,2.9 c0,0.5,0.4,1.4,0.8,1.4c1.1,0,0.9-1.9,0.9-3.6C1130,547.5,1130.4,546.8,1130.4,545.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1095.5,532.9c0,1.4,1.7,3.2,2.5,3.2c0.4,0,1.4-1.9,1.4-2.2 C1099.4,532.2,1095.5,530.9,1095.5,532.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1102.8,532.9c0,0,2,0.7,2.5,0.7h3.3c2,0,3,1.7,4.9,1.7c0.3,0,0.8,0,0.8-0.3 c0-1.4-1.6-1.7-1.7-3.1l-0.4,0.2c-0.8,0-1.8,0.5-2.1-0.7h-6.4C1103.5,531.7,1102.8,532.1,1102.8,532.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1102.3,505.9c-1.1,0.7-1.3,2-1.3,3.4c0,2.2,1.1,2.9,1.1,4.7v2.2c0,1,0.4,3.2,1.8,3.2 c-0.7-1.2-1-1.9-1.6-2.9v-1.2c1.1,0,2.7-0.2,3.2-0.3c-0.1-1.4-1.1-1.7-1.1-2.6c0-1,1.4-1.2,1.4-2.2 C1103.5,509.7,1102.5,508.3,1102.3,505.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1186.4,543.9c0.4,2,2.5,1.8,3.7,2.9c0,0,0,0.1,0.1,0.1c0.1,0.1,0.2,0.2,0.3,0.3l-0.3-0.3 c0.6,0.5,1.7,1.2,2.1,1.2c3,0,4.2-1.9,6.8-2.5c0-3.1,3-2.4,3-6c0-1-0.4-2.5-1.3-2.5c-2,0-1.1,3.7-3.1,4.9 c-1.3,0.7-3.4,0.5-5.5,1.4c0,0-1.3,0.7-1.6,0.5H1186.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1179.4,545.4c-3.4-2-3.3-6.6-7.8-8.3c-0.7-0.2-1.8-0.3-1.8-1.7c-1.7,0-2.5-2.4-4.2-2.4 c-3.2,0-7.5-1.7-9.6-3.6v-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.3-0.3-0.4-0.4l0.3,0.4c-0.7-0.2-1.9-0.7-2.4-1.4h-3.8 c-0.8-0.5-2-2.6-3.7-3.2c-0.4-0.2-1.6,0-1.7-0.9c-1.7,0.3-3.4,3.4-4.7,3.9c-2,0.7-2.3,0.9-3.4,2.2c-0.3,0.3-1.6,2.9-2.5,2.9 c-0.9,0-2.8-2.7-2.8-3.4c-1.3,0-2.1-0.7-2.1-1.5v-6.1c-2.5-0.7-4.4-3.4-6.8-3.4c-2.5,0-3.5,2.9-5.2,2.9c-0.9,0-2,0.5-2,1.5 c0,2.4,3.4,1.4,4.4,3.8c0.1,0.5,0.4,1.4,0.9,1.5c0.7,0.2,1.3,0.5,2,0.5c1.6,0,2.5-0.2,4.1-0.7h1c-1,2-5.2,1.7-7.2,2.9 c0.3,1.4,1.8,0.7,2.5,2c0.7,1.4,0,2.1,0.7,3.7c0.1,0.5,1,0.5,1.4,0.5c1.1,0,1.7-1.7,2.1-3v1.5c2.3-0.9,3.1,3.6,5.2,3.6 c2.3,0,6.1,0.8,7.6,1.7c1.4,0.9,5.4,2.7,5.9,4.7c0.7,2.5-0.1,4.9,1.9,7.3c-0.9,0.5-3.5,1.4-3.5,3.4c0,1.4,1.3,1.4,2.3,1.4h3 c0-0.8,1.5-1,2.1-1c3.7,0,4.7,5.3,8.3,5.3h5.4c0-1.2,1.3-1.9,0.7-4.1c2-1.2,1.7-4.2,5.2-4.2c4.7,0,7.2,4.7,10,8.1 c0.3,0.3,1.4,0.7,1.4,1.4c0,1.9,3.3,3.7,5.4,4.2h3.7c0.3,0.3,2.4,2,2.7,2h0.8c0-1.2,1-2,1.8-2.7c-0.4-0.2-2.6,0.2-2.8-0.7 c-0.3-0.7-0.6-1.7-1.4-2c-0.6-0.2-1.4,0.5-1.7-0.3c-0.3-0.7-0.7-1.9-1.1-1.9c-1,0-2.7-0.8-3.1-1.7c-1.1-2-0.9-3.2-2.3-4.9 c-0.3-0.3-2.7-3.2-2.7-4.1c0-1.5,2.7-0.8,2.7-2.7C1183.8,544.4,1180.8,546.3,1179.4,545.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1203,534.4c-1.6-1.9-2.8-3.9-5.5-4.9c0.4,1.4,1.4,1.2,2.5,2c1.8,1.3,1.6,3.2,3.4,4.2 c-0.3,1.7-0.3,2.9,1.4,3.2c0.3,0.3,0.6,0,0.8,0c-0.1-0.3,0-0.9,0-1.2C1205.7,535.4,1204.1,535.8,1203,534.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1212.2,543.4c-0.3,1.7,0.3,3.4,2,3.7v1.4c0,0.5,0.4,1.2,0.9,1.2c0.4,0,1-0.8,1-1.4 C1216,547.8,1213.1,544.1,1212.2,543.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1239.5,566.1c-0.1,1,0.8,3.5,2.3,3.5c-0.1-0.3,0-0.7,0-1C1241.8,567.3,1240.6,567,1239.5,566.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1233.3,563.4c0,2,2.3,2.7,4,2.7c0.2,0,0.6-0.3,0.7-0.3C1237,564.1,1235.5,563.4,1233.3,563.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1234,556.8c0.1,1.3,2.7,5.4,4.1,5.4C1237.4,559.7,1236,558.2,1234,556.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1225.6,553.2h-0.3c0,1.9,3.3,3.2,4.4,3.2c0.4,0,0.9-0.2,1.1-0.3c-0.9-1.5-3.7-2.5-5-3.4 L1225.6,553.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1219,548.5l0.7,0.5c0,0.2-0.6,0.2-0.7,0.2l2.1,1.7h1.3C1221.5,549.3,1220.5,549.9,1219,548.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1137.8,699c1.3,1.5,3.4,1.2,5,0C1140.7,697.8,1140.5,697.5,1137.8,699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1115.6,574.8h1.4v-2.5c-2.1-0.2-3.1,0.2-5.7,0.8C1111.9,573.8,1113.9,574.8,1115.6,574.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1203,640.7c-2.7-3.2-8.1-6.1-8.1-12.9c-1.8,0-4.1,0-4.7-2.2c-0.6-2.4-0.9-5.6-2.6-7.6 c-2.4-2.9-8.5-4.4-9.6-8.5c-1.1-4.3-2.3-6.4-3.5-11c-0.7-2.7-0.7-8.1-2.4-9.5c-0.6-0.3-3.2-1.4-4.7-1.9 c-1.6-1.4-0.8-4.4-1.4-6.8c-0.9-3.2-2.7-6.3-3.1-10.9c-2.4,1.5-1.7,3.7-4,5.8v15.3c-0.7,3.9-1.6,13.9-5.9,13.9 c-2.7,0-3.4-3.7-5.4-4.6c-3.5-1.7-5.7-2.5-9.5-4.2c-0.6-0.2-0.6-2.7-1.4-3.4c-0.8-0.7-2.8-0.3-2.8-1.7l1.7-8.5 c1.1-1,3.2-1.2,3.2-3.4c0-1.4-2-3.1-2.8-3.1c-1.6,0-2.1,1.4-4,1.4c-5.1,0-7.9-2.4-12.7-4.7c0.3,1.9,1.7,2.4,2.5,3.9 c-0.4,0.2-1.5,1.2-2.5,1.2c-2.4,0-8.1,1.5-8.1,3.9c0,2.4-2.1,3.6-2.1,5.9c0,1.5,0.4,2.7-0.4,4.2c-0.3-0.2-1.4-1.3-2.1-1.3 c-1.3,0-2.4,0.7-3.1,1.9c-0.3-3-1.7-6.4-4.3-6.4c-3,0-3.7,3.4-7.5,3.4c-0.3,3.9-3.1,4.6-3.1,9.3c-1.1,0-1.8-0.7-3-1.4 c-0.7,1.9,0,4.4-1.6,5.6c-0.6-1.2-1.4-1.9-2.1-3.4c-1.4,0.8-1.8,2.5-1.8,4.2v2.9c0,5.8-11.6,10.5-16.7,11.5 c-2.7,0.5-7.8,0.8-9.5,2.9c-1.6,1.8-4.8,6.1-7.5,6.4c0-0.5,0-1.2-0.2-1.7c-0.6,0.3-1.6,0.7-1.6,2v9.8c0,4.2,1.7,6.3,1.7,8.8 c0,0.8,0.4,1.5,0,2.2c-0.4-0.5-1-1.4-1.3-2.2c-0.4,0.8-0.6,1.5-0.9,2.2c-0.7,2.5,2.1,3.4,2.8,5.9c1.8,6.6,2.3,9,4,16.4 c0.7,3,2.8,5.8,2.8,10.7c0,3.9-3.2,5.1-3.2,7.6c0,2.4,6.8,5.9,9.2,5.9c6.4,0,8.5-5.6,13.4-5.6c1.7,0,1.7-1.4,4,0 c3.1,0,5.5-0.9,8.5-1.2c1.1-8.6,10-5.6,17.3-8.5c3.1-1.2,4.1-3.9,9.2-3.9c4.7,0,13,1.7,15.3,5.1c1.1,1.9,4.3,10.2,5.2,10.2 c0,0-0.6,3,1.1,3c3,0,6.5-8.8,9.1-11.9c0.1,2.5-0.6,11.4-4.1,12.2c0,0.9,0.7,1.7,1.4,1.7c2.1,0,2.3-3,3.5-3.7 c0-0.5,0.3-1.2,0.3-1.7c0.6,0.7,1.4,1.3,1.4,3.4c0,1.7-0.6,2.7-1,3.7h1.7c1.1-0.3,1.8-0.5,2.8-1.2c0,0.2,0.2,0.9,0.2,0.9 c0.1,2.2,2,4.2,2,6.8c0,7,9,11.4,14.6,11.4c3.5,0,2.4-3.4,5.7-3.7c0.1,1,5.9,4.9,7.1,5.1c1.1-8.2,12.7-4.6,14.3-12.4v0.3 c0-5.9,3-11.2,4.1-15.3c1.4-5.4,4-7.1,6.5-11.9c0.7-1.3,0.3-2,1-3.4v-4.7c1.3-1.5,2.1-6.8,2.1-10.5c0-5.1-1.4-14.3-3.7-17.8 L1203,640.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1093.1,469.4c-0.1,0.4,0,2.5-0.4,3.5c-0.4,0.9-2.7,0.2-2.8,2.3c-0.8,0.1-1.2,0.9-1.2,1.9 c-0.3,0-0.5,0-0.8,0c-0.9,0-0.6-2.4-2.3-2.4c-2.3-0.1-1.7,3.2-4.4,3.1c-0.3,1.5-0.8,2.3-0.8,3.8c0,0.5,0.5,1,0.5,1.5 c0,0.6-1.1,3.4-0.1,3.4c1.4,0,1.2-4.8,2.6-6.3c0,0,0.9,1.2,1.3,1.4c0.1-0.2,0.4-0.7,0.4-0.7c0.2,0.3,0.5,0.7,1.3,0.8 c-0.1-0.4,0-0.9,0-1.3l1.8,0.1c0.1,0.4,0.4,1,0.5,1.5c-0.4,0.3-0.6,0.7-0.7,1.7c0,2.8,1.5,5.2,3.3,5.2c0.4,0,0.9,0.2,1.3-0.1 c0,0.4,0.2,1.2,0.6,1.2c0.9,0,1.4-0.9,1.4-2c0-1.6-1.5-2.1-1.5-3.1c0-0.9,0.7-1.2,1.2-2c0.3,0.5,0.6,0.8,0.7,1.2l-0.1-0.4 c0.2,0.8,1.1,3.3,1.6,3.5c0-2.5,1.6-3.4,1.6-5c0-1.3-2.1-10.1-3.1-11.3C1094.6,470.2,1094,469.4,1093.1,469.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1062.9,475.3l0.9,0c1.6-1.2,4-3,4.6-6.4c1,0,1.9-0.3,2.2-1.6c0.6,0,0.8-0.4,1.3-0.9 c-0.5-0.6-1.1-0.9-1.1-2.4c-0.4,0.4-0.4,1.2-0.7,1.9C1068.7,469.2,1064.3,470.9,1062.9,475.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1070.1,444.1c0,0.9,2.3,2.7,2.8,2.7c0.4,0,0.7-0.6,0.9-1l0.8,0l0,1.5c-0.3,0.3-0.8,0.7-0.8,1.6 c0,0.8,1,2.1,1.9,2.1c0.8,0,1.3-0.9,2.1-0.8c1.8,0,1.9,3.3,3.7,3.3c-0.4-1.2-0.7-1.8-0.1-2.8c0.8,1.3,3.8,2.7,4.6,4.5 c0.1,0.4,0.2,1.2,0.6,1.2c0.3,0,0.5-0.6,0.5-0.9c0-0.4,0-0.7,0-1.2c-0.9,0-1.7-0.6-1.6-1.8c-0.3,0.1-0.9,0.3-0.9,0 c0-0.8,0.6-0.9,0.8-1.8c-0.2,0-0.5-0.3-0.8-0.3c-0.5,0-0.7,1-1.2,1c-0.8,0-1.1-3.4-2.7-3.4c-0.8,0-1.4,0.6-1.4,1.1 c0,0.1,0,0.6,0,0.7c-1.4-0.8-3.2-4.5-3.1-6.7c0-3.1,2.4-3.3,2.4-6.6c0-2.5-1.6-4.7-1.6-6.7c0-0.3-0.3-0.8-0.3-1 c0-0.2-0.2-0.6-0.2-0.7c-0.5,0.3-0.9,1.4-1.7,1.4c-1.2,0-0.9-2.7-2.3-2.7c-1,0-1.3,1.5-1.3,2.9c0,1.8,0.6,3,0.6,4.7 c0,1.3-0.3,3.4-0.8,4.4C1069.6,438.7,1070.1,441.8,1070.1,444.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1091.7,457.4c-1,0-1.8-0.6-2.8-0.7c-0.4,0-0.8,0.4-1.2,0.6c0.2,1.2,3.1,2.3,3,4.3 c0,0.3-0.4,0.9-0.6,0.9c-0.1,0-1,0-1.7,0l0,0.9c0.1,0.4,1,2,1.9,2l0,0.9c-0.5,0.9-0.3,2.1,0.6,2.1c0.4,0,0.8,0,1.2,0l0-0.9 c-0.5-0.3-1-1.8-1.1-3l1.9,0c0.1-0.6,0.4-1,0.5-1.9c-0.1,0-1-1.4-1-1.4s0.1-1.5,0-2.3c-0.3,0-0.5,0-0.8,0 C1091.8,458.5,1091.7,457.9,1091.7,457.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1080.6,460.3c-0.2-0.2-0.4-0.5-0.6-0.5c-0.3,0-0.8,0.4-0.8,0.7c0,1.3,0.5,4.2,0.4,6.7 c1.2-0.9,4.2-2.1,4.2-4.6C1083.9,461.4,1081.6,460.9,1080.6,460.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1084.5,464.6c-0.6,0.1-1.4,3.8-1.4,4.2c-0.4,0-1.2,0.4-1.2,0.9c0,1,2.3,3.9,2.8,3.9 c0.2,0,0.8-0.4,0.8-0.7c0-0.9-0.6-0.6-0.6-1.9c0-1.8,1.5-2.9,1.5-4.7C1086.4,465.4,1085.8,464.2,1084.5,464.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1085.7,470.4h0.6c0-2.2,1.7-2.9,1.8-5.6c-0.4,0-0.8,0-1.2,0 C1086.9,467.5,1086.1,468.7,1085.7,470.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1089.7,468.6c-0.4,0.6-1,0.3-1.6,0c-0.4,0.9-1.2,1.3-1.2,2.2c0,0.3,0.5,0.8,0.8,0.8 C1088.8,471.5,1089.7,470.2,1089.7,468.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1087,460.4c0-1.9-1.6-2.4-2-3.7l-1.2,0c0,0.6,0,1.2,0,2.2c0.6,0,1.2-0.1,1.8,0 C1085.6,459.6,1087,461.2,1087,460.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1076.7,457.7c0.5,0,1.2-1.8,0.9-2.9c-0.4-1.8-1.8-1.5-3.3-2.7l-1.3,0 C1073.1,452,1076,457.7,1076.7,457.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1078.1,453c0.2,0.3,1,0.2,1.3,0C1079.1,452.7,1078.4,452.9,1078.1,453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1076.2,391.7c-2,0-5,6.6-5,10.2c0,2.5-0.4,4.8,2.1,4.8C1076.7,406.6,1079.8,391.7,1076.2,391.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1034.5,420.5c0-1-1-2.5-1.7-2.5c-1.8,0-6.7,4.2-7.8,4.2c-0.7,0,0,1.5,0,2.6 c0,2.2,1,3.4,3.1,3.4C1030.2,428.1,1034.5,422.9,1034.5,420.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1014.4,528c0.1,0.5,0.7,2.4,1,2.4c0.6,0,1,1,1.8,1h1c-0.1-0.5-0.1-1.2-0.1-1.7 c-2,0-2.8-3.2-3.5-5.8c-1,0.2-3,1.3-3,2.2C1011.6,527.5,1013.8,526.6,1014.4,528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1022.9,532.4c0.9,0,1.4-1,1.6-2c-0.4-0.2-0.9-0.8-1.3-0.8h-1.4c-0.1,0,0,0.7,0,0.8 C1021.8,531.2,1022,532.4,1022.9,532.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M987,522h-1.1v0.7c0,1.2,1.8,3.9,2.5,4.1c0.1-1.7-0.5-2.7-1.4-3.9V522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M981.4,511.7l-0.7,0.3h0.1c0.1,1,2,3.7,2.5,3.7C984.5,515.8,982.3,512.4,981.4,511.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1109.9,350.5c0,0.8,0.7,1.9,1.4,1.9c0.4,0,1-0.7,1.7-0.7c-0.3-0.5,0-1,0-1.5 c0.1,0.9,0.3,1.9,1.1,2.2l-0.6,2.4c0,0-1.4,2.4-1.4,2.7c0,0.7,0.8,2.7,2,2.7v-1c0,0.5,0,1.5,0.4,1.5c2,0,3.1-5.3,3.5-8.3 c0.4,0.3,0.8,0,1.3,0c-0.3-0.5,0-1.2,0-1.7l-1.3-1.4c-0.4,0-0.1-1.2-0.1-1.7c-1.7,0-2.5-1.4-3.7-1.4 C1113.9,346.3,1109.9,349.5,1109.9,350.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1122.9,351.8c1.8,0,2.1-2.7,3.4-4.2c0.4,0.2,1,1.2,2.1,1.2c1.4,0,3.1-5.9,0-5.9 c-2,0-2.4,2.9-4.8,2c0,0.2-2.7,2.6-2.7,2.6c0,0.8,0.3,1.2,1.1,1.8C1121.9,350.2,1122.2,351.8,1122.9,351.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1138.2,331.2c-1.3,0-2.1,5.2-4.5,5.2h-8.8c-3.7,0-5,4.3-7.9,6.6c-0.5,0.3-1.8,0.7-1.8,1.2 c0,0.7,1,0.7,2,0.7c3,0,5.5-1.3,7.4-2.4c1.1-0.7,2,0.2,3.1-0.5c0.4-0.2,0.6-1.4,1.4-1.4c1.7,0,2.5,1,4.3,1.5 c0,0.7-0.4,1.9-0.4,2.9c0,0.5-0.4,1.4,0,1.4c1,0,0.8,1.3,2,1.7c0.7-1.7,2.4-4.4,3.4-4.4c0.4,0,1,0,1.4-0.2 c-0.1,0-1.4-2-1.4-2.7c0-0.5,0.4-1.4,0.9-1.4c1.3,0,1.1,2.9,4.1,2.9c1.1,0,2-1,2.8-2h1.4c0,0.3,0.4,0.8,0.7,0.8 c0.6-2.4,1.8-2.5,3.8-4.1c-0.1,1.2-0.7,1.3-0.1,2.7c1.7-0.7,1.7-2.4,3.4-3.4c-0.3-1-0.7-1.7-0.7-3.2c0-2.2,1.6-3.2,1.6-4.7 c0-1.9-0.4-7.1,1-7.6c0.4-0.2,0.9,0.2,1.3-0.3v-1c0-2.2,2-2.6,2-5.3c0-2.4-2-3.6-2-5.9c0-1.2,0.1-2.2-0.3-3.4 c-0.1-0.5-0.7-0.9-1.7-0.9c-0.4,0-0.1,1.5,0.3,1.5c0.1,0,0.3,0.2,0.4,0.2c-1.7,1.7-1.5-0.5-1.8-0.5c-1.9,0-3.3,4.2-3.3,6.3 c0,0.9,0.6,0.9,0.6,2c0,5.4-4.8,12.6-7.8,13.7c-1.7,0.7-2,2.4-4.1,2.4c-0.3,0-0.7-0.5-0.7-0.8c0-0.7,0.3-1.3,0.7-1.9 C1140.2,327.1,1138.3,331.2,1138.2,331.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1154.2,293.4c-0.3,1.2-2.5,2.4-2.5,4.2c0,0.7,0.7,1,0.7,1.7v3.9h0.8c1.1-1.4,2.3-0.7,3.4-2.5 c-0.5-0.7-2.7-0.7-2.7-2.4c0-2.9,2.4-1.2,4.2-1.2c0-0.5,0.6-1.2,1-1.4c2.4,1.9,3.8,2.2,6.1,3.9c1.1-2,2.1-5.9,5.1-5.9 c2.1,0,3.1-0.5,4.4-1.5c-0.6-0.2-1.7-1.2-1.7-2.2c0-0.9,0.6-1.2,0.9-2c-0.9-0.7-1.8,0.3-3,0.3c-5.5,0-7.2-5.4-11-8.5 c-0.3,0.5-0.9,1-0.9,2.2c0,0.7,0.7,1,0.7,1.7c0,2.2-1,8.8-3.4,8.8c-0.4,0-1,0.2-1.4,0l0.3,0.3c-0.4-0.3-0.7-0.5-1-0.8V293.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1174.6,288.3c-0.3,0.5-0.4,1.5,0,1.5c1.3,0,3-2.5,3.5-3.6l-0.5-0.4 C1176.5,285.9,1175.1,287.3,1174.6,288.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1177.4,285.6l0.2,0.2c0.1,0,0.1-0.1,0.2-0.1L1177.4,285.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1185.3,279.5c-1.7,0-3.1,3.7-3.1,3.7c0,0.2-0.1,0.8,0,0.8c2,0,2-3.4,5.2-3.4v-1.2 C1186.9,279.6,1186.2,279.5,1185.3,279.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1192,277.9c1.1,0,2.3-2.4,2.4-3.4c-0.3,0-2,0-2.3,1c-0.1,0.5,0.3,1.4-0.1,1.4 C1191.7,276.9,1191.7,277.9,1192,277.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1165.1,230.6c-0.6-2.2-1.7-4.4-1.7-7.8h-1v3.6c0,0.8-0.6,1.2-0.6,2.2c-2.1,0.5-3,5.1-3,8.6 c0,2.5,2.1,3.6,2.1,6.1v10c0,2-0.7,2.7-0.7,5.3c0,2,0.9,2.4,0.9,4.7c0,2.5-0.6,4.6-0.6,7.6c0,0.8-0.4,4.9,0,4.9 c1.7,0,1.7-3.7,3.4-3.7h1.4c0.1,0.7,0.9,1.9,1.4,1.7c0.1,0,0.4-0.2,0.4-0.2c-1.1-2.9-4.1-4.7-4.1-8.7c0-4.4,0.4-9.8,4.3-9.8 c1.3,0,2.3,1,3,2.2c-0.8-4.1-2.7-7.5-3.8-11.7c-0.3-1-1.3-2.9-1-4.6v-4.1C1164.5,234.7,1165.6,233,1165.1,230.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M797.2,93.8c0,0,3.8-0.2,4.2,0c2.4,0.8,1.1,3.6,2.1,5.9c0.3,0.8,2.5,0,3.5,0c0.4,0,0.7,1,1,1.2 h11c-0.1-0.3-0.3-0.6-0.5-0.8c-3.1-3.4-7.7-4.9-7.7-11c0-10.8,9.8-22.2,17-24.6c2.5-0.8,3.3-4.6,6.8-4.6c1.7,0,2.3-3.4,3.1-3.9 c4.7-2.7,8.2-1.4,13.2-4.2c3.5-2,14.4-3.1,14.4-8.8c0-1.9-4-4.2-5.7-4.2c-7.1,0-13.7,9.7-21.2,9.7c-1.7,0-2.5-2-4.2-2 c-2.7,0-2.7,2-4.5,2c-5.2,0-9.2,8.1-12.7,8.1c-2.1,0-3.5,1.2-5.7,1.2c-1,0-1.4,1-1.4,1.7c0,1,1,1.7,1,3c0,4.8-7.4,7.3-7.4,10.2 c0,1.4,2,1.7,2.1,3.7c-2.3,0.7-6.8,1.9-6.8,4.8v2.5c0,3.1-4.2,2.7-4.2,6.8C794.7,92.5,797.2,93.8,797.2,93.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M818.6,99.9c0,0.1,0.1,0.1,0.1,0.2c0.1,0.2,0.3,0.3,0.5,0.5L818.6,99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1288.2,104.5c-2.2-0.3-4.5-0.5-6.8-0.5c-4.5,0-7.7,1.1-7.1,3.4c4.4,16.5-6.5-0.2-9.2,0 l-32.5-0.8c-1.8-8.8-6.7-11.9-16.3-11.9c-5.2,0-13.2,2.4-16.3-0.8c-2.8-2.9-3-7-7.1-8.5c-8.6-3.4-17.9-5.9-29-5.9 c-11,0-12.6,6.9-13.4,13.6h-22.6c-4,0-4.5-3.9-9.2-4.2c-0.4,2.4-1.3,7.6-3.5,7.6c-5.9,0-8.5-8.8-8.5-13.6 c0-1.2,11.4-9.8-17.7-12.7c-3.7-0.4-5.7,1.5-5.7,6.8h-15.6c-4.7-1.5-29.2-4.9-32.3-11c-18.6,18.2-14.4,6.8-14.4,6.8 c4.4-6.6,47.1-20.4,12-30.5h-14.9c-1.4-4.7-4.5-9.3-10.6-9.3c-7.4,0-10.3,6.6-14.2,10.2c-2.8,2.5-21.1,11.4-19.5,3.4 c-4.7,1.7-24.6,3.3-34.9,14.4c-2.2,2.3-2.8,9.3-6.1,9.3c-4.7,0-22.2-2-22.2,7.6c0,2,1.6,4.1,2.1,6.8c-3.1,2.4-4.2,0-14.1,0 c-8.4,13.5-7.6-2-9.6-5.1c-0.7,5.4-3.7,7.8-7.4,10.2c1.1,4.8,7.2,9.7,2.8,15.3c-3,3.8,5.8,16.5,1.2,16.5 c-5.9,0-7.5-25.6-7.5-30.9c0-5.8,7.9-8.1-4.2-11c-6.1-1.5-17.7,10.5-17.7,16.9c0,7.8,3,12.9,6.4,17c7.9,14.8-10.9-1.7-17.9-3.9 c-19.4-6-13.1,1.9-13.2,3c-0.6,13.1-5.2,2.5-7.8,2.5c-4.4,0-13.4,7.1-19.8,3.4c-3.2-10-24.5,12.7-29.7,12.7 c-1.7,0-4.2-1.5-3.5-3.4c2.2-6.8-1-21.7-7.1,0.8c-0.4,1.5,2.1,2,2.1,5.1c0,5.9-7.4,1.9-11.3,3.4c-4,1.5-2,17.7-18.4,9.3v6.8 c-8.1-0.9-7.1-11.2-9.9-16.1c6.1,0,9.4-0.2,15.3,1.6c7.9,2.5,23.7-9.3-0.4-18.6c-6.9-2.7-22.2-11.9-26.9-11.9 c-0.4,0-0.6-0.7-3.8-0.2c-0.4,0-3.4-0.5-4.7-0.7c0-1-1-1.2-2.4-2.5c3.3-1.4,4.4,0,5.7-4.1c-1.1-0.7-4.2-2.7-4.9-2.7 c-1.1,0-1.7,1.2-2.1,2.5c-1.6-0.2-1.3-1.7-1.4-3.9c-2.3,1.7-3.4,2.4-5.4,4.7c-0.1-1-0.1-1.9-0.7-3.1c-2.4,1.5-3.3,5.4-6.1,5.1 c0.6-2.4,3-3.1,3-5.4c0-2.2-5.4,2-7.5,2c-1.3,0-2.1-1.4-3-2.5c-0.4,1-3,1.7-3,2.5c0,1.2,1,1.5,2.1,2c-2.6,1.7-5,0.7-6.8,4.8 V104c-3,0.2-3.4,4.1-5.2,4.6v-2c-2.1,0.5-4.7,0.3-6.1,2c0.6,0.7,0.4,0.5,1.1,1.4c-1,0.7-1.8,0.3-2.8,0.3 c-1.4,0-2.5,1.4-3.2,2.7c1.3-0.2,1.3,0,2.3,0.3c-0.3,0.2-1.9,4.2-2.6,4.2c-1.8,0-2.4-1.7-4.7-1.7c0.4-1.2,0.3-2-0.4-3 c-0.4,0.5-0.8,1.2-1.3,2.2c-0.4,0-0.7-0.5-1.1-0.5c-1.1,0-1.8,1-2.1,2.7c0,0,1.4,0.5,2.1,0.5c-0.6,0.3-2.1,1.2-2.8,2.4 c3.4,0,4.8-2.2,8.4-3.1c-0.7,3.6-4.7,9.3-7.6,10.7c-3,1.4-4.9,3.7-6.7,7.1c0,0.2-1.4,3.9-1.4,3.9c-1.1,0-0.9,5.3-2.5,6.8 c-4.2,4.1-6.6,10-12.9,11.9c1.3,0.3,1.8,0.7,3.4,1.2c-5.1-0.7-5.6,3.4-8.2,4.2c-3.1,1-4.7,3.1-6.4,5.9 c-0.8,1.5-3.1,1.4-3.1,3.9c0,4.7,0.3,9,2.4,12c-0.7,1.2-2.3,3.2-2.3,4.4c1.7-0.8,1.7-0.8,3.7-0.8v2.5c-0.6,0.3-2.4,1.2-2.4,2.6 c0,0.7,5.5,4.7,6.4,4.7c5.9,0,10.5-6.4,13.4-11.5c0.9,1.6,1.3,3,2.8,4c-0.3,0.6-0.7,1.6-0.7,2.4c0,3,2.1,3.7,2.8,6.3 c1,3.7,0.7,6.1,3.1,9c0,0.5-0.3,1.2-0.3,1.7c0,0.8,2,7.9,3.1,7.9c3.5,0,4.4-5.4,6.8-5.4h3.8c0.4-3.2,3.8-3.5,4.3-8.1 c-0.9-0.2-2.1-0.9-2.1-2.9c0-3.6,1.1-8.5,4-8.5c1.4,0,5.7-4.2,5.7-6.8c0-3.2-3.8-6.3-6.4-6.8c0-1.2-0.4-2.4-1.1-3V173 c2.1-1.2,0.7-4.4,1.8-6.8c1.4-3,4-3.7,6.4-5.4c3-2,9.5-5.4,9.5-9.3c0.4-1,0-1.9,0-3.9c0-4.7,3.8-6.8,8.5-6.8 c3.6,0,8.2,0.8,8.2,5.1c0,2.9-3.4,3.7-5.4,5.1c-3.7,2.5-6.8,11.9-12.7,11.9c0.3,1.2,0,2.2,0,3.4c0,1.9,1.3,5.8,2.7,6.4 c-0.4,0.8-2,2-2,3.7c0,3.6,3.1,5.9,6.1,5.9c0,1.9,1.3,2.2,3.1,2.2c2.4,0,5.7-1.5,8.5-2.5c2.7,0.5,9.2,0,10.6-3.4 c1.1,1.9,2.6,2.7,3.5,5.9c-1.7,1.4-5.9,3.7-7.8,3.7c-2.4,0-4-1.2-7.1-1.2c-3.1,0-10.2,3.4-8.1,5.9c7.1,8,3.4,11.1,1.7,11.1 c-2.8,0-3.2-4.2-5.7-4.2c-2.5,0-5.7,7.8-5.7,11.9c0,6.6-4.5,5.7-4.8,11.6c-1.6,0.2-3.4,0.4-5.1,0.4c0-0.3,0.3-1.2,0.6-1.9 c-1-0.5-3-0.7-4.8-0.7c-1.7,0-4,2.5-5.2,3.2c-2.1,1.2-4,0.7-6.4,2.1c-0.7,0.3-0.9,1.5-2.4,1.5c0,0-2.4-2-2.4-2.4 c0-0.5,0.7-1,0.8-1.9c-3.2-0.5-5.9,3.4-9.8,3.4c-0.4,0-0.7-1.2-1-2c-1.3,0-1.8-0.7-3.4-0.7c0.2-0.5,0-0.8,0-1.9 c-0.8-0.2-1.5-1.3-1.5-3c0-3.1,1.7-4.6,3.1-6.3c0.4-0.5,1.7-0.9,1.7-1.7v-1.4c-1.1,0-2.7-0.2-2.7-1.9c0-1.7,0.1-2.7,0.9-4.4v-2 c-3.5,3.1-9.1,3.6-9.1,10.7c0,4.1,2.3,5.4,2.8,10c0,0.2,1,3.4,1,4.3c0,1.3-2.3,2.9-3.1,2.9c-1.3,0-2.5-1-3.5,0.2 c-0.3,0.3-0.7,1.7-1.1,1.2c-1,0.5-0.1,0-2,0c-3.2,0-5.2,2.7-7.2,5.1c-0.2,0.2-1.4,1.2-1.4,1.9c0,2,0.4,4.1-0.7,5.4 c-0.6,0.7-6.2,3.4-7.1,3.7c-0.7,0.2-1.1,0.3-2,0.3c-0.9,4.1-2,7.8-6.2,7.8c-0.3,1.4-1.3,2.5-2.4,2.5c-1.7,0-3.1-0.8-4.2-2.2 h-1.4v1.4c0.2,0.5-0.3,3.1,0.7,3.4v1.2c-0.6,0.2-2.1,0.9-3.2,0.9c-1.1,0-3.4-0.7-3.8-1.7c-1.4,0.5-5.4,1.5-5.4,3.1 c0,0.2,0,0.7,0.1,0.7c0,2.6,6.2,3.9,8.5,4.8c0.7,0.2,0.8,1,1.7,1.2c0,2.7,0.8,5.7,3.7,5.7c0,1.4,0.9,1,0.9,2.6 c0,0.7-0.3,1.9-0.6,2.5l0.3-0.3c0,1,0.1,4,0.1,4.7c0,3.2-1.8,4.2-1.8,7.6c-0.4,0-2.6,0.8-3.5,0.8c-1.4,0-2.3-1.2-4-0.7H569 c-0.7-0.2-1.8-0.3-2.4-1h-6.4c-0.8,0.3-1.6-0.7-2.1-0.7c-0.8,0-5.7,3.6-5.7,4.6c0,1.5,1.5,3.9,1.5,6.5c0,4.4-1.3,8.8-1.3,13 c0,1.2-1.5,1.7-1.5,3.9c0,1.4,1.1,2.4,2.3,2.4v6.8c0,0.5,0.3,1.4,1.1,1.4c2.1,0,3.7-1.2,6.1-1.2c3.3,0,3.4,6.3,5.5,6.3 c3.1,0,5-3.4,8.4-3.4c0.7,0,3.1-0.8,4.4-0.4v-0.2c2.8,1,3.1-3.2,4.8-4.2c3-1.7,3.8-3.7,5.7-7.1c-0.7-0.4-1.4-0.9-1.4-2.2 c0-3.7,4.1-10.7,6.7-11.4c3-0.8,6.1-2,6.9-5.4l-0.8-3.7c0-2.6,2.3-4.3,4.4-4.3c2.8,0,4.8,1.9,7.9,1.9c3.1,0,4.9-3,7.6-4.6 c1.3-0.7,1.4-2.9,4-2.9c5.4,0,6.2,6.9,8.8,10.9c0.3,1.2,2.4,1.9,3.4,3c2.4,2.9,3.4,4.4,7.8,5.6c0,1,2.1,1.7,2.7,1.7 c0.1,1,3.5,5.1,3.9,5.1c0.3,1.5,1.4,2.2,1.4,4.7c0,2-0.7,4.6-2.4,4.6c0,0.7,0.6,1.2,1.6,1.2c2,0,1.7-3.6,3-5.1 c0,0,1.8,0,1.8-0.8c0-2.2-2.5-2.7-2.5-4.9c0-1.7,1.4-2.7,3.1-2.7c2.3,0,3.1,2.2,4.5,2.5c0.4-3.6-3-4.9-5.8-6.6 c-0.9-0.5-4.3-1.4-3.7-3.4c0.3-0.3,0.3-0.8,0.3-1.4c-2.1,0-3.5,0.9-5.7-0.3c-1.1-0.7-2.1-3.4-2.7-5.8c-0.4-1.5-1.6-4.4-3.7-5.3 c-1.7-0.7-3-1.7-3-4.3c0-1,0.3-2,0.6-3c-0.3,0-0.7-0.7-0.7-1c0-1.9,3.1-1.9,4.7-3.1c0.8,1,0,4.6,1.8,4.6h4.2 c0,3.9,3.5,9.7,6.6,9.7h2c0,2.4,2.3,2.5,4.2,3.7c2,1.2,5.1,4.7,5.1,7.1v4.4c0,3.5,2.3,5.1,4,7.1c1.3,1.5,2.4,3.1,3,5.4 c0,0.4,0.3,1.9,0.8,1.9h2.4c-0.4,0.8-1.8,1.4-1.8,2.5c0,2.9,2,5.6,4.2,5.6h2c-1.4-0.8,0-2.9,0-3.9c0-1.4-0.4-1.9-0.8-2.9V323 c0.7,0.8,2.1,2.2,3.7,2.5h0.3c0.3-1.2,1.7-0.5,2.4-1c-0.3-0.3-0.6-1-0.6-1.5c-1.1,0-5-4.2-5-4.7c0-0.5,0.4-1,0.6-2l-2.7-3.7 c0-0.8,0.8-1.9,1.5-1.9c1.3,0,1.6,2.5,3.7,2.5c0.3-1.4,0.3-2.4,0-3.7c1.8-0.7,2.4-2.2,4.7-2.2c2.5,0,3.8,3.4,5.9,3.4 c1.8,0,2.3-2.2,4.1-3.2c1.3-0.7,2.3,0,3.5-0.5c0.7-0.2,1.3,0,1.9-0.7c-0.9-1.5-4.7-3.9-4.7-7.3c0-2.4,2.5-5.8,4-7.5v-4.4 c0.4-1,0.4,0.4,0.9-2.4c0-1.7,1.5-2.5,2.9-2.9c-0.2-0.9,0-1.7-0.2-2.5c3.1-1,3.4-5.4,6.5-5.4c2.5,0,9,12.7,11,12.7 c2,0,8.8-3.6,9.9-5.3c-0.3,0-4-0.7-4-0.7c-0.6,0-2.4-0.5-2.4-2.5c0-1.3,10.3-5.9,14.1-7.6c0,0-1.8,2.5-2.5,2.9 c0.3,1,4,5.6-4.2,8.1c3.5,10,19.8,8.3,19.8,21.7l0.6-0.1c0.1,0,0.1,0,0.2-0.1c-2.5,1.3-4.2,3.9-7.1,3.9h-8.1 c-1.6-0.2-7.1-1.3-7.1-3.4c-3.3,0-3.1-2.6-6.9-2.6c-2.4,0-6.4,0.2-8.2,1.5c-1.6,1.2-4.1,3.4-5.8,3.4h-4.4 c-0.7,0-3.4-0.7-3.4,0.9c0,1.2,0.9,0.7,1.1,2c-2.5,1.5-12.7,0.5-12.7,5.8c0,1,1.4,0.9,2.4,0.9c-0.3,0.9,0,0.9,0,2 c0,3.2-1.6,2.9-3,4.6c2,1.2,3.5,1,4.8,3.2c-1.4,1.7,2.7,4.2,3.5,5.3c-0.1,0.3-0.7,0.9-1.1,1h1.6c2.7-1.5,4.1,3.1,6.8,3.1 c2.5,0,2-3.9,4.9-3.9c3,0,4.1,4.2,7.1,4.2c4.1,0,4.8-2.2,7.1-4.2c0.6,0.7,1.4,1.3,2.8,1.3c1.1,0,1.6-1,2.7-1.5v1.7 c-0.3,0.3-1,0.7-1,1.7c0,2,0.7,4.4,0.7,7.3c0,3.9-2.8,4.7-3.7,8.1c-0.8,3.4-1.3,5.3-2.3,9c-0.1,0.7-1.1,0.7-1.1,1.9l0.8,2.2 c-0.2-0.4-0.3-0.8-0.5-1.2c-1.9,0.5-1.9,1.3-4,1.3c-3.1,0-4.7-2.2-7.4-2.2c-4.4,0-5.8,2.5-10.3,2.5c-5,0-11.3-2.5-15.8-4.6 c-2.3-1-5.5,0.3-6.8-1.7c-0.6-1-2.1-1.5-2.1-3.9h-3.1l-0.4-0.3c-4.4,1.7-7.8,1.7-7.8,7.1v3.4c0,0.8-1.5,2.5-2.8,2.5 c-10.5,0-13.7-13.6-22.9-13.6h-4c-2.7,0-6.4-3.7-6.4-8c0-2.6,1.8-3.9,1.8-6.4c0-1.5-1.8-2.2-1.8-3.7c0-2.2,2-1.9,2.1-4.4 c-0.8,0.2-1.3,1-2.1,1c-2.3,0-1.5-3-4.2-3c-2.7,0-2.8,2.5-5.7,2.5c-1.6,0-2.4-1.2-4.2-1.2c-2.1,0-4.4,2.5-6,2.5 c-1.1,0-3-1.7-4.9-1.7c-6.4,0-16.8,4.7-22.3,8c-1.7,1-2.3,3-5.2,3c-4.8,0-8.5-1.2-12-4.2c-1.4,1.4-1.7,2.9-2.8,4.6h0.3 c-3.5,5.2-8.4,10.5-12,16.1c-2.8,4.2-0.7,7-2.4,13.2c-0.7,2.7-4.2,6.1-6.4,7.6c-2.5,1.7-6.2,1.4-8.2,4.6 c-3.4,5.6-7.6,14.6-9.5,21.2c-0.7,2.7-4,4.8-4,8.2c0,6.8,2.8,11.5,2.8,19c0,4.2-2.8,13.4-5.9,15.3c1,2.4,2.1,3.2,2.1,5.6 c0,1.5,0.7,2.9,0.7,5.4h-0.4c0.7,1,1.1,1.3,1.8,2.4c0,0.7,7.5,8.6,8.5,9.5c3.5,3.4,4.4,7.5,7.1,12.4c3,5.4,11.2,11.2,15.1,14.8 c0.6,0.5,2.5,1.3,4.2,1.3c5.5,0,7.9-3.4,13.4-3.4c2.8,0,6.4,2.6,8.5,2.6c2.1,0,2.8-2.2,4.9-3.1c5.4-2,10.6-5.9,17.7-5.9 c5.8,0,6.8,9.8,11,9.8h5.9c4.8,0,7.4,3.4,8.9,7.1c-1.4,1.4-1.4,6.4-1.4,8.5c0,0.7-0.6,1,0,2.5c-1,0.7-3.2,4.9-3.2,6.8 c0,8,8.1,13.9,11.7,19.5c1.8,2.9,1.3,6.8,2.4,10.2c1.4,4.2,2.5,6.8,3.5,14.1c0.4,3.7,1.8,5.4,1.8,9.7c0,9-8.9,11.9-8.9,23.7 c0,11,4.2,17.5,8.2,25.4c1.1,2.4,2.8,3.2,2.8,5.6v4.6c0,14.9,6.5,24.9,11.6,35.3c0.7,1.5,4.7,6.6,4.7,9.3 c0,1.9-0.7,3.2-1.8,4.6c1.1,1.4,2.5,5.1,2.5,8.5c0.3-0.2,0.6-0.7,1.4-0.9c0.9,1.9,2.1,3.4,4.5,3.4c5.4,0,8.9-5.1,14.8-5.1 c1.6,0,2.4,1.7,4,1.7c1.3,0,2.4-1,4.2-1.2c0.4-3.1,4-1.7,6.4-3.1c5.8-3.4,7.4-8.1,10.9-13.6c2.2-3.4,2.5-7.3,5.7-11 c1.7-2.1,5.6-5.8,5.6-10.5c0-1.5-0.9-2.7-2.1-3.6c1.7-4.3,3.7-5.9,7.1-8c1-0.5,3.4,0.2,4.2-1.2c0.9-1.5,1.1-7.1,1.1-9.8 c0-5.1-4-7.6-4-11.4c0-1.9,2.3-4.7,4.2-5.1c1.6-11.2,20.2-9.7,20.2-22.9c0-1.4-0.3-2.4-1.1-3.4c0-4.8,0.4-8,0.4-10.7v-4.2 c0.1-0.3,1-1.5,1-2.6c0-3.2-5.2-6.1-5.2-11.9c0-5.1-1.1-7.5-1.1-12.7c0-4.8,3.7-6,4.7-10.2c3.5-15.1,13.6-17.8,22.9-26.6 c5.2-4.9,7.1-11,11.3-17.8c3.5-5.8,9.9-18.3,9.9-28c0-1-0.6-1.5-1-2.5c-5.1,1.5-10.2,4.1-15.6,5.1c-2.1,0.3-3.5-0.9-5.7,0 c-1.8,0.7-2,2.9-4.3,2.9c-2.4,0-4.2-5.4-6.1-7.1c1.4-2,0.1-2.4,0.1-5.3c-4.6,0-5.9-7-8.1-9.1c-2.6-2.2-4.1-2.4-6.4-5.1 c-2.5-3-1-7.5-3.5-11.5c-2.1-3.4-5-3.4-6.4-8v-9c-2.1-2-6.4-9.5-5.6-13L718,371.3v-2.9c2.4,2.9,4.8,10.5,7.8,11 c0.4-1.7,2-6,2.6-8.4c-0.3,2.1-0.7,4.2-0.7,5.4c0,0.5,2,3.2,2.4,4.1c1.5,2.9,3,5.4,4.7,8.5c0.6,1,1.6,2.4,2,4.1 c0.3,1,0,3.6,0.9,4.6c0.4,0.5,2.3,0.2,2.8,0.8c0.4,0.5,1.1,1.5,1.8,2.2c0.6,3.2,2.4,4.1,2.4,8c0,6.4,1.2,9.9,6.1,11.3 c0,4.1,3.9,9.9,5.6,12c1.6,1.9,3.9,3.4,3.2,7.1c-0.3,1.5-1.4,4.7,0.2,4.9c0,3.2,1,6,2.5,8.7c0.9,1.7-0.2,1.7,0.2,1.9 c0.4,0.2,4,2.3,4.4,2.3l0.9-0.6c3,0,3.3-1.4,5.8-3.4h4.4c1.8-1,7.5-5.8,9.2-6.3c3.4-1,7.8-2.2,11-4.1c-0.3-0.3-0.5-1-0.5-1.5 c0-3.7,8.6-5.6,12.4-6.5c0-2,2.7-4.9,4-4.9c2.1,0,2-4.9,4.1-4.9c1.7,0,1.5-2.9,2.1-4.9c0.6-2,2-2.7,4.1-2.7 c0-4.1,4.1-5.4,4.1-9.3c0-1.5-2-1.2-2.7-2.7v0.2c-1-0.7-1.1-3.6-2.7-4.1c-4.1-1.5-6.8-2.4-8.8-7.3v-6.3 c-5.1,4.6-5.8,11.5-15.3,11.5c-2.1,0-5.8-1.2-5.8-3.6c0-2,1-3.4,1-5.4c0-0.7,0-1.2-0.1-1.9c-1.4,0.3-1.1,2.5-2.8,3 c-0.1-1.5-1-2-1-3.9c-3.3-0.9-7.2-8.1-8.1-12.2c-0.3-1.4-0.3-2.2-0.3-3.9c0-2.4,0.9-5.4,2.8-5.4c4,0,7.1,5.3,8.6,9 c0.3,0.7-0.1,2,0.7,3.1c1.6,1.9,3.8,0.8,5.5,2.9c1.4,1.7,2.6,3.9,4.8,4.8h7.1c0.8-1,1.4-2.6,3-2.6c3,0,3,5.1,4.4,6.8 c0.2,0.2,4.3,1.5,5,1.5c3.8,0,10,2,12.7,2c0.1,0,0.7,0.2,0.7,0l5-0.3c0.3-0.3,0.7-0.8,1.3-1.2l3.7,1.2c1.4,0,1.9-1.3,3.5-1.3 c1.6,0,2.7-0.4,4.2,0.2c1.7,0.7,2.5,4.6,3.7,6.8c1.4,2.5,5.5,5.9,8.3,5.9c1.1,0,2.1,0,3.3,0.4c-0.6,0.7-0.7,2.2-1.8,2.5 c-1.3,0.5-2.3-0.3-3.5,0.7c2.1,2.5,3.8,7.8,8.2,7.8c3.7,0,3.8-5.8,5.7-8h1.1c0,0.7-0.8,1.9-0.8,2.4c0,2.2,1.4,4.2,1.4,7 c0,2.1-0.6,2.6-0.7,4.8l-0.1-0.1c0,0.5,0.2,1.9,0.2,2.4c0,3.2,1.6,6.5,2.4,9.8c1,3.8,3.6,9.3,4.2,11.9c0.6,2.2,0.6,3.2,1.7,5.4 c1.1,2,0.4,4.2,1.6,6.9c0.6,1.4,2.5,3.1,3.1,5.4c1,3.6,2.5,6.9,3.7,11c0.1,0.5,0.6,1.7,1.3,1.7c0.2,1.2,1,1.9,2.1,1.7 c1.1,0,1.3-2,1.8-3.4c0.7-1.7,1-1,2.7-2c1.1-0.7,0.7-5.1,2.7-5.8c0.4-0.2,1.4-0.2,1.4-0.7l0.7-0.2l-0.7-4.4 c0-3.2,1.7-5.9,1.7-10.2c0-2.7-1-4.4-1-7.5c0-3.6,3-4.1,5.5-5.1c1-0.3,2.6-2.4,3.7-3.7c2.7-3.2,5.2-6.6,8.1-10 c2.3-2.7,6.4-3.5,8.9-6.6c1.3-1.5,1.1-3.4,1.7-5.8c0.4-1.5,3.4-1.7,4.4-4.2c1.1,0.9,1.1,1.7,3.4,1.7c3.7,0,7.6-1,7.6-6.1 c2.1,0.5,4.5,1.5,5.1,3.9c0.6,2,0.3,4.7,1.4,6.8c1.1,2.2,2.7,3.5,4.7,5.4c1.4,2.7,3.1,5.4,4.1,9c0.1,0.8,0.9,1.4,0.9,2.2 c0,1.9-0.7,2.9-0.7,5.1c0,2.2,0.1,4.2,2.3,4.2c4,0,5-4.9,7.4-7.8c0.9,1,0.4,1.7,1.3,2.7c0.3,0.3,1.4,0,1.8,0.8 c1.4,2.5-1,7.6,0.8,7.6c0,5.4,3.7,9.8,3.7,17.3c0,1.9-1.1,5.7,0,6.4h-0.7c-0.4,2.4-0.7,4.1-0.7,6.4c0,0.4-0.3,1,0,1 c1.3,1,0.4,0,1.8,0c2.3,0,3.3,6.1,4.2,8.5c1.6,3.9,1.8,7.5,3.1,12.4c1.6,5.6,5.5,10.7,9.9,12.4c0.8,0.3,1,1.5,2.4,1.5 c0.4,0,0.6-0.7,1-0.7c0.6,0,0.7,0,1.8-0.2c-0.7-1.9-0.7-2.7-1.3-4.9c-0.6-2-2.7-3.1-2.7-6.1c0-1.5,0.6-1.5,0.6-3.2 c0-8.5-8.3-9.5-12.2-14.1c-1-1.2-1.1-4.2-1.7-5.4h0.3c0-4.9-4.8-2.9-4.8-8.1c0-4.6,4.1-5.9,4.1-11c0-1.4-0.6-1.7-0.6-3.2 c0-0.8-0.3-1.8,0.9-1.8c1.6,0,3.2,0.3,3.7,2.2c0,0,0.4,2.2,0.7,2.2c2.3,0.9,4.2,1,6.2,3.4c1.7,2.1,0.1,4.6,3.3,4.6 c0,2.6,2.8,3.4,4.9,3.4c0.1,0.9,0.4,2.2,1,2.6c-0.6,0.3-0.6,1-0.6,2.4c0,1,0.6,3.4,1.1,3.4c0.6,0,3.4-2.5,3.4-4.2v-1.9 c0,0.5,0,1.5,0.4,1.5c1.7,0,1.4-2.7,3.1-3.8c3.7-2.2,4.1-4,8.6-5.4c0-3,1.7-4.6,1.7-8.5c0-5.6-2.3-13-5.7-15.8 c-3.5-2.7-5-7.1-8.2-11c-0.6-0.7-1.3-1-1.3-2.5c0-7.3,6.9-8.5,9.8-13.7c2.4,1.4,4.1,0.3,6.8,1.9c-0.1,0.9-0.6,4.2,0.7,4.2 c1.6,0,0.7-2.2,1.8-3.6c1-1.2,3.8-1.7,4.9-2.4c2.7-1.5,5.4-0.9,7.1-2.9c0,0,1.4-3.2,1.7-3.2c1.4,0,2.1,1.4,3.5,1.4 c6.5,0,8.1-4.7,12-7.5c1.1-0.7,1.8-1.3,2.1-3c3.4,0,4.4-6.3,5.7-9.5c0.9-2,4.7-8.8,6.8-9.3c0-3.7,2.1-5.4,2.1-10.3 c0-7.3-1.4-10-3.9-14.6c-0.4-0.8-0.4-2.9-1.7-3.7l0.2-0.2h-0.3c0,0-0.1-2.7-0.1-3.2c-1.1-0.2-3.8-1.9-3.8-4.2 c0-2,2.4-2.2,3-4.2c1.3-4.6,7.3-4.6,10.2-8c-1.1-1.9-3.3,0-5.2-1.5c-1-0.7-1.5-2-3.1-2c-1.1,0-1.1,3.7-2,3.7 c-1.1,0-2.5,0.5-3.7-0.4c-1.7-1.4-1.1-3-2.8-4.6c-0.6-0.5-3-1.2-3-2.9c0-3.6,4.1-2.4,6.1-4.1c1.7-1.5,5-4.1,6.1-6.3 c0.3-0.5,0.9-2.2,2.3-2.2c1.1,0,2.7,2.2,2.7,3.2c0,2.7-2.7,3.9-2.7,7c3.9,0,7.2-5.1,11.7-5.1c1.7,0,2.4,1.9,4.5,1.9 c-0.7,1.7,0,1.7,0,3.7c0,1.7-1.6,1.5-1.6,3.6c0,0.9,0.4,2.9,1.4,2.9c0.4,0,1-0.8,2-0.8c1.7,0,3.8,1.3,3.8,3.4 c0,1.2-1.1,2.2-2.3,2.2v1.7c0.3,0.3,0.6,1,1.4,1.2c0,1,0.7,1.9,0.7,2.9c0,0.5-1.3,2.7-1.3,3.9c0,0.7,0,1.5,0.7,1.7 c-0.1,0.9-0.9,1.4-0.9,2.2h2.1c0.9-1,1.1-1,2.8-1.5c0-1.5,3.5-1.7,4.4-2c2-0.7,2.8-2.5,2.8-6.4c0-6.6-2.1-10.5-5.2-14.2 c-1.3-1.5-2.7-3-2.4-5.9c1.7,0,3.1-1.2,4.2-2.5c1-1.2,3.5-2.9,4.1-4.2c1.8-4.6,3-7.3,6.4-10.5l0,0c0,0,5.5,1.7,9.9,1.7 c8.1,0,15.7-20.4,21.3-27.2c2.3-2.7,5.4-8.2,6.3-12.6c1-4.9-0.7-8.1,1.5-12.8c0.8-1.8,2.5-5.6,2.5-9.3c0-4.6-6.1-13.5-9-11 c-8.4,7.6-12.7-4.1-12.7-5.1c0-4.8,7.6-10,10.6-13.6c4.4-5.3,10.2-14.1,16.3-16.1c5.4-1.7,22.2-3.4,26.9-3.4 c5.8,0,8.5,3.4,12,3.4h7.8c2.3-11.2,6.5-17.8,16.3-17.8c2.5,0,3.7-0.9,8.5,0c-2.4,2.2-3.4,16.9,12-5.9c1.6-0.4,9,3.3-2.1,11.9 c-3.9,3-7.3,1.5-9.9,5.9c-3,5.1-5.7,11.5-9.9,14.4c-3.5,2.4-8.5,6.3-8.5,13.6c0,6.3,1.7,26.8,5.7,30.5 c2.8-5.1,4.8-14.4,10.6-16.1c-0.7-4.7,5.7-5.8,5.7-9.3c0-5.6,4.9-7.1,4.9-10.2c0-2-1.4-4.1,0-7.6 c11.4-29.3,21.9-13.6,26.2-13.6c7.4,0,13.5-6.6,19.6-12.2V104.5z M679.4,260.8C679.4,260.8,679.4,260.8,679.4,260.8 c0,3.2,1.3,3.8,3.1,3.8C680.7,264.6,679.4,264,679.4,260.8z M681.9,250.6c0.9-0.8,2.9-1.6,2.9-3.3c0-2.8-2.1-4.9-2.6-7.7 c0.5,2.9,2.6,4.9,2.6,7.7C684.9,249,682.8,249.8,681.9,250.6z M705.5,130.6c0-2.9,2.6-4.2,2.6-7.1c0-3.7-5-3.6-5-6.8 c0,3.2,5,3.1,5,6.8C708.1,126.4,705.6,127.7,705.5,130.6c0,3.2,2.8,5.1,2.8,8.5C708.4,135.7,705.5,133.8,705.5,130.6z M793,290 c2.7,5.6,6.5,7.8,6.5,14.4c1.1-0.7,3.8-2.4,4.8-2.6c0.2,2.6,2.4,3.9,2.4,6.5h-4.2c-1.3,0-2.6,1.7-2.8,4.2c3,0.5,5,3.9,5,7.1 c0,1.9-1,2.4-1,3.9c0,1.5,1.3,3.4,1.4,3.6v3c-1.7,0.5-4.2,1-6.6,1c-1.8,0-5.4,0.3-6.5-1c-0.8-1-1.1-2.7-2.4-3 c-1.6-0.3-3.4,0.7-4.1-1.2c-0.8-2,0.4-3.4-0.7-5.4c-0.7-1.4-1.8-1.2-1.8-2.9c0-0.3-0.1-0.7,0-1c-0.6-0.7-0.6-2-1-3.1 c-1,0.2-0.8,0-2,0.5c-2.1,0.8-2,3.9-5.1,3.9h0c3.1,0,3-3,5.1-3.9c1.1-0.5,1-0.3,2-0.5c0.4,1,0.4,2.4,1,3.1c-0.1,0.3,0,0.7,0,1 l2,0.3c1.7-2.7,1.7-6.8,3.9-8.1c-3.8-2.5-9.6-12.7-9.6-18.5c0-1.7-3.1-4.2-3.1-6.8c0-0.8,2.7-7.1,3.4-8.1 c0.7,0.5,4.9-2.4,5.4-2.5c3.7-1.7,5.9-2.9,10.6-2.9c7.6,0,8.9,4.4,11.7,9.5c-2.1,2-4.9,0.2-7.5,0.2c-3.8,0-9.5,4.4-9.9,4.2 C789.9,288.3,792.1,288.1,793,290z M814.1,322.1c1-0.2,1.9-0.5,2.9-1.4C816,321.7,815.1,321.9,814.1,322.1z M836.1,336.9 c-0.4,0-0.4,0.8-0.7,1c-0.7,0.5-2.2,4.1-2.9,6c0.7-1.9,2.1-5.5,2.9-6c-0.5-0.9-0.4-2.1-0.4-3.5c0,1,0.1,2,0.4,3.1 c1.6-2.1,2.8,0.8,4.2,0.8C838.2,338.3,837.6,336.9,836.1,336.9z M850.3,327c0.7-0.9,1.5-1.4,2.8-1.4c0,0,0,0,0,0 C851.8,325.6,851,326.2,850.3,327z M862.6,328.8c-1.1,0-1.6-1.8-2.7-1.8c-0.8,0-4.2,1.3-4.5-0.7c0.3,2,3.7,0.7,4.5,0.7 C861,326.9,861.5,328.8,862.6,328.8L862.6,328.8z M869.5,324.6c-0.1,0-0.3,0-0.4,0.1C869.2,324.6,869.4,324.6,869.5,324.6 c0.5,0,0.9-0.7,1.5-1.5C870.5,323.8,870.1,324.6,869.5,324.6z M877.3,329.3c-0.8,0-1.2-0.5-1.4-1.4 C876.1,328.8,876.5,329.3,877.3,329.3C877.3,329.3,877.3,329.3,877.3,329.3z M881.4,327.6c0.9-0.6,1.9-1.2,3.1-1.2c0,0,0,0,0,0 C883.2,326.4,882.3,327,881.4,327.6z M892.7,329.8c-2.1-0.8-3.4,0-3.4-2.9c-1.7-0.5-2.9-0.5-4.5-0.5c1.7,0,2.8,0,4.5,0.5 l0.1-0.8l-0.1,0.8C889.3,329.8,890.6,329,892.7,329.8c0.5,0.2,0.7,0.5,0.9,0.9C893.5,330.3,893.2,330,892.7,329.8z  M907.9,361.2c-0.6-0.2-2,0-2.3-1C905.9,361.2,907.3,361,907.9,361.2c0.4,0.2,0.8,0.4,1.1,0.6 C908.6,361.6,908.3,361.3,907.9,361.2z M906.6,334.1c1.3,0,4.5,3,4.5,4.7C911.1,337.1,907.9,334.1,906.6,334.1z M912.1,282 c0,19-8.9,27.1-21.9,27.1c-2.3,0-5.2,7.6-5.7,11c0.4,0.1,0.7,0.2,1,0.3c-0.3-0.1-0.7-0.2-1.1-0.3c0.4-3.4,3.4-11,5.7-11 C903.2,309.1,912.1,301,912.1,282c2.2-0.4,3.7-1.6,4.9-3C915.8,280.5,914.3,281.6,912.1,282z M941.8,377.3h-5.9 c-3.3,0-4.5-2.5-6.7-4.2c2.1,1.7,3.4,4.2,6.7,4.2L941.8,377.3c1.3,0,1.7-0.9,2.6-0.9C943.5,376.4,943.1,377.3,941.8,377.3z  M954.6,249.8c-6.9,4.9-15.5,5.1-21.2,11c-2.3,2.4,2.2,11.8-9.2,10.2c-1.8-0.3-2.9,1.3-4.1,3.4c1.2-2,2.3-3.6,4.1-3.4 c11.4,1.6,6.9-7.8,9.2-10.2C939,254.9,947.6,254.7,954.6,249.8c0.2-0.2,0.5-0.5,0.9-0.9C955.1,249.3,954.8,249.6,954.6,249.8z  M989.5,238.3c-1.3-0.2-2.4-0.3-3.1-0.3C987.1,237.9,988.2,238,989.5,238.3z M975.8,250.6c-5.9,0-11.9-5.1-15.6-5.1 c-1.4,0-2.8,1.3-4,2.5c1.1-1.2,2.6-2.5,4-2.5C963.9,245.6,969.8,250.6,975.8,250.6c4.3,0,5.7-3.9,6.9-7.3 C981.5,246.8,980.1,250.6,975.8,250.6z M985.8,383.2c0,6.8-3.7,7-3.7,13.2C982.1,390.1,985.8,390,985.8,383.2z M981.3,426.8 c0-2.1,0.4-3.9,1.1-5.3C981.7,422.9,981.3,424.7,981.3,426.8z M981.6,428.6c0.6,1.4,1.8,1.6,2.4,2.8c1,1.9,1.1,5.4,1.1,7.5 c0,1.4-1.1,3.2-1.4,3.6v0c0.3-0.3,1.4-2.2,1.4-3.5c0-2-0.1-5.6-1.1-7.4C983.3,430.2,982.1,429.9,981.6,428.6z M983.6,443.7 c0,1.9,1.6,2.7,2.5,3.9C985.1,446.4,983.6,445.6,983.6,443.7z M983.7,442.2L983.7,442.2c0,0.3,0,0.5-0.1,0.6 C983.7,442.6,983.7,442.4,983.7,442.2z M986.1,465.2c0.5-1.6,1-3.1,1.8-5.2C987.1,462.1,986.7,463.6,986.1,465.2z M988.7,459 c0.2-0.3,0.4-0.5,0.4-0.9c0-0.6-0.3-2.2-0.8-4c0.5,1.8,0.8,3.5,0.8,4C989.1,458.5,988.9,458.8,988.7,459z M994.2,411.2 c0.4-0.6,0.8-1.3,1.2-2c-0.8,0-1.3,0.3-2.3,0.3c-2.1,0-3.6-2.1-4.2-4.6c0.6,2.5,2.1,4.5,4.2,4.5c1,0,1.4-0.3,2.2-0.3h0 C995,409.9,994.6,410.6,994.2,411.2z M996.3,409.2c0,0.7,0.2,1.2,0.4,1.5C996.5,410.4,996.3,409.9,996.3,409.2z M1017.9,403.6 c-1.8,0-3.1-1.1-4.5-1.6C1014.9,402.5,1016.1,403.6,1017.9,403.6c0,1.5,0.3,2.5,0.8,3.4C1018.3,406.1,1017.9,405,1017.9,403.6z  M1031.7,255.7c-9.2,0-11.7-8.5-20.5-8.5C1019.9,247.2,1022.5,255.7,1031.7,255.7c5.8,0,13.1-5,20.7-5.6 C1044.8,250.7,1037.5,255.7,1031.7,255.7z M1072.2,239.1c2.2-5.1,5.4-9.6,12.5-9.6C1077.6,229.5,1074.4,234,1072.2,239.1z  M1092.8,232.1c4.7,4.1,5.5,12,8.9,18.5c0.1,0.2,0.2,0.4,0.4,0.6c-0.1-0.2-0.3-0.4-0.4-0.6 C1098.3,244.1,1097.5,236.2,1092.8,232.1z M1102.1,251.3c0.1,0.1,0.2,0.3,0.3,0.4C1102.3,251.5,1102.2,251.4,1102.1,251.3z  M1102.6,251.8c0.2,0.2,0.4,0.3,0.6,0.5C1102.9,252.2,1102.8,252,1102.6,251.8z M1112.3,257.4c-2-2.4-6.5-3-9.2-5.1 C1105.8,254.4,1110.4,255.1,1112.3,257.4c0.5,0.6,1,1.6,1.6,2.6C1113.3,259,1112.8,258,1112.3,257.4z M1116.6,284.5 c-0.2-0.2-0.4-0.4-0.4-0.5C1116.2,284.2,1116.3,284.3,1116.6,284.5c1.5,1.2,2,2.7,1.9,4.2 C1118.5,287.2,1118,285.7,1116.6,284.5z M1131.4,260.8c-3.3,0-5,1.6-6.7,3.1C1126.4,262.5,1128.1,260.8,1131.4,260.8 L1131.4,260.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M684.2,232.7L684.2,232.7c0-0.5-0.1-1.1-0.1-1.7C684.1,231.6,684.2,232.1,684.2,232.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M728.6,369.2c0-0.1,0-0.3-0.1-0.4l0.1,0.2C728.6,369.1,728.6,369.1,728.6,369.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M809.6,323.8c0.2-0.3,0.5-0.5,1-0.8c0,0,0,0,0,0C810.1,323.3,809.9,323.6,809.6,323.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M832.2,346.8C832.2,346.7,832.2,346.7,832.2,346.8c0.1-0.1,0.1-0.2,0.2-0.3 C832.3,346.6,832.3,346.7,832.2,346.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M836.8,361c0,0.5-0.1,0.9-0.2,1.3C836.8,361.9,836.8,361.5,836.8,361 C836.8,361,836.8,361,836.8,361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M985.1,468L985.1,468c0.2-0.6,0.4-1.1,0.6-1.6C985.5,466.9,985.3,467.4,985.1,468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1268.6,107.7c0.7,0,1.4-0.8,1.4-1.7c0-1-0.9-1.4-1-2h-4.7 C1265.2,106,1266.7,107.7,1268.6,107.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1134,54c1,0,1.2-1.2,1.4-2.2l0,0l0-0.1c0-0.1,0-0.2,0-0.3h-0.3l-1.1-1.4 c-0.6,0.8-1.1,1.5-1.1,2.6C1132.8,53.7,1133.3,54,1134,54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1040.9,62.5c-1.4,0-3.1,0.8-3.1,2.5c0,1.5,1.6,2,3.1,2c1.1,0,2.1-0.5,3-1 c0.2-0.3,0.3-0.6,0.3-1C1044.1,63,1042.8,62.5,1040.9,62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1044.1,65.9c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0.4-0.6,0.7-0.8,1L1044.1,65.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M987.8,27.2c0,1.7,0.4,2.5,2.1,2.5l7.5-2.5c0,0,4.4-0.9,4.9-0.9c2.6,0.5,9.9-0.2,9.9-4.2 c0-2.4-5.8-6.8-7.8-6.8c-1,0-1.6,1.4-2.6,1.7c1.2-1.4,0.4-1.4,0.4-3.7h-1.8c-5.7,0-6.9,6.3-10.2,10.2 C989.5,24.5,987.8,24.5,987.8,27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M953.6,6.9c0,1.5,2,4.2,2.8,4.2c1.7,0,6.4-0.3,6.6-3.4c-1-0.3-4.9-2.5-5.7-2.5 C956.5,5.2,953.6,5.2,953.6,6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M972.9,6.3c-4.5,1.7-5.9,3.6-10.6,5.4c2.1,1.4,5.8,6.1,7.5,6.1c5.1,0,9.6,3.1,15.8,3.1 c1.3,0,2.8-1,2.8-2.5c0-1.2-1.1-1.7-2.1-2.1c0.8-0.3,2.8-0.5,2.8-2.2c0-1.7-0.3-2,1.1-3.4c-1.8-2.2-1.8-3.4-4.7-3.4h-2.8 c-1.7,0-2.5-1.7-4.3-1.7c-1.1,0-1.5-0.5-3,0c1.1-0.7,2.7-2.1,2.7-3.1c0-0.9,0.1-1.4,0-3.4c0.6,0.2,0.3,0.5,1.7-0.2 c-2.3-2-4.5-6.6-8.5-6.6c-6.8,0-8.9,8-14.9,10C960.4,4.7,963,6,967,6C967.9,6,971.5,6.3,972.9,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M972.7,40.8c1.7,0,2.5-1,2.8-3.4h-2.1c-0.6,0.5-1.3,1.2-2.1,1.7C971.4,39.9,972,40.8,972.7,40.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1019.6,28.6c1,0,1.7-1.3,1.8-2.5c-1.3,0.7-1.7-0.2-4.7,0.5 C1017.2,27.4,1017.9,28.6,1019.6,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M789.7,2.6c-0.3,0.3-0.7,0.5-1,0.7V4L789.7,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M774.9-0.8c1.3,0,2,1,3.2,1.5c-0.7,0.7-1.4,1-2.1,1.5c0.6,0.2,1.3,0.3,2.5,0.3 c-1.1,0.3-1.8,0.7-3,1.4c0.4,1.5,1.8,2,4,2h-0.1c0.4,0.7,0.8,1.5,1.5,1.7c1.3,0.2,1.6-2.9,2.8-3.7c1.9-1.3,3.1,0.2,4.9-0.7v-1 c0.4,0.2,1,0.2,1.4,0c1.7-1.5,3.5,0,3.8-3.1c-0.8-0.3-2.5-1.7-4.3-1.7c-2.1,0-3.1,2.2-5.2,2.2c-2.7,0-4.7-2.2-8.2-2.2 c-3,0-9.6,0.5-10.9,3.2c1.1,0.2,2,0.7,3.1,0.7C770.6,1.4,773.3-0.8,774.9-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M834.3,2.6l-0.7-2c1.3,0,2.7,0.7,3.5-0.9c0-0.7,0.1-1,0-2.5c-1.3,0.3-3.7,0.2-4.5,0 c0.3,0,1.1-0.5,1.4-1.4h-4.7c0,0.3-0.1,0.9,0,2.2c-1.7,0.7-2.8,2-2.8,4.6C826.5,3.5,833.5,3.1,834.3,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M819.4,2.3c-1.4,0-7.1,1-7.1,3.4c0,0.7,0.7,1.2,1.4,1.2c1.3,0,1.8,0,2.1-1.7 c0.9,0,2,1.7,2.8,1.7c2,0,1.8-2.5,4.7-2.5C822.7,3.1,821.3,2.3,819.4,2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M818.7-1.1c1.6,0,3.1,0.3,4.2-0.7c-3.1-1.5-4.1-1.9-8.1-2.5c1.4-1.7,4.3-2.7,6.5-4.4 c0-0.8,0.7-1.7,1.3-2.2c0-0.5-0.1-2-0.4-2c-1.3,0-2.3,1.4-2.4,2.9c-4.1,0-4.3,3.4-8.5,3.4v2.2c1.4-1,0.8-0.4,2.4,0.3h-5.9 c-0.7,0.7-1,1-1.8,1.9c0.3,0.2,6.1,3.2,7.1,3.2C814.8,0.9,817-1.1,818.7-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M634.1,17.5c0.4,0,0.7,0.5,1.1,0.7c-0.6,2.7,1.6,4.1,4,5.6c-0.4,0-0.7,0.2-1.1,0.4 c0.7,1.7,2.3,2.7,4.5,2.7c3,0,3-3.7,4.2-4.6h1.1c0.6,0.5,1.8,1.5,2.1,1.5h3.7c-1.5,1.5-5.4,3.6-7.2,4.2c-0.7,0.2-4,0.2-4,1.7 c0,4.1,3.7,2.2,5.4,2.2c1,0,5.5,0.2,6.4,0.9c-1.7,0.5-3.2,0-4.7,1.4c0,0-3.3-0.5-5.2-0.2c0,5.8,7.6,8,11,10.7 c2-2.4,1.7-7.1,4.1-9.3c0.7-0.7,1.8-0.3,2.1-1.3c1.4-4.4,3-11.9,7.8-11.9c0,0,1.1,2.2,3.4,2.6c-0.7,0-1.3,0.2-2,0.3 c0.6,1.3,1.8,4.4,2.8,4.7c-0.3,2.5-1.8,1.7-2.1,4.7c1.8,0.2,4.8,0,6.5,0.3c-0.4,0.9-0.4,1.7-0.1,3.1c3.5-1.4,5.1-4.2,8.9-5.8 c-1.3-2.2-5.4-0.9-5.4-6.1H677c0.4-0.7,0.3-1.7,0-2.5c-1,0.2-1.4,0.3-2.5,0c0.4,0,1,0,1.4-0.2c-1.4-2-8.9-7.1-11.3-7.1 c-0.4,0-1-0.2-1.4-0.2c0.3-1.4,0.6-4.1-1.7-4.1c-1.1,0-1.4,1.5-2.5,2.2c0-1.2,0.4-2.2,0.4-3.4c0-1.7-3.8-3.4-5.7-3.4 c-1.8,0-2.8,0-2.8,2.5c0,3.2,0.8,4.7,1.7,7.5c-3.5-1.5-2.5-7.5-6.4-7.5c-1.3,0-2.4,1.4-2.4,2.9c0,1,0.4,1.9,1,2.2 c-1-1.2-2.4-1.2-3.8-2.5c0.4-0.9,1-1.4,1.7-2.4c-3.2-0.7-4.8-0.7-7.1-0.7c-1.4,0-4.4,3.2-4.9,4.1 C631.6,14.7,633.1,17.5,634.1,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M662.1,8.4c-0.3,3.9,2.5,1.9,5,1.9c0.3,0,6.1,0.5,6.6,0.5c-0.7,0.3-2.3,0.3-3.5,0.8 c-0.3,0-1.9,0-2.8,0.2c0.2,1.4,0.6,2.2,1.8,2.7h8.1c1,2,2.4,3.1,5,3.1c4.1,0,11.2-5.9,14.6-8.6c-0.8-2-3.5-4.6-6.4-4.6h-4.6 c-2.1,0-3,1.7-4.3,1.7c-0.3-1.2,0-2,0-4.2h-1.7c-0.7,0.7-1.9,3.9-3.5,3.9c-0.7,0-4.8-2.4-5.7-3.4h-3.9l0.7,1.7H665v0.8 c-0.9,0.5-2,0.2-2.8-0.5H660C660.1,6,661,7.4,662.1,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M635.4,26.9c-1-3.6-2.8-4.4-4.6-7.1C628.6,21.4,632.7,26.1,635.4,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M631,19.6c-0.1,0.1-0.2,0.2-0.2,0.2l0.2,0.3V19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M630.6,19.6c0.1,0.1,0.1,0.2,0.2,0.2c0,0,0,0,0,0L630.6,19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M548.4,240c0,2,1.8,3.9,3.5,3.9c0.8,0,2-0.2,2.7-0.7c1.1-0.9,2.8-3.7,5.1-3.7 c1.4,0,2.8,0.2,3.7-0.8c1.1-1.4,0.1-3.4,0.1-4.8v-5.8c0-1.4,2.6-1.2,2.6-2.5c0-2.9-1.6-6.9-4.8-6.9h-2.4c-1.4,0-4.2,2-4.2,3.2 c0,0.8,0.3,1.2,0.9,2.2c-0.9,1-3.3,1.9-4.1,1.9c-0.4,0-1.6-0.3-1.6,1.9c0,1.7,1.3,2.7,2.7,3.6 C551.9,235.4,548.4,235.7,548.4,240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M561.1,201c1.6,0,2.7-2,2.7-3.9c-1.1,0-3.5,0.8-3.5,1.9C560.2,199.6,560.7,201,561.1,201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M565.6,205.9v1.4c0,0.2-1,1.4-1,2.2c0,0.7,1.3,1.2,2.1,1.4v1.5c-0.4,0.3-0.6,0.7-0.6,1.2v2.7 h1.1c-0.3-0.7-0.7-1.2,0-2.6c0.4,0.3,1.3,0.8,2.4,0.8c-0.4,1.4,0,1.7,0,3.2c0,1.3-1.4,2.2-1.4,3.6c0,1.3,1,1.3,2.3,1.3 c1.1,0,1.8-0.8,3.3-0.8c0.4,0,0.8,0.2,1.3,0.2c-0.3,0.7-1,1-1,2.4c0,1.7,2,2.1,3.4,1.9v2.5c-0.7,1.7-3.8,3.2-6.4,3.2 c0,1.9,1.1,2.7,1.1,4.9c0,2.5-4,2.7-4,5.2c0,0.3,0.4,0.8,0.7,0.8c0.7,0,0.6-0.8,1.4-0.8c1.5,0,2.1,2,4,2c1,0,2-0.7,2.6-1.7 c0,0.3,0.3,0.9,0.3,1.2c0,2.4-2.8,1.5-4.8,2.2c-0.4,0.2-4.7,5.6-5,6.3v1h1c0.6-0.7,1-1.3,2-1.3h2c0-1.4,0.8-2.9,2.3-2.9 c1,0,1.6,1,2.6,1c2.1,0,5.9-1.5,7.4-1.5h5.7c1.7,0,2.7-1,4-2.6v-1.2c-0.8,0-1.4-0.2-2.8-0.7c1.1-2.2,4.5-3.7,4.5-6.8 c0-1.7-1.3-3.2-3-3.2c-1.1,0-0.9-0.2-1.8,0.7l0.7-0.7c-0.6,0.3-0.7,0.8-1.7,1.2V234c0.4-0.2,0.7-0.7,0.7-1.2 c0-1.3-1.5-2.2-1.5-3.6c0-4.1-3.7-5.3-5.9-8c-1.7-2-1.3-6.1-4-7.1c-1.1-0.3-1.8,0.3-3.3-0.2c0.2-0.7,0.6-1.2,1.1-1.4 c0-3.6,4.4-5.6,3.8-10.3h-8.3c-0.3-0.5-0.4-0.8-0.4-1.4c0.4-2.4,3.5-2,3.5-4.4c0-0.3-0.8-1.5-1.4-1.5h-4.1 c-0.9,0-2.3,1.4-2.3,2.2c0,0.9-0.6,1.5-0.6,2.9c-1,0-2,0.7-2,2c0,0.3,0.4,0.9,0.7,1c0,0.3-0.3,1-0.6,1c-0.3,0-1-0.5-1-1.5h-2.3 C562.4,204.9,563.5,205.4,565.6,205.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M570.4,225c-0.8,0.5-1,1.2-1,2h1.6c0-0.8,0.1-1.5,0.1-2H570.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M533.8,147.4l0.3-0.3c0-4.7-5.2-3.5-5.2-8.5c0-0.5,0.4-1.2,0.9-1.5c-1.3,0-2.1,0.9-3.4,0.9 c-1.4,0-2.6-0.2-2.6-2.2c-0.6,0.5-0.6,0.3-1.6,0c-0.3,0.7-0.6,1.2-0.6,2.5c-1.3-1.5-3,0.5-4.8,0.5c-1.3,0-2.4-0.5-4.5-0.5 c0,0.5-0.1,1.2,0,1.7c-0.6-0.3-0.9-0.8-2-1.2l-3.4,1c-0.8,0-1.3-0.9-1.8-1.5c-0.4,0.7-0.3,1,0,2.2c-0.7,0.2-1.6,1-2.5,1 c-1,0-2.3-2.2-2.1-3.4c-0.2-1-0.7-1.5-0.8-2.5h-1.1c-1.1,0-1.4,1.9-2.5,1.9v1.3c-0.9-0.5-1.6-0.8-2.8-0.3 c0.3,1.9,5.5,3.7,7.2,3.7c0,0.5,0.2,1,0.6,1.4c-1.6,0.7-5.2,1.5-7.4,1.5c1.4,1.7,3.8,0,6.1,0.7c-0.3,1.9-0.7,2.9-0.7,5.1 c-0.4,0-0.8,0.5-1.3,0.8c3.1,0,4.2,2.4,6.2,3.1c3.8,1.5,7.5,3.1,12.7,3.1c4.8,0,7.5-2.9,10.9-4.2 C529.3,152.8,532.7,149.8,533.8,147.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M289.7,420.5c-1-0.5-1.7-2.9-3.3-3.4l-2.1-0.2c-0.1-0.3,0-0.8,0-1.2c-3.3,0-6.8-1.9-8.8-4.2 c-0.3-0.3-1.4-2-2.4-2c-4.7,0-7.6-4.2-13.9-4.2c-6.4,0-9.3,2.9-11.6,7.5h1.3c1.4-1.7,5.2-4.1,7.9-4.1c0.7,0,1.4-0.2,2,0.5 c-0.4,0.5-0.6,1.2,0.3,1.9h4.1c2,0,3,2.5,5,2.5c1.1,0,1.8-0.5,3,0.2c0.6,0.3,0.4,1.5,1.6,1.5c0.4,2.6,2.7,2.4,4.8,3.6 c-0.1,0.8-0.7,1.5-1.4,1.5v1c2.7,0,5,1.2,8.2,1.2C286,422.5,288.7,422.5,289.7,420.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M254.8,411.7v1.2c-0.4,0-1.3,0.3-1.3,1.5c0,0.3,1.8,0,2,0c0.3-0.8,0.1-1.7,0-2.5l-0.4-0.2H254.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M274.6,429.8c0,1.4,1.1,2.5,2.3,2.5c1.7,0,3-0.7,4.7-1c-0.1-0.7-0.4-1.2-1.3-1.5l0.3,0.3 c-0.8-0.3-2.8-1.4-4.5-1.4C275.4,428.8,274.6,429.2,274.6,429.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M319.2,429.5c0,1.7,1.8,1.9,3.5,1.9c0.9,0,1.8,0,2.3-1c-0.4-1-3.8-1.9-4.2-1.9 C320.3,428.5,319.2,428.6,319.2,429.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M290,428.8c0,1,0.9,2.6,1.7,2.7c0-0.5,0.1-0.8,0.1-1.4c0.7,0.5,0.7,0,1.7,0 c1.7,0,5.1-0.5,6.4,0.5c0.7,0.5,0.4,2.2,1.7,2.2c1.6,0,1.4-3,3.3-3c0.7,0,0.6,0.9,1.4,0.9c1,0,1.6-0.7,2.6-1.4h5.2 c-1-1.7-2.4-2.4-3.8-3.7l0.7,0.7c-2.5-1.5-3.4-4.4-7.9-4.4c-1.6,0-2.4,0.7-4.2,0.7c-1.3,0-2.1-1.2-3.4-1.2 c-0.4,0-1.1,0.7-1.1,1.2c0,1,1,1.9,1.8,1.9c0,1.3,0.1,2.5,1,3.6c-1.7,1-3.1,0.2-6.4,0.2C290.6,428.3,290.3,428.8,290,428.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M341.1,471c0,0.5,0.9,0,1.3,0c0.8,0,1.4-1.5,1.7-2.2v-1.2h-1.3 C341.9,467.6,341.1,469.3,341.1,471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M387.9,518.8c-1.7,0-2.8,1.7-2.8,4.2c0,1.5,3.7,4.6,5.8,4.6c1.7,0,3.8-3.9,3.8-5.4 c0-0.3-0.4-1.5-1-1.5c-0.7,0-2,1.9-2.3-0.3c-1.1,0-2.1-0.9-3-1.5C388.5,519,388.1,518.8,387.9,518.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "92.9,260.3 92.9,260.3 92.9,260.3  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M446.3,544.1c-2-0.7-3.3,0.3-5.2-0.3c-2.3-0.9-6.7-5.6-7.9-8.1c-1.6-0.9-4-2-6.7-2.7l-5.4,0.9 c-2.8,0-3.4-2.7-6.4-2.7c-1.3,0-1.8,1.2-3.1,1.9h-1c0-1.5,0.1-2.7-0.3-4.2c-0.3-1.4-1.6-1-2.7-1.9c-1.8-1.4-6.9-4.6-9.5-4.6 c-2.3,0-4,3.5-5.4,6.3c-0.4,0.8-1,2-1.6,2c-0.4,0-0.7-1.3-0.7-1.9h-3.4c-0.3-1.7-1-3.1-2.4-3.9c-0.7-0.3-2-0.2-2-1.9 c0-5.1,4.1-6.8,6.4-10.2c0-1.7-1.8-1.7-2.5-3.4c-0.7-1.9-2.6-7.3-2.6-9.3c-2.4-0.7-5.4-6.3-7.6-6.3h-0.8v-0.3 c-1.4,0-3.7-1.4-4.7-1.9h-3.7c-3.8-0.9-9.8-0.3-10.7-5.1c-0.7,0-1.8-0.4-2.1-1c-1.7-4.2-3-3.7-5.7-6.9h-4 c-0.6-2.2-0.1-4.8-2-5.4c-2.1-0.9-5.1-1.4-6.1-3.7V468c0.4,0.3,1.5,0.2,2.1-0.3c0,0-2.6-0.5-4-0.5c-0.4,0.4-3.4,0.4-3.5,0.9 c-0.9,2-2.3,2-4.4,2.4c-1.1,0-2.8-0.3-2.8-1.9h-7.6c-0.8-0.2-1.7-1.4-1.7-3c-2.1-0.5-5.3-1.5-5.9-4.2l-2.5,0 c0,2,2.1,1.2,2.7,3.2h-3.4c-1.3,1-3.5,0.7-3.5,3.2c0,2,1.7,3.2,1.7,5.3c0,0.7-0.8,2.8-1.3,2.8c-1.6,0-2.3-3.3-2.3-5.1 c0-1.5,0.9-4.4,1.3-6.9c0.6,0,1.4-0.7,1.4-2c0-0.2-0.6-2-1.3-2c-1.8,0-2.2,2.5-4.1,3.2c-3.5,1.4-5.8,2-9.2,3.4 c-1.8,0.7-3.1,1.2-3.8,3.9c-0.3,1.4-0.4,3.6-1.3,4.2c-0.8,0.7-2.3,1.2-2.3,2.9c-0.3,0-0.8,0.5-0.8,0.8v1c-1,0.4-0.6,0.4-1.7,0 c-0.2,0.4-0.6,0.8-1,1.2c0.5-0.6,0.9-1.2,0.9-1.3c-2.3-2-4-5.4-8-5.4c-3.4,0-5.2,3.4-8.9,3.4c-2.4,0-2.4-3.2-4-4.1 c-2.3-1.3-5.2-2.9-5.2-6.6v-10.3c0.8-1.7,1-5.9,1-7.5v-2.5c-2.5-0.7-3.4-3.6-6.8-3.6c-5,0-8.8,1-13.4,1c-0.9,0-1.7-0.7-1.7-1.8 v-0.9c0.9-1,2.5-1.7,2.5-3.4V429h1.1v1.2c0.9-1.7,1.7-2.9,1.7-5.6c0-3.2,2.4-6.3,2.4-8.6v-1.5c-0.8,0-2.7-0.2-3.3-0.3 c-0.6-0.3-1.6-0.5-2.8-0.5c-3.8,0-8.5,1.7-8.5,6.6c0,2.6-2.4,4.7-3,6.8c-0.1,0.7-0.9,2.7-2,2.7c-0.6,0-1.1-1-2.7-1 c-2.8,0-5.1,2.4-7.8,2.4c-1.1,0-1.1-1.5-2.4-2c-3.7-1.4-3.7-4.2-6.2-7.3c-1-1.2-2.8-3.6-3.4-4.9c-0.6-1.5,0.1-2.5-0.4-4 c-0.3-0.7-1.4-2-1.1-3.4v-9.5c0.4-2.5,1.4-3.7,1.4-6.8c0-1-0.3-1.7-0.6-2.7l-0.1-0.4c0.1,0,0.3,0,0.4,0.1 c0-0.5-0.7-1.2-0.7-1.7c0-5.1,1.8-9.7,5-11c1.4-0.7,2.7,0.5,3.8-0.9c1.7-2,3.7-6.3,7.8-6.3c1.6,0,2.4,1.7,4,1.7 c0.8,0,1.3-1.3,2.1-1.3c2.8,0,6.2,5.8,10.2,3.4c-1.7-1.4-0.4-2.9-0.3-5.4c-0.9,0.5-0.6,0.5-2,0c2.4-1,5.4-0.7,7.6-1.4 c0,0.5,0.6,1.4,1,1.4c1.1,0,1.6-1.4,3.5-1.4c3.4,0,4.9,3.9,7.5,3.9c1.3,0,1.8-2.2,3.1-2.2c6.2,0,4.5,10.4,6.8,15.8 c1.1,2.7,2.5,3.5,4.2,6.3c0.8,1.5,0.7,4.2,2.8,4.2c2.4,0,3.1-3.2,3.1-6.8c0-3.1-1.3-4.8-1.7-6.8v-0.8c0-5.4-4-7.1-4-12.7 c0-12.3,8.5-15.5,15.1-20l-0.4-0.3c0.8-1,0.7-1.5,2.4-2.2c1.1-0.3,1.9-1.7,3.5-2c0.8-0.2,1.2-1.2,1.7-1.9l-1.7-1.2V339 c1.3,0,1.9,0.2,2.2-1.7c-0.7-0.2-1.4-0.3-1.9-1.5c0.7,0,1.9-0.7,1.9-2.1V332h-1c-0.9-1,0-0.8,0-2.5c0-1.7-0.7-4.8-0.7-5.9 c0,0-0.1-1.3,0.1-2.2c0.3,1.7,1.6,4.4,1.6,5.6v1.8c0,0.4,0.3,1,0.6,1c0.4,0,3.3-5.9,3.3-6.9c0-1.4-1-1.9-1.3-3.2l0.7-0.8 c0.3,0.3,0.6,1.3,1,1.3c1,0,3.7-5.9,4-7.3c0,0-1.3-1.2-1.3-2c0-0.5,0.4-1,0.8-1.2c0.4,0,0.8,0.2,1.3,0.2c2,0,3.4,0,5.4-0.8 c-1-0.9-2.3,0-3.5,0h-1.4c2.8-2.2,7.6-1.2,10.5-3.7c0.6,0.7,3,0,4.7-0.5v-1.2c0,0-1.3,1.2-1.6,1.2c-0.9,0-1.4-2.2-1.4-3 c-0.4-0.2-0.6-1-0.6-1.5c0-6.4,4.8-8.3,7.1-11c1.4-0.8,1.6,0,3.2,0c2,0,3.5-1,4.5-2.9c-0.3-0.4-0.5-0.8-0.6-1.3l-0.1-0.4V284 c0.3,0.2,1,0,1.4,0c0.9,0,4.4,0.7,5.7-0.3c1.3-1,1.3-3.2,3.4-3.4c0,2.4-0.1,2.5,2.1,2.5c-3.3,0.3-8.3,3-8.3,6.8 c0,1.5,2,4.3,2.8,4.3c1.1,0,3.8-4.6,6.6-5.6c0.7-0.2,10.4-4.6,10.4-6c0-1.9-3.7-2-4.5-2c-4.1,0-10.6-4.8-10.6-9 c0-1,1.1-2.4,1.4-4.1c-0.7,0-2.3-0.5-3.5-0.5c0.9-1.3,5.9-2.2,5.9-5.6c0-3.2-4.4-2.5-7.4-2.5c-6.2,0-9.1,5.2-13.3,5.9 c1.8-4.6,4.8-3.1,7.9-6.8c2-2.4,0.6-3.9,3.5-5.1c5.4-2,8.5-0.8,13.9-0.8c7.1,0,10.9,2.8,15.1-3.7c2-3.2,13.4-3.9,13.4-9.3 c0-3.9-1.1-5.6-2.4-8.1c-1.1,0,0.5-1.7-1.1-2.5v-2c-3.2,2.2-10,5.1-13.4,5.1c-0.4,0-1.3-0.3-1.4-0.7c2.8-1.9,10.7-3.2,11.5-6.4 c0.1-0.8-1.1-1.1-1.2-1.9c-3.4,0.5-10.6-1.4-10.6-7.1v-0.5c-3.1,0-5-2.4-6.8-4.1c0.7-0.5,2.1-1,2.1-3.1c0-1.7-1.3-3-1-4.7 c-1.3-0.5-5.9-4-4.7-7.1c1.5-3.8-4.5-4.7-5-9.3c-0.4,0-1.8-1.5-2.4-2.2c-1,0.9-3.3,2.4-3.3,4.7c0,2.5-4.5,8.8-8.1,8.8 c-2.5,0-3-3.7-4.7-3.7c-2.4,0-3.4-8.3-3.8-11.9c-0.6-4.8-8.2-1.4-8.2-7.6c-4-0.7-4.8-6.4-8.8-6.4c-1.8,0-1.8,1.7-4,1.7 c-4.1,0-6.7-2.9-10.6-2.9c-2.1,0-4.2,1.2-4.2,4.2c0,1.7,5,4.2,0.4,7.6c-1.8,1.4,2.6,5.1,2.8,7.6c0.5,5-3.5,6.3-5.4,7.1 c3.3,6.6,8.2,8.8,8.2,20c0,3-8.5,10.7-11.3,11.4c4.9,3,3,12.2,5,15.1c-0.6,1-2.4,2.2-2.5,4.1c-1.7,0-2.9,3.3-4.3,2 c-3.5-3.4-8.5-8.6-8.5-13.6c0-5.4,0.8-9.7-3.1-12.7h-9.2c-5.2-4.6-11.2-7.3-17.4-10.2c-1.1-0.5-4.4-3.4-6.4-3.4 c-2.1,0-3.1,2.5-5.2,2.5c0-4.1-2.3-13.6-5.4-13.6c-1.4,0-2.1,1.4-3.5,1.7c0.6-2,0-2.7,0-7.6c0-6.8,1.7-10.8,4.9-14.7 c1.1-1.3,3.5-8,4.7-8.5c2.4-1,6.6,0.7,6.6-3.4c0-2.5-5.4-2.7-7.4-4.1c1.3,0.5-3-3,8.5,1.3c3,1.1,1.2-3.6,2.9-3.6h3.1 c3.4,0,5.2-4.2,7.5-6.3v-2.6c-4.8-1.3-9.6-0.5-11.7-5.6h2.6c1.8,1.4,3.7,3.9,6.4,3.9c2.3,0,6.4-3.6,6.4-5.6 c0-0.7-2.1-3.7-1-3.7c3.1,0,4.3,3.4,6.2,3.4c1.3,0,2.1-1.4,4.7-1.4c-0.7-1,0-4,1.7-0.8c0.9,1.7,8.2-5.8,8.2-8 c0-1.5-3.3-3.2-3.3-4.3c0-1.2-1.9-3.9,2.5-6.4c0.6-1.5,0-1.3,0-4.2c-4.5,0-3.4-4.3-9.2-4.3c-1.3-0.2-2.3-1.2-3.5-1.2 c-1.7,0-3.5,1.4-3.5,3.4c0,2.2,2.1,3,2.1,4.6c0,1.7-3.3,1.7-4,3.4c-1.1,2.9-0.7,5.2-2.8,8.3c-3.2,4.9-7.4-3-7.4-4.9 c0-2.2,2.4-1.7,2.4-4.2c0-1.2-4.1-6-5.2-6c-4.1,0-1.3,7.3-5.7,7.3c0-2.9-0.3-4.9-3.3-6.6c0.4-0.9,0.7-1.4,1.4-2 c-2.3-1.7-5.4,0-7.1-2.6c1-0.7,3.5-1.9,3.5-4.1c0-3.2-4.2-3.1-4.3-5.6c-0.1-5.3-3.2-8.6-8.8-8.8c-2.7-0.1-1.6,2-1.4,3.7 c-1.7,0.5-4,0-4,2.5c0,1.7,1.1,2.5,1.1,4.2c0,1.7-1.8,1.5-1.8,3.9c0,5.6,9.6,2.2,9.6,8c0,1-1.1,5.1-1.1,5.1c1-0.7,1.8-1,3-1.7 c1.8,7-7.5,3.6-7.5,11.9c-4.6,1.5-1-4.1-2.1-5.9c-0.4-0.8-4.2-2-6.4-2c-2.5,0-3.5,1.9-3.5,5.4c-2.4-0.4-4,0-12,0 c-7.6,0-16.6-3.2-18.4-10.2c-2.5,0.8-11,1-11,4.7c0,1.2,0.7,1.8,1.8,1.8c2.3,0,6-1.3,7.7-2.7c0.6,5.6-6.7,1-6.7,6.8 c0,1.2,1.6,5.1,0.9,5.1c-2.8,0-3.4-4.2-5.8-5.6l-2.1-1.2h-9c-2.8,0-4.7,1.4-7.8,1.5c-5.6,0.3-5.6-2.1-5.6-2.7 c0-1.5,4.3-0.9,5.2-1.9c-3.9-6.6-3.2-5.5-11.3-4.7c-8.6,0.8-12.9-7.6-21.5-7.6c-2.7,0-3.8,2.2-6.1,2.2c-1.6,0-3.1-3.2-3.4-4.6 c-2.7,0.7-2.7,4.4-5.5,4.4c-2.7,0-6.5-7.6-7.4-7.6c-2.8,0-1.8,4.9-4.8,4.9c-1.1,0-2.1-1-2.6-2.4c-4.4,1.2-5.9,1.5-9.9,3.4 c-1.6,0.3-5.3,3.6-6.5,2.2c-3.7-4.2-3.1,1.1-4.4,1.2c-9.2,0.4-2.8,4.4-4.1,4.4c-3.5,0-9.9-0.8-15.7-5.1c-0.2-0.2-2-1.7-2-2.2 c-1,0.7-0.3,0.4-1.7,0V184c0,0,0,0,0,0v-73.2c-3.5-1.4-4.8-3.4-8.9-3.4c-2.5,0-4.1,1.2-6.7,1.2c-4,0-11.6-0.7-15.1-3.4v80.8 c0.7-0.7,1.3-1.4,1.6-2.1c-0.7-0.7-1-1.2-1.4-2.4c1.3-0.9,4.1-1.7,5.8-2.5c2.4,5.9,8.6,6.6,13.3,8.5h7.8 c4.2,2.9,9.1,2.7,12.7,5.9c1.7,1.5,3.7,6.4,6.7,6.4c1.1,0,1.7-1.7,2.1-3c1.1,1.3,2.1,2.5,4.3,2.5c0.6-1.2,1.8,0.4,2.5,1.2 c-0.4,0.9-1.4,1.5-1.4,3.6c0,1,1.6,2.5,2.1,2.5c1.8,0,1.1-2,3.8-2.2v2.2c0,1.4-2.1,1.5-2.1,2.9c0,1,0.6,2.5,2.5,2.5 c2.5,0,4.2,0,4.2,2.5v2.5c0,1.9,3.5,5.1,5.9,5.1c0.7,0,0.7-0.2,1.4-0.2c0-1.2,2-1.5,2-3.4c0-3.2-2-4.2-3.3-5.6 c1.3,1.3,3.3,2.3,3.3,5.6c0,1.9-2,2.2-2,3.4c0,0.9,0.8,1.4,0.8,2.4c0,2.2-0.6,6.8,1.4,7.5c1.1,0.3,2.3,0.3,3.1,1.3 c1.3,1.5-0.3,3.7,1.4,5.1c0,0,3.7,2.7,3.8,3.2c1,3.9,1.3,8.5,6.1,8.5c0.7,3.4,5.7,1.2,6.8,5.6c0.4,1.7,4,2,5.4,3.7 c0.3,0.3,1,0.7,1.6,1h0c0,0,0,0,0,0c0.6,1.7,1.8,2.2,1.8,3.9c0,1.5-1.3,3.6-2,4.6c-0.7-1.5-2-2.9-4.1-2.9 c-0.6,0-2.1,0.2-2.1,1.2c0,3.7,3.5,5.3,3.5,9c0,5.3-3.7,14.9-2.4,19c1.4,4.3-0.1,10.5,1.4,14.2c-0.9,0.7-2.1,1.7-1.4,3.2 c2.4,5,5.5,12.5,8.5,13.1c-0.7,6.9,3.3,9,5.2,14.9c0.4,1.3,0,3.2,1.1,3.7c5.1,2.4,12.3,5.9,14.4,11h-0.3v1.2 c1,3.9,2.3,4.9,3.5,8c0.8,2,0.7,6.8,2.4,8c2.5,1.9,4.8,5.5,6.9,9.1c1.2,2.1-2.1,1.5-2.8,1.5c1.4,2.5,4.5,2,6.5,4.4 c1.4,1.7,2.6,3.6,4.1,5.4v4.4c0.4,0.8,0.6,0.8,1.4,1.5c1.5,1.2,2.9,5.2,5.5,5.2c0.1,0.7,2,3.6,2.3,3.6c0.4,0,1-1.7,1-2.6 c0-1.3-1.7-4.2-2.8-2.9c-2.5-2-3.4-6.4-4.5-10.5c-1-3.6-3.8-5.4-4.8-9.3c-0.7-2.9-1-4.6-3-6.9c-1.4-1.7-3.3-1.7-4.3-4.3 c-1.1-2.9-2.5-5.1-2.5-8.6c0-0.5-0.1-1.5,0.3-2.2c1.8,2.2,4.1,2,6.5,3.4c1.1,0.7,0.8,4.4,2.1,5.9c1.3,1.5,0.8,4.4,2.1,5.9 c1.6,1.9,3,3.7,4.8,5.9c0.4-0.5,0.3-0.3,1.5,0c0,4.1,4.4,4.4,5.7,7.5c0.7,1.9-0.3,3.6,0.8,4.9c1.4,1.7,3.7,2.4,5.1,4.1 c3.1,3.7,7.9,8.6,9.6,14.8c0.3,1.2,1.4,1.7,1.4,3.9c0,1.8-1.4,2.9-1.4,4.7c0,1.5,0.9,3.4,2.1,3.4c0.4,2.2,4.8,3.4,6.5,5.4 c0.4,0.5,0.7,0.7,1.6,1.2c1.8,1,2.8,0.7,4.7,1.7c2,1.2,2.4,3.2,4.4,3.9c1.6,0.5,2.5-0.5,4.1,0.3c1.4,0.8,6.2,4.9,7.9,4.9 c1.1,0,2.1-0.3,3.2,0.3c0.6,0.3,1.7,1.5,2.8,1.5c2.4,0,2.8-3.4,5.4-3.4c1.1,0,2,0.5,3.1,1.4h0.9c3.8,2.2,4.4,6.1,8.8,8.7 c2.8,1.7,4.8,0.8,7.5,2.4c1.8,1,3.2,2.9,5.9,2.9c1,0,1.7-0.9,2.7-0.9h0.8c0.8,4.1,3.2,5.6,5.5,8.3c0.7,0.8,1.4,1.2,1.8,2.9 c0.7,2.5-0.7,4.9,1.4,6.6h1.4c-0.3-0.3-0.3-1,0-1.5c0.1,0,4.9,3.6,5.4,4.6c0.6,1.4,0.6,3,2.5,3.6c0,0.3,0.4,1,0.7,1 c1,0,3.3-1,4.2,0.2c1.1,1.3,2.6,4.6,4.8,4.6c1.1,0,1.8-0.8,2.1-2.6c-0.3-0.2-1.1-0.8-1.1-1.5c0-1,4-4.4,5-4.4 c1.6,0,2,2.2,3.5,3.1c-0.3,0.7-0.9,1-0.9,1.7c0,0.5,1.3,1,1.6,1.3c0.1,0,0.2-0.1,0.3-0.2c-0.1,0.3-0.2,0.7-0.2,1.1 c0,3,2.6,2.5,2.6,6.1c0,1.7-0.7,2.3-0.7,4.4c0,1.4,0.9,2.4,0.9,3.7v0.9l-0.6,1.4c0,0.5,0.7,1.4,1.4,1.7 c-0.8,4.6-4.5,3.4-6.1,7.1c-1.1,2.7-2.1,7.3-5.9,7.3c0.6,7.5-3,6.8-3,10.7c0,2.4,0.3,5.7,2.3,5.7c1,0,0.9-0.8,2.1,0.2 c-0.6,2.7-3.1,3.4-4.4,5.9c-0.6,0.7-1.6,3.1-1.6,5.1c0,3,2,6.4,3.5,8.3c0.6,0.7,1.7,0.3,2.1,1.3c0.4,1.2,0.7,3.6,1.7,4.8 c0.4,0.5,1.4,0.2,1.8,1.2c1.3,3.2,2.1,5.4,3.1,9.3c1,3.7,3.8,6.8,5,10.9c0.6,2.4,2.7,3.7,2.7,6.4c0,2-0.6,3.9,0.6,5.2 c2.5,3,4.5,5.4,8.5,7c2,0.7,2.8,1.4,4.5,3.4c1.6,1.9,3.1,1.5,5.2,2.7c2.5,1.5,4.8,4.1,6.1,8.1c0.4,1.9,1.1,11.9,1.1,13.6 c0,2.7-1.3,7.3-1.3,9.7v7.4c-0.3,1.7-1,4.7-1,5.9v1.5c0,5.8-3.3,10-3.3,16.4c0,2.7-1.5,5.1-0.7,8.1l0.1,12.7 c-0.9,4.1-0.9,6.9-1.8,10.9c-0.1,0.7-0.9,0.5-1.3,1.2c-0.7,1.2-1,3.6-1.6,4.7c-1.3,2.4-3.2,6.3-3.2,10.2c0,1.2,0.1,5.9,0.7,5.9 c0,0,0.8,0.8,0.8,1.9c0,0.5-0.4,1-1.4,1c-0.4,3-1.4,4.4-1.4,7.6c0,1.9,0.8,5.8,2,5.8c1,0,1.1-1.4,2.1-1.9c0.4-0.2,0.9,0,1.3,0 v2.6l-4.7,25.1c-2.1,0-1.1-3.1-3.7-3.1c-0.7,0-1.3,0.8-1.3,1.9h-0.1v1.7c0.3,1.9,2,4.6,2,5.9c0,2.7-3.3,3.9-3.3,6.9 c0,2.9,2.1,8.8,2.1,12.5v2.4c0,3.6,3.8,2.9,3.8,7c0,1-0.6,2-1,2.9c0.4,0.3,0.7,0.7,1.1,0.9c-0.1,1.5-2.7,1.4-2.7,2.9 c0,0.3,0.8,1.2,1.3,1.7c1.8,2.2,3,4.6,6.9,4.6c0.1,0.9,0.4,2.2,1.6,2.2h2.7c0,3,3.1,3,5.2,3.9c2.3,0.9,1.1,5.4,4.4,5.4h4 c0.4,0,1-0.7,1.4-0.7h1.6c1.3,0,4.8-3.2,6.9-3.2c0.8,0,1.7,0.5,2.3-0.5c-3.8-2.2-7.6-3.7-10.8-7.5c-1.8-2.2-1.7-10-4.2-11.7 c-0.9-0.2-2.1-2.2-2.1-3.9c0-3.2,0.7-5.6,2.4-7.6c1.3-1.5,3.5-0.5,4.5-2.9c0.9-2.2,0.4-4.4,1.6-5.8c2-2.4,5.5-2.9,5.5-7.6 c0-5.3-6.4-2.9-6.4-9.5c0-2.9,2-5.3,4.2-5.9c1-0.2,3.5-0.3,3.8-2.2c0.9-4.2,0.9-7.3,3.4-10.3c-0.7-0.3-1.5-0.7-1.5-2.6 c1.4,0,2,1.5,3.7,1.5c0.3,0,1.4-1.2,1.4-2.2c0-0.8-0.7-1-1.3-1.7c-0.4,0.1-1.3,1.2-2,1.2c-1.3,0-3-4.4-3-6.8c0-0.8,0.4-2,1.4-2 c2.8,0,3.4,2.4,6.4,2.4c1,0,3.2-1.2,3.2-2v-1.7c1-2.4-0.4-7.5,1.4-9.7c1.3-1.6,5.9,0.3,8.2-0.5c3.4-1.4,6.4-0.5,8.8-3.4 c1.4-1.7,2.4-2.8,3.7-5.2c0.7-1.3,0.7-2.5,0.7-4.5c0-1.8-2.3-1.8-2.7-3.7c-0.6-2-0.6-3.9-1.7-5.3c-0.4-0.5-2.5-1.3-2.5-2.9 c0-0.5,0.7-0.9,1.1-0.9c2.1,0,4,2,5.9,2c1,0,4.2,1.9,6.4,1.9c6.5,0,7.6-8.5,10.4-13.6c2.4-4.4,5.2-4.9,7.8-9.5 c1.1-2.2,1-3.4,2-5.6v0.2c1.4-3.6,2.8-6.5,5.7-8.1v-8c0-3.2-0.3-5.6,1.6-7.8c1.1-1.3,3-1.3,4.1-3.6c2.5-4.7,6.1-2.4,9.5-6.4 c0.4-0.5,0.6-1.3,1.4-1.9c2.1-1.2,4.2-1,6.9-1c2.4,0,5.4-2.4,6.2-4.4c0.3-0.7,0.2-2.7,0.7-3.7c2.1-3.4,2.8-5.1,4.9-9 c0.3-0.7,0.7-4.1,0.7-5.8c0-1.4,1.3-3.1,1.8-3.9c0.1-0.5,0.7-1.2,0.7-2c0-2.2,1-5,1-8.1c0-4.1-2.1-9.6,0-12.1 c1.4-1.7,3-2,4.4-4.6c0.8-1.5,1.5-1.9,2.3-3.5c3.8-6.9,9.6-10.3,9.6-22.8C449.9,548.7,449.2,545.1,446.3,544.1z M316.2,270.5 c0.1,0.2,0.2,0.5,0.3,0.7C316.3,270.9,316.3,270.7,316.2,270.5c-0.2-0.4-0.4-0.6-0.6-0.7C315.8,269.9,316,270.1,316.2,270.5z  M315.5,269.8c-0.1,0-0.2-0.1-0.3-0.1C315.3,269.8,315.4,269.8,315.5,269.8z M268.9,294c3.1-1.2,9.8-3.2,13.3-3.2 c0,0,0.1-0.1,0.3-0.3c-0.1,0.2-0.3,0.3-0.3,0.3c0,6.4-9.1,4.7-13.2,4.7c-0.7,0-0.7,0.2-1.7,0.2c0.1,0.3,0.3,0.7,0.5,1.1 c-0.2-0.5-0.7-0.8-0.7-1.4C267.1,294.5,268.5,294.2,268.9,294z M266.5,301.2c-3.3,1.9-8,4.6-10.9,4.6c-1.4,0-2-2.6-2-4.3 c0.4,0.9,1.3,2.1,2.1,2.1c1.3,0,1.4-1,2-1.7c1.3-1.5,3.4-1.3,5.4-1.3C265,300.5,265.8,301.7,266.5,301.2z M228.5,265.9 c1.8-0.7,2.1,0,3.7-0.8c1.4-0.9,0.9-3.6,2.3-3.6c1.7,0,2.8,3.1,3.4,3.7c0.3-0.7,0.2-2,0.2-2.4h1.1c0.8,0,6.8,5.8,7.1,6.4 c0.8,2,0,3.7,1.1,5.1c3.3,3.9,7.6,3,11.2,5.8h3.7c1.7,1.4,3.8,3,3.8,5.6c0,1.2-0.6,2-1.4,2c-1.7,0-3.4-2.2-4-2.9 c-0.6,2.7-1.8,10.9-3.8,10.9c0,0,0,0,0,0c-1.4-1.4-1.4-2.5-2-5.3c-1.4,0.5-1.1,1.2-2.8,1.2c0.4-2.4,1.6-3.9,1.6-6.3 c0-2-5.2-5.1-6.4-5.1c-2.3,0,0,4.1-5.1,4.5c-1.6,0.1-1.5,5.3-1.5,7.4v5.4c0,2.2-0.7,7.3-2.8,7.3c-1.6,0-3.2-1.5-3.2-3.4 c0-4.4,1.1-13,3.5-16.8c-1.4,0-2,1.4-3.4,2.4c0.3-3.4,6-8.1,9.1-8.1c1.1,0,4.2,0.9,6.4,0v-2c-3,0-4.7-2.2-8.1-2.2 c-1.6,0-2.1,1.7-4,1.7c-1,0-2.3-0.8-2.4-2h-2.8c0.6-1.4,1.6-1.9,1.6-4.2c-2.1,0.5-4.7,3.7-6.2,3.7c-1.3,0-1.4,2.2-3.8,2.2 c-1.1,0-1.6-0.2-2.1-1.7c-1,0.2-1.5,0.7-2.5,1.2h-2.1C220.7,270.6,224.6,269,228.5,265.9c-5.2,0-8.9,0-11.7-3.4 C219.6,265.9,223.2,265.9,228.5,265.9z M208.6,261.6c-0.6-0.7-0.9-1.4-1.6-2.3C207.7,260.2,208,260.9,208.6,261.6z M36,193.4 c-1.2,0-2.4-0.8-3.5-1.9C33.6,192.5,34.9,193.3,36,193.4c1.5,0,1.9-2,2.8-3.3C37.9,191.3,37.5,193.4,36,193.4z M42.7,188.3 c2.9,3.5,4.8,5.5,6.9,8.5C47.5,193.8,45.6,191.8,42.7,188.3z M57.4,210.8c-1.6-1.9-2.3-4.4-2.8-6.4c-0.4-1.4-1.3-1.8-1.7-2.3 c0.4,0.6,1.3,1,1.7,2.3C55.1,206.4,55.8,208.9,57.4,210.8c0.2,0.2,0.4,0.4,0.6,0.5C57.8,211.2,57.6,211,57.4,210.8z  M155.6,359.1c4.8,1.5,7.5,2.2,9.9,7.1C163.1,361.3,160.4,360.7,155.6,359.1z M176.8,369.7L176.8,369.7c4.2,0,6.2,3.1,7.8,6.9 C183,372.8,181,369.7,176.8,369.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M304.6,281c0.2-0.2,0.3-0.5,0.5-0.7C304.9,280.6,304.8,280.8,304.6,281 c-0.3,0.3-0.3,0.7-0.4,0.9C304.3,281.7,304.3,281.3,304.6,281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M288.6,283.6c0,0,0.1,0,0.1-0.1C288.6,283.6,288.6,283.6,288.6,283.6c-0.3,0.3-0.9,1-1.8,2 C287.6,284.7,288.3,283.9,288.6,283.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M268.8,299.8C268.8,299.8,268.8,299.8,268.8,299.8c-0.6,0.4-1.4,0.8-2.2,1.3 C267.4,300.6,268.2,300.1,268.8,299.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.1,
    y: 259.3,
    transform: "matrix(0.9037 -0.4281 0.4281 0.9037 -91.1587 113.1917)",
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "125.9,355.2 125.9,355.2 141,361.2  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M273.3,395.9c0,1.4,0,3.2,1.4,3.2c0.3,0,0.7-0.5,0.7-0.8c0-1.2-0.4-2.2-1.6-2.4 C273.7,395.9,273.3,395.8,273.3,395.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M273.2,386.3c-0.7,0-1.7,0.7-2,1.4c0.8,0,2.3,0.2,3.7,0C274.6,387.1,274.2,386.3,273.2,386.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M277.6,388.3c-0.1,0.5,0.3,1.5,0.7,1.3L277.6,388.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M294.7,415.3v-1.5c-0.6,1-1.7,1.9-2.8,1.5v1c0,0.2,0.4,0,0.6,0 C293.1,416.3,294.1,415.9,294.7,415.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M55.4,223.9c0.7,0,1.1-0.5,1.1-1.7c0-3.7-3.8-4.2-3.4-8.8c-3-0.7-3.7-0.7-3.7,3.4 c1.7-1.4,0.9-0.5,3.1,0c-0.4,0.8,0,2.2,0,3.4C52.6,220.3,54.2,223.9,55.4,223.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M45.2,206.9c-0.3,0.2-1.4,0.5-1.4,0c-0.7-2.7,0-2.7,0-7.1c-2,1.4-0.7,0-3.3,0 c-0.6,0-1.7,0.3-1.7,1.7c0,2.5,1.7,4.7,3.8,5.1c0,2.7,0.6,4.7,2.3,6.8C46.4,211.7,45,209.3,45.2,206.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M176.1,109.4c2.5,0,3.1,0.7,5.7-1.4c-2.7-2.5-14.6-6.3-14.6-11.7c0-4.4-3.8-8.3-3.8-14.4 c0-1.5,3.1-3.1,3.1-5.6c0-2.5-2.4-3.7-4.9-3.7c-2.3,0-4.2,1.2-4.2,2.9c0,0.5,0,1.2,0.1,1.7c-2.3,1.4-1.4,0-4,0 c-1.1,0-2.5,0.8-2.5,2.2c0,1.5,2.1,9.5,3.3,11.7c-0.7,0.7-0.7,1.3-1.8,1.3c-2.5,0-1.6-4.2-2.4-6.3c-0.7-1.9-2.7-4.1-4.7-4.8 h-3.1c0.3,1,0.6,1.5,0.7,3.1c-1.6,0.5-2.7,0.8-4.2,1.2c-1-3.1-2.4-5.1-6.4-5.1c-2.3,0-3.3,2.2-4.4,3c-0.6-1-0.4-5.9-2.4-5.9 c-5.1,0-18,6.1-18,14.4c0,0.8,2.7,3.4,4.2,3.4c1.8,0,2.7-0.5,5,0.2c-1.6,1.2-5.7-0.2-5.7,3.6c0,4.8,7.8,3,10.9,3h7.5 c1.4,0,2.5,1,3.5,1.7c-1.7,0.2-2.5,0.3-4.7,0.3c-5.9,0-10.3,0.8-13.7,3.9c1,2,3.5,5.9,6.6,5.9c2,0,6.2-0.5,7.8,0.8 c1.7,1.5,0.1,4.2,2.6,4.2h12.7c3-2.5,6.5-1.2,10.2-3.4c2.1-1.2,1.1-3,3.7-3c4.1,0,6.1,5.1,11.6,5.1c3.5,0,6.8,0.2,8.1-3 c-0.6-0.5-1.3-1-1.4-2.4c-0.6,0-2.1,0-2.1-1.4C174.3,109.9,175,109.4,176.1,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M87,93c0.4,0.8,1.4,3.4,2.1,3.4c0.7,0,1.1,1.7,2.1,1.7c1.1,0,10.9-4.2,10.9-5.6 c0-3.9,6.2-11,10.6-12.7c1.4-0.5,8.9-1.9,8.9-3.7c0-3.9-6.9-7.3-9.9-7.3c-1.8,0-3.5,2-4.8,0.5c-3.1-0.4-4.5-2.4-7.6-3.4 c-2.6-0.8-4,1.2-5.7,1.2c-3.4,0-4.9-1.7-8.5,0c0.1,1.9,2.1,4.6,2.1,5.9c0,6.1-7.1,10.9-7.1,16.6C80.2,91.6,85.8,91.1,87,93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M121.6,48.4c-0.1,0-0.2,0-0.4,0c-1.1,0-2.3,0.9-2.8,1.9c0.5,0.4,1,0.6,1.5,0.8 c-0.4-0.1-0.7-0.1-0.8-0.1c0,0-1.3-0.2-2.4,0v2.5c0.5,0.2,1,0.5,1.6,0.7c-0.5-0.1-1-0.2-1.6-0.2c-1.4,0-2.1,1.4-3.5,1.7 c0.6,1.2,0,0.8,0,2.5c0,1.4,1,2.6,2.1,2.6c1,0,3.1,1.2,5,1.2c1.7,0,3.5-0.8,5.9-1.2c0-1,0.7-2,1.6-2.2c0.3,1.7,1.6,2.5,2.4,3.9 c-1.8,0-4-0.5-4,2c0,1,2.3,2.5,4,2.5c3.5,0,6.4-1.2,9.2-2.5c0.4-0.2,9.5-2.6,9.5-2.9c0-0.5,8.3,0.7,9.2,0.3 c1.3-0.5,4.7-5.6,4.7-8c0-2-1.6-4.2-3.3-4.2c-1.8,0-2.5,2-3.8,2c-2.7,0-5.4-3.7-5.4-6.3c0-0.3-0.1-0.8,0-2.2 c-1,0-1.8-0.5-2.7-1.2c-1.4,1.4-5.1,2.7-5.1,5.4c0,1.5,2.5,2.4,3.5,2.5v2.2c-0.4,0-1.3,0.3-1.4,0.7c0.6,0.3,1.3,0.5,2.8,0.5 c-0.6,1.5-1.3,2.2-3.1,2.2c-6.2,0-9.2-6.4-13.4-6.4h-3.2c-0.1-2-1.9-2.6-2.4-2.6c-1.3,0-2.1-0.5-4.7,0 C120.5,47.5,121,48.1,121.6,48.4z M125.5,52.1c-0.5-0.1-1.3-0.2-2.2-0.4C124,51.8,124.7,51.9,125.5,52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M106.1,54.8c0,1.2,1.3,2,2.4,2c1.8,0,4-3.6,4.2-5.9C111.3,50.8,106.1,52.1,106.1,54.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M125.9,44.7h3.1v-2.2h-4.9C124.1,44,125.2,44.7,125.9,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M95.7,50.9c1.4,0,2.3,1,4,0c0.3,0.7,1.3,2.5,2.4,2.5c1.6,0,2.7-1.9,3-3.7 c2.4,0.3,4.5-2.4,4.8-5.3c1.3,0.8,1.1,4.8,3.5,4.8l6.1-5.4c0-1.4-1-1.7-1.1-3.4c1-0.3,1.8-1.5,1.8-2.7c0-3-8.5-0.3-8.5-0.3 c-1.3-0.2-1.4-0.3-2.6-0.3c-4,0-4.7,4.4-7.4,6.3c-2.4,1.7-4.5,2-6.8,3.4c-0.6,0.4-3.1,2.7-3.1,3.1c0,0.5,1.1,1.4,1.4,2.5 C94.5,52.1,94.9,50.9,95.7,50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M136.1,28.6h6.1c1.7,0,2.7-1,3.8-1.7c-0.6-2.2-3-4.2-5.9-4.2c-1.8,0-10.3,3.7-10.3,5.9 c1.1-0.2,1.7-1.4,2.8-1.4C134,27.2,134.4,28.6,136.1,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M141.7,29.4c-3,0-11.6,0.3-11.6,4.2c0,1.5,2.4,4.6,4.5,4.6c3.1,0,7.8-1.5,7.5-5.1h-4 c2.1,0,4.5-0.5,6.1-2C143.9,30.4,143.3,29.4,141.7,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M126.2,34.8c1,0,1.4-1,2-2c-0.9-0.5-4.8-4.7-4.8-0.5C123.3,33.1,124.9,34.8,126.2,34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M196.5,83.7c0-1.7,0.4-0.2,0.4-2.5c0-1.9-4.1-0.3-5.2-0.2c1-1.5,4.5-2.9,4.5-6.3 c0-0.9-1-1.7-1.4-1.7h-5.7c-3.1,0-6.2-0.7-8.5,2c-0.1,0.5-1,0.8-1,1.4c0,2.2,2.7,1.9,4.5,2.2v4.6h-2.1c-2.4,0-4.5-2-6.4-2V84 c4.1,4.9,8.5,4.2,12.5,9c0.9,1,1.1,2.9,3.1,2.9c1.3,0,1.5-2,2.8-2.5c4.5-2,5,0.4,5.7-8.8C198.9,84.2,197,83.8,196.5,83.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M168.6,45h-1.7c0,0.8,0.2,1.5,0.5,2l-0.2-0.3v3.1c1.1,1,2.1,2.2,3.5,1.7l0.4,1.7h2.1 c0,1,0.7,2,1.7,2c2.8,0,7.8-1.7,10.3-1.7c0.6,0,1.3,0.2,1.7,0.5c-0.8,1-3.5,1-3.5,2.5c-0.1,0.5-0.1,1.2,0,1.7 c-0.6,0.3-1,1-1,1.7c0,1.5,3.7,0.9,4.5,0.9c0.4,0,3.5,0,5.7-0.9c-0.6-4.7,1.1-6.8,1.1-10.7c0-2.6-0.3-4.3-2.8-4.3 c-1.1,0-1.7,1.4-2.8,1.4c-2.7,0-4.1-1.7-6.4-1.7c-1,0-1.6-0.4-2.6,0.2c0.6,2.4,2.6,2.4,5,2.4v3.7c-3.5,0-4.7-3.7-7.8-3.7v2 c0.6,0.8,1.7,2,2.8,2.9C174.8,53.7,172.7,45,168.6,45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M190.5,114.5c-0.6,0.2-3.1-0.5-3.1,0.8c0,0.5,10.5,5.1,12.3,5.1c1.6,0,2.1-1.7,3.5-2.7 c-0.8-2.4-6.6-8.7-8.8-8.7C191.7,109.1,192.2,113.8,190.5,114.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M209.6,69.3c-3,0-3.8,2.4-3.8,2.5c0,0.5-0.3,1.5,0,1.7h-3.2v2.9c1,3.4,0,5.4,2.3,8.1 c-0.1,0.8-0.1,2.9-0.1,5.1h2.8c1.7-2,2.8-2.5,3.3-5.6h-1.8c0.9-3.4,0.9-1.2,4-1.2c4.2,0,6.2-3.7,8.1-6.8c0,0,2.6-2.2,2.6-2.6 c0-0.8-0.1-1.3,0-2.2C218.4,71.3,214.4,69.3,209.6,69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M165.1,39.9c1,0,1.8-0.8,2-2c-3-1.2-3.2-4.8-6.9-4.8C160.1,35.3,163.5,39.9,165.1,39.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M164.4,60.6c1.1-0.2,1.4,0.2,2.8,0.2c0.8,0,2.1-0.2,2.1-2.2c0-1.2-0.7-1.7-1-2.5 C166.3,56.9,164.9,57.7,164.4,60.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M164.4,20.1c-0.1,0.7-0.6,1.4-1,1.7c1.1,1,1.8,0,4.9,0c-0.3,0.5-0.3,1.5,0,2 c-1.7,0.7-3,0.5-4.2,2c1.3,1.5,1.8,1.3,3.8,1.3c2.1,0,4-0.9,4.7,0.7c2.5-0.3,4.1,0.7,6.6,0.7c3.3,0,3,4.2,6.4,4.2 c1.1,0,2.6-0.5,2.6-2.2c0-1.9-2.8-3.2-4-4.6c0.3-0.5,0.8-1.2,1.1-1.7c-0.7-0.8-2.3-3.9-4.2-3.9c-0.8,0-1.3,1.4-2.1,1.4 c-1.6,0-1.4-3.9-4.2-3.9c-1.1,0-1.7,1.4-2.8,1.4c-1.7,0-2.4-3.1-5.4-3.1c-1.7,0-2.8,1-4.5,1.4C162,19.6,162.4,20.1,164.4,20.1z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M176.1,30.6c-0.6,0-3.8,2.5-1.3,2.5c2.1,0,3.8,0,4.5-1.2C178.1,31.4,177.7,30.6,176.1,30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M229.2,63.3h1.7c-0.3,2.9,4.1,3.4,7.1,2.5h11.3c1.3-1,1.6-1.9,3.5-2.2c0.3,1.2,1,2.5,2.8,2.5 c5,0,11.3,0,11.7-5.9c0,0-0.8,0.2-1.8-0.2c0.2-0.7,0.4-1.2,0.7-1.6c0.4,0,0.9-0.2,1.1-0.3c-2-4.4-5.7-4.7-11.3-4.7 c-7.4,0-9.9,4.2-17.7,4.2c-3.5,0-6.4-1-9.8-2c-0.6,0.5-2.3,1.5-2.3-0.9c0-0.5,0.7-0.5,1-0.9c-2-1.9-5.5,0.7-6.4-3.9h5.7 c-1.3-2.2-7.8-1.2-6.7-5.1h-2.5c-0.6,1-1.4,1.4-2.8,1.4c-4.8,0-5.9-5.9-12.3-5.9c-1.7,0-4.2,0-4.2,2.5c0,1.5,8.6,5.9,10.2,5.9 c1.1,0,2-0.7,2.8-1.7c2.4,2.9,3.1,5.6,5.7,8.6c-0.6,0.3-1.7,1.5-1.7,2.7c0,3.4,7.1,7.6,10.2,7.6 C226.5,66.2,228.6,64.2,229.2,63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M211.1,59.9c0-2.2-3.4-5.6-5.9-5.6c-3.3,0-2.7,3.9-4.2,3.9c-0.3,0-1.8,0.9-1.8,2.6 c0,0,8.2,4.6,9.2,4.6C210.2,65.3,211.1,62.8,211.1,59.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M211.5,35.3v-2.2c-1.4,0.3-0.3,0-1.8,0c-2.7,0-7.8,0.3-9.2,2c0,0,8.2,1.9,8.9,1.9 C210.6,37,211.5,36.2,211.5,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M196.6,29.4c-0.4,0.2-1.4,0.8-1.4,1.7c0,2,5,1.4,9.9,0c-0.4-1.9,0-3.1,0-4.2 c0-3.6-4.9,0.2-4.9-3.9c-1.6,0-4.5-1.2-5-2.5c-1.4,0.2-3.2,0.9-3.2,2.5C192,26.3,194.9,27.4,196.6,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M189.6,12.5h2.4V9.1c-1,0-3.1-0.2-5,0C187,11.1,188.7,11.4,189.6,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M207.5,9.1c-1.3,0-3.5-1-4.2-1.7h-2.1c0.4,4.9,3.4,5.4,8.2,5.4c-0.8,1.4-1.8,1.5-3.3,2.2 c0,1,0.1,1.7,1.1,1.7c1.1,0,1.6-0.7,3-1.4c0.4,1,0.6,2.2,2,2.2c1.7,0,2.1-1.4,4.2-1.4c2.1,0,3.7,0.7,5.8,1.4 c-2,0.5-10.7,0.2-10.7,3.4c0,2.5,4,4.2,6.4,4.2c-0.4,0.5-0.9,1-1.8,1.2c0.3,2.4,3.4,3.1,5.7,3.1c2.1,0,3.4-0.9,3.4-3.9 c1.3,1,3.8,3.2,5.1,3v-2.2h2.5c-0.4-1.4-1-1.7-1.8-3.4c0.7-0.8,1-1.7,1.7-2.5c0.4,1.9,0.4,3.4,2.3,3.4c1.8,0,3.8-5.1,6.6-5.4 c1.1-0.2,2.7,0.2,3.3-0.8c0.4-0.7,0.1-1.4,0.1-2.5c-1.8-0.2-5.5-2.2-6.9-2.2c-0.3,0-2.4,1.5-2.4,0c0-1,1-1.4,1-2.5 c0-1.2-1.7-1.4-1.7-2.5c0-2,0.1-2.9-1.8-2.9h-1.4l0.7,1.2v2.2h-1.7c-1.3-1.5-0.4-3.7-2.5-4.7c-2.1-1-3.5,0.7-5.7-0.3 c-2.3-1-1.7-5.9-4.5-7.3c-2.6-1.2-5.4-1.5-8.9-1.9c0.1,2.4,2.6,2.5,4.2,3.6h-2.4c-2.6-0.7-3.7,0.3-5.4,1.5 c0,0.2,1.3,2.7,1.8,2.7c0.9,0,2.5-1,4,0c-0.4,0.5-0.7,1.7-1.6,1.7c-1.1,0-1.8-1.2-3.8-1.2c-1.3,0-3.2-0.2-3.2,1.7 c0,1.9,4.4,3,6.2,3.7C208.8,7.7,208.1,9.1,207.5,9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M259.2,154.9c-0.7-0.7-0.3-1.9-1-3.1c-2.5-4.1-7.1-2.4-10-6.8c-0.4,0.3-0.8,0.7-1.3,1.4 c-0.7-1.7-1.4-2.2-2.1-4.8c-4,0.5-4.7,7.3-4.7,10.2v2.5c0,1-0.7,1.5-1.4,2.2c-0.3,0.8-2,0.5-2.1,3.4c1.1-0.2,3.8-0.7,6.1,0 c-0.3,1.7-0.7,3.4,1,3.4c0.7,0,0.7-0.5,1.1-1.4c2,1,6.7-2.5,6.7-6.3c0.8,0.3,5.4,4.3,5.4,4.3h3.8c1.8,0,3.1-0.7,4.7-1.9 C264,156,261.4,156.9,259.2,154.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M286,126.9c0-5.6-8.8-6.8-8.8,0c0,2,1.4,3.7,3.5,3.7C282.5,130.6,286,129.1,286,126.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M254.2,164.5c-0.1,1-2,2.5-3.1,4.2v2.2c2.3-0.3,5.8-3.7,7.1-5.8 C256.5,164.4,257,164.4,254.2,164.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M269.5,82.8c2.4,0,3.7-1.7,5.2-1.7c1.6,0,2.4,1.2,4.2,1.2c1.3,0,2.1-1.2,2.5-2.7 c-2.5-1.5-5.8-5.2-9.6-5.2c-3,0-4-1.4-7.1-1.4c-1.1,0-2.4,0.8-2.4,2.5c0,1.9,1.6,2.7,2.8,3.6C264.3,82,266.7,82.8,269.5,82.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M266.2,174.3c1.4,0,1.7-2.4,2.6-3.7c-1.4-2-4.7-1.9-4.7,1.2C264.1,171.8,266,174.3,266.2,174.3z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M292.1,125.7c-0.4-0.7-1.6-2.7-2.8-2.7c-0.3,0-1.8,1.2-1.8,1.7c0,1,0.8,1.3,1.8,1.3 C290.7,126,290.3,126.2,292.1,125.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M272.3,113.2c-1.7,0-4.9,3.9-3.3,3.9C270.8,117,271.9,115.2,272.3,113.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M302.7,97.6c0.4-2.9-3.1-3.4-4.7-3.4h-3.5c-4.7,0-5.7-5.8-8.8-8.5c-1.8-1.5-7.9-2.5-10.6-2.5 c-2.5,0-3.2,4.2-5.7,4.2c-1.3,0-1.7-1.7-3.3-1.7c-1.4,0-2,1.7-2.8,1.7c-0.7,0,0-2.7,0-3.4c0-3.7-2-9.7-5.7-9.7 c-5.7,0-15.1,2-15.1,8.5c0,1.7,1.4,2.9,1.4,4.6c0,1.4-2,3.4-2.8,3.4c-1.7,0-1.4-1.5-1.4-2.9c0,0-0.3-1.9,0-3.1 c-0.7,0-1.1-0.7-1.1-1.7c0-4.9,4.7-5.3,6.1-8.8c-0.1,0-4.7-1.7-4.7-1.7c-4.8,0-8.5,2.9-11.3,6.3c-0.6,0.7,0.1,3.7-1,4.8 c-2.1,1.9-2.8,2.9-2.8,7.6c0,1.5,2.1,4.6,2.1,4.6s6.5,0.7,7.8,1.7v2.2c-2.4-0.3-4.5-1.4-6.4-0.5c0.3,2.4,2.4,2.7,3.1,5.1h6.8 c0.9,1.4,3.1,3.4,4.2,3.4c6.4,0,17.1-0.5,21.5,0c-0.1,1.2-0.7,3.9,1.1,3.9c2.5,0,4.8-6.4,6.7-6.4c1.6,0,9.2,7.8,10.5,9.3 c-0.9,0.2-3.4,0.5-3.4,2.2c0,0.3,0.6,2,1.1,2c1.8,0,2.7-2,4.5-2c3,0,12,8.3,12,12.7c0,2.4-3,6.1-4.2,7.6 c-1,1.2-3.5-0.3-3.5,2.6c0,1.4,1.8,3,2.5,3.5c-1.7,1.4-5.1,2.4-6.4,2.4H279c-2,0-5.7,2.9-5.7,4.6c0,2.4,4.5,4.8,6.1,4.8 c1.7,0,2.5-2.6,4.3-2.6c1.3,0,1,1.2,2.4,1.2c1.3,0,2.1-1.4,2.8-2.5c4.1,2.9,6.4,6.1,11,8.5c-2.4,5.4,6.1,5.3,9.5,7.6 c3.5,2.5,6.2,1.5,10.3,3.9c0.4,0.2,0.7,2,1.4,2c0.6,0,1.4-0.9,1.4-2c0-4.7-7.9-8.3-10.3-11.9h2.1c1.6,2.4,10.6,6.4,13.2,6.8 c0.6-1.9,2.1-5.1,2.1-6.8c0-1.9-2.5-2.7-2.5-3.9c-0.1-0.7-0.1-0.7,0-3.4h-2.4c-0.3-2.9-1.3-0.9-4-2c-1.1-0.5-2.8-4.3-3.1-6.5 h-1.8v-2.5c0.6,0.5,1.3,0.3,2.1,0v-2c-1.3,0.3-1.5,0.5-2.8-0.3c0.1,0,2-1.9,2.8-1.9c6.8,0,7.1,11.5,14.1,11.5 c1.6,0,1.8-2.9,1.8-4.8c2.7,0,3.1-1.5,3.1-2c0-0.9,0.1-0.3,0-2.2c1.8,0,4.2-0.7,4.2-2.9c0-2.7-1.1-3.9-3.8-3.9 c-0.7,0-1.8,0-2.5-0.8c-1.1-3.2-1.8-0.9-4.9-0.9c-2.1,0-2.8-2.9-3.1-5.9c-3-0.3-6.8-2-7.1-5.9c-1.8,0-2.7-0.5-4-1.3 c1.3-2.5,2.4-2.5,4.7-3.9c-0.4-1-1.4-1.5-2.1-1.5c-1.3,0-1.8,0-4.2-0.3c1.1-2,3-1.9,5-2.4c-0.9-2.4-2-4.1-4-4.1h-2.4v-2.9 C308.7,101.8,306.6,99.1,302.7,97.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M272.6,161.5c1.4,1.4,1.8,1.4,3.3,0C274.2,160.5,274,159.3,272.6,161.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M249,140.8c-0.1,1.2,1,2.5,2.8,2.7C250.8,142,250.8,139.8,249,140.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M223.1-9.6h4.2c-1.7,0.7-2.5,1.2-4,2.9c0.3,0.2,1.8,1.3,2.5,1.3c2.7,0,2.8-3,5.7-3 c1.1,0,1.6,0,2.8,0.4c-3.7,1.3-7.2,0.8-8.8,5.2c1.1-0.2,4,0,6.7,0c-1.8,0.2-2.8,1-3.8,1.9c1,1.5,5,3.6,7.8,3.6 c1.3,0,2.1-0.8,3.1-1.7h1.8c-0.9,2.2,2.8,3.4,5.7,3.4c1.1,0,1.7-1.7,2.8-1.7c1.4,0,2.3,1.4,5,1.4c4.5,0,7.8-1.2,10.6-3.9h2.1 c-1.7,2.5-4.1,3.4-6.8,4.7h-7.1c-0.3,0.5-1,1-1,1.7c0,1,4.5,4.4,5.2,5.2c-4,0.5-5.2-4.4-8.8-5.7c-2.8-1-5.9-0.3-7.5-0.3 c-0.7,0-1.4-0.3-2.1,0c0.3,1.3,0.6,2,2.1,2c-1.4,0-3.5-0.3-3.5,1.4c0,3,9.6,3,9.6,8.5c0,4.7-4.2,3.2-7.8,4.6 c-2.1,0.8-3.1,2.7-4.2,5.6v2h2.1c0.6-0.7,0.6-0.7,1.4-1.2h2.1c0,4.1,4.4,6.1,6.4,8.5H245c-2.7-1.9-4.2-4.7-8.8-4.7 c-1.4,0-3.5-0.7-3.5,1.7c0,3,3,3.6,4.7,5.1c-3,2.5-10.3,0-10.3,6.8c0,0.5,0.4,1.4,1.4,1.4c0.7,0,1.3-0.9,1.7-1.7 c4.9,1.9,8.8,3.4,13.4,3.4c2.1,0,3-1.7,4.2-1.7h10.6c2.8,0,1.4,2.5,4.7,2.5c3.3,0,11.3-3.1,11.3-5.9c0-1.5-1.7-1.4-2.1-1.4 h-3.5c0-5.8,5.9-2.5,5.9-8c0-1-0.7-1.4-1-2.5h7.1c2.4-2,3.4-6.1,6.4-7.8c-0.9-2.4-2.4-3.1-4.1-4.1c2.7,0.3,4.4,0.7,4.1-3h-4 c2.3-2.2,5.8-2.6,8.9-3.7c2.3-0.8,5.4,1.2,7.4-0.5c4.2-3.7,7.5-10.5,13.2-12.7c5.1-2,13-4.4,16.3-8.3 c-3.5-0.2-9.2,1.2-10.6-0.5c7.5-4.4,14.4-1.4,20.1-6.4c1-0.8,3.5-0.3,3.5-2.5c0-3.1-7.5-2.2-9.2-4.3c-0.9-1-0.9-2.4-2.4-2.9 c-1-0.3-1.6-0.7-2.5-1.4l-11.3,3.9c1.1-0.3,1.6-0.7,2.6-1.9c-2.8-3.4-15-2.9-18.4-2.9h-4c-1.3,0-2.1-1.2-4.2-1.2 c-2,0-2.5,2.9-4.5,2.9c-2.1,0-2.8-2-5.4-2c-0.7,0-1.4,0.5-1.7,1.2h-16.3c-1.4,0-2.5,0.5-3.3,2.2c-1.8,1.9-0.4,0.3-2.8,0.3 c-4.1,0-5.8,3.6-7.1,7.6c-1.3-0.5-6.8-3.7-9.5-3.7c-3,0-1.1,3.7-5.7,3.7c0,0.7-0.6,1.4-1.1,1.4H232c-4.1,0-13.3,2-14.2,6.3h3.1 C221.4-8.7,222.2-9.2,223.1-9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M499.4,105.4c-3-1.2-15.6-0.5-15.6-5.6c0.7-0.2,3.1-0.7,3.1-2.2c0-1.3-1.4-1.9-1.4-4.2 c0.7,0.5,1.4,0,2.1,0c5.8,0,4.4,8.5,11,8.5c1.5,0,3.8-0.2,3.8-2c0-9.7-9.1-12.5-14.2-18.6v-2.6c0.3,0,0.7,0.2,1.8,0 c0.9,3.2,5.2,7.6,7.8,7.6c1.7,0,2.1-2.7,2.1-4.8c0-4.6-6.4-3.1-7.8-7.6h2.1c1.1,1.9,2.7,2.7,4.2,3.9c1.1-3.6,6.8-1.4,7.8-6.4 c-0.7-0.3-1.4-1.4-1.4-2.5c2.7-0.3,5.5-1.9,6.4-4.6c-1.7-0.7-5.7-0.5-5.7-3.4c0-2.2,2.3-2.2,4.5-2.2c-0.7-1,0-2.4,0-3.7 c0-2.5-2.1-3.6-2.1-7.3c-2,0-4.5,0-4.5-2.9c0-1.2,1.3-2.5,2.8-2.5c2.6,0,9.9,1.5,9.9-2.5c0-4.1-5.5-3.2-6.1-5.9 c0.9,0,1.8-0.5,2.5-1c-1.4-1.3-3.4-3.2-5.7-3.2c-1.6,0-2.7,0.9-4.2,0c0.8-1.7,0.7-5.8,2.4-7.3c2.7-2.4,5.7-3.6,5.7-7.1 c0-0.7,0.1-0.7,0-2.5c2.7-0.9,6.4-1.5,6.4-4.2c0-1.7,1,0.2,0-2.2c2.6-0.7,6.4-0.7,6.4-5.4c-1.1,1-1.3,1-3,0 c6.4,0,9.3-4.9,14-6.8c0.8-0.4,3.5-1.9,3.5-3.9c0-2.2-6.6-5.9-8.5-5.9c-1.4,0-2.4,0.2-2.8,2.2h-6.8c-2.3,1.4-2.7,2.2-5.2,3.4 c-0.6,0.2-3.2-0.5-3.2-0.5h-9.5c-2.3,2-9.4,13.2-13.1,14.4c0.4-1.7,9.6-13.2,9.6-14.7c0-2.6-1-5.1-3.5-5.1 c-4.7,0-13.1,9.7-16.6,9.7c-1.1,0,5-7.1,5.3-8.5c-2.5-1.2-26.3,2.2-28.7,0l31.1-2c3.8-1.7,13.4-0.8,14.2-6.8 c-3.5-1-8.5,0.2-12.3-1.7c-6.6-3.4-12.9-9.8-21.2-9.8h-20.5c-7.2,0-12.7,4.8-19.5,4.8c-2.1,0-3.5-0.3-5.7,0v2h-2.8 c-3.1-1.4-5.4-1.2-8.8-1.2c-4.7,0-8.2,1.2-12,3.4c0.7,1.2,1.8,1.4,2.8,2.5c-1.3,0.3-5.7-0.5-5.7,2c0,3.2,5.8,5.4,8.1,6.8h-6.4 c-3.5-2-6.9-5.9-12.7-5.9c-1.4,0-3.5,0.2-3.5,2.2c0,1.4,0.7,2.4,1.1,3.7h-2.1c-2.8-1.3-5.2-1-6.8-4.2l-1.4,1.7 c0,1.2,0.7,2.2,0.7,3.4c-2.7,0-3.4-5.1-5.9-5.1c-3.8,0-6.6,2.7-10.6,3.9c-5.4,0-7.5,1.7-13.2,2.5c-4.5,0.7-0.7,8.5-5.7,8.5 c-1.4,0-2.5-0.4-3.7-1.4c-2.8,3.4-9.2,7.5-14,9.3c-0.7,0.2-2.8,1-2.8,2.6c0,3.2,8.1,3.1,10.6,3.4c0,4.2-1.6,7.3-3.8,9 c-3.1,2.2-8.2-0.4-12,1.2c-2.7,1-4.3,2.9-6.8,3.9c-3.1,1.2-8.1-0.7-8.1,4.6c0,2.7,13.6,7.3,14.1,7.3h5c0.7,0,1.1-0.8,1.4-1.7 h5.7c-0.4,1.9-0.4,2.5-1.8,3.7h-8.1c-0.7,1.2-1.1,1.4-2.5,1.4h-3.5c-1.1,0-4,1-4.3,3.4c2.7,1.2,1.8,0,5,0 c1.7,0,3.4,1.9,5.7,2.9c-0.6,1.5-1.6,1.7-2.8,2.7c1.7,2.5,6.2,4.1,9.2,4.1c1.1,0,1,0.5,1.8-0.5c-0.4-0.2-1-0.9-1.4-1.4 c0.7-0.3,1.3-0.7,2.8-0.7c1.7,0,3,1.4,4.2,1.4c1.8,0,2.7-2.2,4.5-2.2h4.2c15.8,0,25.7,14.8,29.7,29.3v2.5 c1.3,0.2,3.5,0.3,3.5,2.9c0,3.9-3.1,3.6-3.1,7.3c0,2.5,1.3,2.9,3.8,2.9c1.8,0,2.3-2.9,3.5-2.9c4.7,0,5.9,8,10.3,9.7 c-0.1,1,0,2.6-1.4,2.6c-3.4,0-5.5-2.6-8.5-2.6c-1.3,0-1.1-0.7-2.6,0c0.6,4.8,10.9,5.6,15.3,7.3c-1.3,4.8-3.4,6.4-4.2,11.5 c-2-1-2-0.8-4,0.3v0.3c-2.8,2.7-3.7,6.1-5.7,9.3v3.9c0.8-0.9,1.8-0.7,2.8,0c-0.4,1.7-1.4,2.5-1.4,4.2c0,4.6,3.8,6.4,4.7,9.7 c0.4,1.7,0.9,4.9,1.4,5.6c2.4,1.5,3.1-2.7,5.2,0.5c-1,1.2-2.1,1-2.1,3.2c0,4.9,5.4,12.6,8.2,15.3c0.4,0.3,0.1,2.7,1,3.4 c2.3,2,3.7,0.9,4.7,4.7c1.7-0.2,4-2.2,5.9-2.2c3.5,0,3.3,7.6,6.8,7.6c0.9,0,1.1-1,2.8-1.2c0.3,1,0.7,1.7,1.7,1.7 c3.8,0,2.1-8.8,5.4-10.7c-0.3-1.9,0-6.3,0-9.3c0-4.9,6.6-3.1,6.6-8.8c0-1.9-1.7-2.7-1.7-3.9c0-0.8,0.6-1.4,1-2 c0-0.5-0.3-1.2-0.3-1.7c0-5.6,7.6-4.1,10.6-7.6c1.3-1.5,0.7-3.2,2.8-4.2v3.4h2.1c3-2.5,7.8-1.7,10.6-5.1c2.1-2.5,2.3-5.9,5-8.5 l3.5-3.1c0-1.4,1.4-1.9,2.8-2.9h6.7c5.4-2.7,9.5-2.2,14.6-4.2c4.1-1.5,5.5-6.3,10.2-8.1C495.9,107.6,497.3,107.4,499.4,105.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M370.7,112.8h3.1c2.4,0,5.4-0.5,5.7-3.4c-3.7-1.4-4.8-5.9-8.5-5.9c-1.3,0-3.1,0.8-3.1,3.4 C367.8,108.9,369.4,112.6,370.7,112.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M513.8,56c-0.4,0.5-1.4,1.2-1.4,2.2c0,0.9,0.9,2.6,1.8,2.6c1.4,0,3.8-2,4.5-2.6h-2.4V56H513.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M364.7,245.4c0-0.7-0.4-1.7-1-1.7c-2.3,0-3.1,2.9-4.3,5.1c-2.1,3.9-3.7,11.5-7.6,13.9 c0.1,0.5,0.7,0.9,1.1,0.9v1c0,0.2-2.5,2.6-2.5,3.2c0,0.5,0.7,1.7,1.4,1.7c1.7,0,2.3-1,4.4-1c1.6,0,2.4,1.2,4.2,1.2 c1,0,1.8-0.3,2.8-0.8c0.7,1.7,2.6,0.7,4,0.7c-0.4,1-1.6,1-1.6,2.7c0,0.3,0.6,0,0.9,0c1.7,0,3-2.5,4.1-4.6 c1.1,1.4,0.3,4.6,1.4,4.6c0.4,0,0.7,0.3,1.1,0.3c0,0.7,0.3,2,1.3,2c1.4,0,2.3-2,2.3-4.1c0-1.7-1-1.5-1-3.6 c-0.9,0.7-0.4,1-1.8,1c0-1.2-1-1.9-1-2.7c0-0.7,1.3-1,1.4-2.6c-0.6,0-1.3,0.2-1.6,0.5c0-2.5,0.1-4.1,0.1-5.6 c-0.7,0.5-2.5,0.5-4.1,0l-1.7,0.7v-0.8h-2.5v-1.5l0.7-0.8c-0.6-0.7-1.4-0.9-2.3-0.9c-1,0-1,1-2.1,1.4V254 C361.7,251,364.7,249.1,364.7,245.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1147.4,60.8c1.4,0,2.1-1.5,3.1-2.6c0.7,1,1.3,1.7,2.6,1.7c1.4,0,2.3-1.3,3.1-1.3 c1.1,0,1.7-1.2,2.8-1.2c1,0,1.6,1.7,2.6,1.7c1.7,0,2.4-1.7,3.5-1.7h3.8c0-1.3,2-3.2,2.5-5.6c-3-1-11.3-4.6-13.9-4.6 c-1.7,0-2.4,2-2.4,4.6c-3.8,0-4.1-5.4-8.5-5.4c-3,0-6.4,2.9-6.4,6.8C1140.3,57.2,1143.7,60.8,1147.4,60.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M262.7,236.9c0.1,0,0.7,0.2,0.7,0c0-2.4-2.4-2.9-4.8-2.9c0.1,0.3,0.1,0.8,0,1.2 C259.4,236.2,261.4,236.9,262.7,236.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M78.9,258.6c2.3,1.7,7.2,6.3,10.5,6.3h1.3v-1.5c-3.7-4.4-7.1-8.5-13.2-10.9 c-1-0.3-2.3-2.4-3.8-2.4c-0.7,0-1.4,0.5-2,0.8h0.6c0,0,1.4,0.5,2.1,0.7c-0.2,0.5-0.7,1.2-1.4,1.5c0.6,2,4.5,3.7,7.4,3.7 C79.9,257.4,79.2,257.4,78.9,258.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M57.7,235.6c0-0.9-0.7-1.2-0.7-2c0-1.7,0.3-2.7,0-3.7c-0.3,0.8-0.8,2.2-1.8,2.2 c-0.8,0,0.8-1.9,0.8-2c-1.3-0.2-2-1.2-3.3-1.2v1.4c0.6,1,1.1,3,1.7,3c0.9,0,1.1,1.9,2.3,2.2c0,0.3-0.6,0.9-0.6,1.9 c0,1.4,0.8,3.2,2,3.2c1.4,0-1.1-2.5-1.1-3.2C57,236.6,57.7,236.2,57.7,235.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M649.4,324.1c-2.1-0.5-3,1.1-4.8,1.1c-2,0-3.3-2.2-6.2-0.5v1.2c0.4,0.8,1.6,0.7,2,0.8 c2.3,0.8,4.1,3.7,6.5,4.4c0,0.5,0.7,0.7,1.1,0.7c0.4,0,0.8-0.7,0.8-1.2c0-1.4-0.7-1.5-0.7-2.7c0-0.7,0.7-1.9,0.7-1.9 L649.4,324.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M625.5,305.2c0.4-1,0.8-4.7,1.3-6.8c-0.4-0.2-0.6-1-0.6-1.9c-0.7,0.2-1.3,1.7-2.3,1.7 c-0.3,0-0.7,0.3-1,0.3C623.6,300,624.1,304.9,625.5,305.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M623.3,312.2c0,1.2-0.7,2-0.8,3.4c0,1.4,0,3.5,1.4,3.5c1.1,0,3.7-2.4,3.7-4.8 c0-2.7,0.4-4.2-0.9-6.9c-0.4,0-0.9-1-1.8-1c-1.3,0-1.4,1.7-3,2.2C622.1,310,623.3,310.8,623.3,312.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M602.1,315.9c0-0.5-0.7-1.5-0.7-1.9c-0.8,0.2-1.4,0.7-2.3,1.2c0.1,0.2,1.3,1.5,1.8,1.5 C601.4,316.8,602.1,316.4,602.1,315.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M632.1,220c0-1.7-1-1.4-1-3.4h-2.7v1.7c0,1.7,1.6,2.2,3.3,2.2v1.4 C631.8,221,632.1,221.3,632.1,220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M633.8,221.7l-0.3-0.7c-0.2,0.2-0.6,0.5-0.7,0.9c0.1,0.2,1,1,2,1c3.1,0,2-5.9,4.4-6.8 c-0.7-2.9-0.9-4.4-3.7-4.4c-1,0-2.7,4.4-2.7,5.1c0,1,1.6,2.4,3,2.7C635.8,220.3,634.8,221.5,633.8,221.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M664.2,199.3c-2.5,0.2-3.2,3.2-3.2,4.2c0,0.9-0.4,1.5,0,2.2c1-1.5,2.1-2.4,2.1-4.2 C663.1,200.6,663.9,200,664.2,199.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M677,198.4c0.6,0,2.4-1.2,2.4-1.7v-2c0.3-0.2,1-1.3,1.1-2.2c-0.6-0.3-0.8-0.7-1.6-1.7 c0,0-1.3,0.9-1.3,1.7c0,0.9,0.6,1.4,1,2c-1.1,0.2-2,1.2-3.1,1.4C675.6,196.9,675.7,198.4,677,198.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M693.2,340.5c-2.4-0.8-5.8-1.7-8.9-1c1.6,1,4.2,1.4,5.4,1.4 C690.7,340.8,691.4,341.7,693.2,340.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M726.6,337.4c-2.4,0.5-6.1,2.2-8.2,3.4c0,0.3,0.4,0.9,0.7,0.9c0,0.5,0.6,0.8,1,0.8 c1.3,0,4-0.8,4.4-1.9c0.1-0.5-0.2-1.5,0.3-1.7C725.6,338.5,726.3,339.1,726.6,337.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M803.9,459c1.1,0,2.3-1.4,2.5-2c-1.8,0-2.8,0.3-4.1,0.8C802.5,458.6,803.5,459,803.9,459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M782.4,111.1c-0.3,0-1.8,3.2-1.8,3.9c0,1.7,0.8,2,2.5,2c2.4,0,4.1-1.7,5.9-2.9V112 c-2-0.3-3-2.5-5-2.5C783.4,109.4,783.1,111.1,782.4,111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M823,104c0,2,3.1,4.2,5,4.2c0,0,1.8,0.3,1.8-0.9C829.8,104,823,100.6,823,104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M875,76.7c-1.4-1.4-1.8-3.2-3.5-3.2c-1.3,0-2.1,1.9-2.1,3.4c0,0.5-0.4,1.7,0,1.7 C871.1,78.6,874.3,77.4,875,76.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1161.8,75.2h4.2c-0.1-3.9-3-6.8-6.6-6.8c-3.3,0-5.1,2.4-6.8,5.1l0.7-0.8 C1156,73.8,1159.3,73.5,1161.8,75.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1189.8,60.3c2.3,0,6.4-0.7,6.4-2.5c0-0.8-0.6-1.7-1.4-1.7c-0.6,0-15.4-2.2-16.7-3.4l1.4,1.3 C1179.5,58.2,1186.2,60.3,1189.8,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1156.2,66.2c0-2.4-3.8-2.7-3.8,0c0,1.5,0.1,2.2,1.7,2.2C1155,68.4,1156.2,67.6,1156.2,66.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M339.8,259.1c-3-2-5.7-5.2-10-4c1.7,1.5,5.8,5.1,8.1,5.1C339,260.1,339.4,260,339.8,259.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M331,273.4c-0.3,0.2-0.6,0.7-0.6,1.2c0,1.2,5.2,4.4,6.2,4.4c0.3,0,1.7-0.9,1.7-1.9v-1h-4.2 C332.7,275.7,331.7,275.1,331,273.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M347.3,279v-1.2c-3.3,0-1.1-1-1.1-2.5c0-0.7-0.7-1-1-1.7c-1.3,0.5-3.3,4.7-3.3,5.8 c0,1,0.9,1.9,2.3,1.9C345.7,281.2,347.3,280.1,347.3,279z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0AD"
    },
    d: "M181,566.4c6.8-0.7,12.4-6,12.4-12.6c0-0.3,0-0.4,0-0.7c0-6.6-6.7-12.1-14.9-11.3 c-30,4.3-54.8,14.5-79,32.7c-6.4,5.2-7.3,13.8-2.6,18.5c0.2,0.2,0.3,0.3,0.5,0.5c4.7,4.7,12.4,4.5,17.7,0.2 C135.7,578.4,155.6,570.2,181,566.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0AD"
    },
    d: "M149.5,552l11.4,25.9c-2.2,1-3.5,1.7-3.5,1.7s20.9,45.6-4.4,57.9 c-40.3,19.6-56.1,4.9-56.1,4.9l-32,15L45,607.8c0,0,27.2-12.9,34.4-18c7.2-5,26.2-20.7,53.9-31.5 C139,556.1,144.5,554,149.5,552z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F1E6"
    },
    d: "M44.6,606.8l22.9,52.2c0,0-5.2,2.3-14.2,6.2l-23-52.4L44.6,606.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59A6C3"
    },
    d: "M-82.1,734.2c69.4-34.2,136.3-67,136.3-67l-0.9-2.1l-23-52.4l-2-4.6L-67,647.3L-82.1,734.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M96.4,594.8c-7.2,3.1-10.5,11.5-7.4,18.7l16.4,37.9c3.1,7.2,11.5,10.5,18.7,7.4l101.9-44.1 c7.2-3.1,10.5-11.5,7.4-18.7L217,558c-3.1-7.2-11.5-10.5-18.7-7.4L96.4,594.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M200.6,611.9c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C202.6,611.9,201.5,611.5,200.6,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M197.4,604.5c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C199.4,604.5,198.3,604.1,197.4,604.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M194.2,597.1c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C196.2,597.1,195.1,596.7,194.2,597.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M191,589.7c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C193,589.7,191.9,589.3,191,589.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M187.8,582.3c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C189.8,582.3,188.7,581.9,187.8,582.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M184.6,574.9c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C186.5,574.9,185.5,574.5,184.6,574.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M181.4,567.4c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C183.3,567.5,182.3,567,181.4,567.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M193.9,611c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C195.9,611,194.9,610.6,193.9,611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M190.7,603.6c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C192.7,603.6,191.7,603.2,190.7,603.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M187.5,596.2c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C189.5,596.2,188.4,595.8,187.5,596.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M184.3,588.8c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C186.3,588.8,185.2,588.4,184.3,588.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M181.1,581.4c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C183.1,581.4,182,581,181.1,581.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M177.9,574c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C179.9,574,178.8,573.6,177.9,574z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M189,616.9c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C190.9,617,189.9,616.6,189,616.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M185.8,609.5c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C187.7,609.6,186.7,609.1,185.8,609.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M182.6,602.1c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C184.5,602.2,183.5,601.7,182.6,602.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M179.3,594.7c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C181.3,594.7,180.3,594.3,179.3,594.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M176.1,587.3c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C178.1,587.3,177.1,586.9,176.1,587.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M172.9,579.9c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C174.9,579.9,173.8,579.5,172.9,579.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M169.7,572.5c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C171.7,572.5,170.6,572.1,169.7,572.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M182.3,616.1c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C184.3,616.1,183.2,615.7,182.3,616.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M179.1,608.7c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C181.1,608.7,180,608.3,179.1,608.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M175.9,601.2c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C177.9,601.3,176.8,600.8,175.9,601.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M172.7,593.8c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C174.7,593.9,173.6,593.4,172.7,593.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M169.5,586.4c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C171.4,586.4,170.4,586,169.5,586.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M166.3,579c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C168.2,579,167.2,578.6,166.3,579z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M177.3,622c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C179.3,622,178.2,621.6,177.3,622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M174.1,614.6c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C176.1,614.6,175,614.2,174.1,614.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M170.9,607.2c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C172.9,607.2,171.8,606.8,170.9,607.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M167.7,599.8c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C169.7,599.8,168.6,599.4,167.7,599.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M164.5,592.4c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C166.5,592.4,165.4,592,164.5,592.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M161.3,584.9c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C163.3,585,162.2,584.5,161.3,584.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M158.1,577.5c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C160,577.6,159,577.1,158.1,577.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M170.7,621.1c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C172.6,621.1,171.6,620.7,170.7,621.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M167.5,613.7c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C169.4,613.7,168.4,613.3,167.5,613.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M164.2,606.3c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C166.2,606.3,165.2,605.9,164.2,606.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M161,598.9c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C163,598.9,161.9,598.5,161,598.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M157.8,591.5c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C159.8,591.5,158.7,591.1,157.8,591.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M154.6,584.1c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C156.6,584.1,155.5,583.7,154.6,584.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M165.7,627c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C167.7,627.1,166.6,626.6,165.7,627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M162.5,619.6c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C164.5,619.6,163.4,619.2,162.5,619.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M159.3,612.2c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C161.2,612.2,160.2,611.8,159.3,612.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M156.1,604.8c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C158,604.8,157,604.4,156.1,604.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M152.8,597.4c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C154.8,597.4,153.8,597,152.8,597.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M149.6,590c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C151.6,590,150.6,589.6,149.6,590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M146.4,582.6c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C148.4,582.6,147.3,582.2,146.4,582.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M159,626.2c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C161,626.2,159.9,625.8,159,626.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M155.8,618.7c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C157.8,618.8,156.7,618.3,155.8,618.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M152.6,611.3c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C154.6,611.4,153.5,610.9,152.6,611.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M149.4,603.9c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C151.4,603.9,150.3,603.5,149.4,603.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M146.2,596.5c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C148.2,596.5,147.1,596.1,146.2,596.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M143,589.1c-0.9,0.4-1.3,1.5-0.9,2.4c0.4,0.9,1.5,1.3,2.4,0.9c0.9-0.4,1.3-1.5,0.9-2.4 C144.9,589.1,143.9,588.7,143,589.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M201.2,584.3c-2,0.9-4.2,0-5.1-2l-5.7-13c-0.9-2,0-4.2,2-5.1l7.1-3.1c2-0.9,4.2,0,5.1,2 l5.7,13c0.9,2,0,4.2-2,5.1L201.2,584.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD01F"
    },
    points: "203.9,568.2 202.1,576.2 195.3,572  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M211.6,608c-2,0.9-4.2,0-5.1-2l-5.7-13c-0.9-2,0-4.2,2-5.1l7.1-3.1c2-0.9,4.2,0,5.1,2 l5.7,13c0.9,2,0,4.2-2,5.1L211.6,608z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 207.6,
    y: 596.8,
    transform: "matrix(0.9153 -0.4028 0.4028 0.9153 -222.9913 135.8339)",
    style: {
      fill: "#FFD01F"
    },
    width: 7.7,
    height: 2.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 205.5,
    y: 592.1,
    transform: "matrix(0.9157 -0.4019 0.4019 0.9157 -220.8122 134.1737)",
    style: {
      fill: "#FFD01F"
    },
    width: 7.7,
    height: 2.6
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCDBD"
    },
    d: "M116.8,606.2c-1.9-5.6,1.1-11.7,6.7-13.7l0.4-0.1c5.6-1.9,11.7,1.1,13.7,6.7l15.5,45.6 c1.9,5.6-1.1,11.7-6.7,13.7l-0.4,0.1c-5.6,1.9-11.7-1.1-13.7-6.7L116.8,606.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCDBD"
    },
    d: "M97.3,616.9c-1.9-5.6,1.1-11.7,6.7-13.7l0.4-0.1c5.6-1.9,11.7,1.1,13.7,6.7l14.3,42 c1.9,5.6-1.1,11.7-6.7,13.7l-0.4,0.1c-5.6,1.9-11.7-1.1-13.7-6.7L97.3,616.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCDBD"
    },
    d: "M134.3,593.4c-1.9-5.6,1.1-11.7,6.7-13.7l0.4-0.1c5.6-1.9,11.7,1.1,13.7,6.7l17.6,51.7 c1.9,5.6-1.1,11.7-6.7,13.7l-0.4,0.1c-5.6,1.9-11.7-1.1-13.7-6.7L134.3,593.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCDBD"
    },
    d: "M154.7,589.2c-1.9-5.6,1.1-11.7,6.7-13.7l0.4-0.1c5.6-1.9,11.7,1.1,13.7,6.7l16.8,49.3 c1.9,5.6-1.1,11.7-6.7,13.7l-0.4,0.1c-5.6,1.9-11.7-1.1-13.7-6.7L154.7,589.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M136.6,593.9c0,0,1.6,4.9,3.4,5.1 c4.8,0.6,8.2-0.7,12.4-3.7c2.1-1.5,0.2-5.9,0.2-5.9C149.4,577.7,133.6,584.4,136.6,593.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M158.5,588.9c0,0,1.3,5.1,4.4,4.9 c4.6-0.3,7.8-1.5,11.2-4.4c2.1-1.8,0.1-6.3,0.1-6.3C170,571.8,154.8,579.7,158.5,588.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M120.5,606.9c0,0,0.5,4.1,3.2,5.1 c2.7,1,9.5-1.5,11.1-2.5c1.6-1,3-0.9,1.7-6.5C133.6,591.6,118.5,597.1,120.5,606.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M102.9,618.4c0,0,0.3,1.3,0.7,2.9 c0.4,1.5,1.1,1.8,1.5,1.9c4.4,1.4,8.4,0.1,12.9-2.8c0.4-0.3,1.2-1,0.9-2.7c-0.3-1.7-0.6-2.5-0.6-2.5 C115.8,604,100.7,609.4,102.9,618.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0AD"
    },
    d: "M168.5,260.3l13,25.1c-2.1,1.2-3.4,1.9-3.4,1.9s23.7,44.2-0.8,58c-39,22-55.7,8.4-55.7,8.4 l-31,16.9l-22.9-48.2c0,0,26.4-14.6,33.2-20.1c6.9-5.5,24.8-22.3,51.8-34.8C158.3,265.1,163.5,262.6,168.5,260.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M74.1,316.9l24.6,51.4c0,0-5.2,2.5-14,6.7L60,323.4L74.1,316.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7543"
    },
    d: "M-30.6,436.8c64.4-33.1,116.3-59.7,116.3-59.7l-1-2.1L60,323.4l-2.2-4.5L-15.9,352 L-30.6,436.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0AD"
    },
    d: "M196.4,256.7c6.3-2.6,10.1-9.4,8.2-15.7c-0.1-0.3-0.1-0.4-0.2-0.7c-1.9-6.3-10-9.6-17.5-6.4 c-27.4,12.9-48.1,29.9-66,54.4c-4.6,6.8-2.9,15.3,3,18.4c0.3,0.1,0.4,0.2,0.6,0.3c5.9,3.1,13.2,0.7,17-5 C156.7,281.4,173.3,267.7,196.4,256.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M126,316.1l108.6-50.8l14.3,34.4l-112,42.7c0.4,2.1-0.7,4.3-2.7,5.1l-0.4,0.2 c-2.1,0.9-4.6,0-5.7-1.9l-22.8,8.6l-9.8-23.6l21.9-10.6c-0.7-2.3,0.3-5,2.5-5.9l0.4-0.2C122.4,313.2,124.8,314.2,126,316.1z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212220"
    },
    d: "M212,298.8c1.8,4.3,4.3,8.3,7.3,12.1L187.4,323c-3.2-3.9-5.3-7-9.4-15 c-4.1-8-4.2-11.1-3.9-14.4l30.1-14.2C206.8,286,209.4,292.4,212,298.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BF7100"
    },
    points: "282.1,320.9 269.3,265.7 246.4,221.8 245.3,269.6  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M267.6,220c-24.3,10.1-55.8,46.3-45.6,70.7c10.1,24.3,58,27.5,82.3,17.4 c24.3-10.1,35.8-38,25.7-62.4C319.8,221.4,291.9,209.9,267.6,220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212220"
    },
    d: "M260.5,252.2c0.4,2.2,0.8,4.4,1.4,6.6c2.7,6.6,5.3,13.3,8,19.9c1.5,3.6,3.5,7,5.9,10.2 c4.6,8.4,10.2,16.2,17,22.7c-25.5,5.4-62.2,0.1-70.9-20.9c-8.5-20.3,12.1-49,33.3-63.7C256.1,235.4,257.8,243.9,260.5,252.2 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD01F"
    },
    points: "282.1,320.9 215.6,345 185.5,296.2 250.1,267.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFECA5"
    },
    points: "250,267.6 185.7,296.1 182.4,251.9 246.4,221.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCDBD"
    },
    d: "M124.3,314.1c-2.3-5.5,0.4-11.8,5.9-14l0.4-0.2c5.5-2.3,11.8,0.4,14,5.9l18.3,44.6 c2.3,5.5-0.4,11.8-5.9,14l-0.4,0.2c-5.5,2.3-11.8-0.4-14-5.9L124.3,314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCDBD"
    },
    d: "M106.7,325.5c-2.3-5.5,0.4-11.8,5.9-14l0.4-0.2c5.5-2.3,11.8,0.4,14,5.9l16.9,41 c2.3,5.5-0.4,11.8-5.9,14l-0.4,0.2c-5.5,2.3-11.8-0.4-14-5.9L106.7,325.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCDBD"
    },
    d: "M141,300.3c-2.3-5.5,0.4-11.8,5.9-14l0.4-0.2c5.5-2.3,11.8,0.4,14,5.9l20.8,50.6 c2.3,5.5-0.4,11.8-5.9,14l-0.4,0.2c-5.5,2.3-11.8-0.4-14-5.9L141,300.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCDBD"
    },
    d: "M161.1,294.8c-2.3-5.5,0.4-11.8,5.9-14l0.4-0.2c5.5-2.3,11.8,0.4,14,5.9l19.8,48.2 c2.3,5.5-0.4,11.8-5.9,14l-0.4,0.2c-5.5,2.3-11.8-0.4-14-5.9L161.1,294.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M142.2,297.6c0,0,1.6,4.9,3.4,5.1 c4.8,0.6,8.2-0.7,12.4-3.7c2.1-1.5,0.2-5.9,0.2-5.9C154.9,281.4,139.2,288.1,142.2,297.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M164.1,292.6c0,0,1.3,5.1,4.4,4.9 c4.6-0.3,7.8-1.5,11.2-4.4c2.1-1.8,0.1-6.3,0.1-6.3C175.5,275.5,160.4,283.4,164.1,292.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M126,310.6c0,0,0.5,4.1,3.2,5.1c2.7,1,9.5-1.5,11.1-2.5 c1.6-1,3-0.9,1.7-6.5C139.1,295.3,124,300.9,126,310.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M108.4,322.2c0,0,0.3,1.3,0.7,2.9 c0.4,1.5,1.1,1.8,1.5,1.9c4.4,1.4,8.4,0.1,12.9-2.8c0.4-0.3,1.2-1,0.9-2.7c-0.3-1.7-0.6-2.5-0.6-2.5 C121.4,307.7,106.2,313.1,108.4,322.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "c140__x2B__2_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.8,295.6c-6.8-1.2-13.3,3.4-14.5,10.2c-1.2,6.8,3.4,13.3,10.2,14.5c6.8,1.2,13.3-3.4,14.5-10.2 C246.3,303.3,241.7,296.8,234.8,295.6z M238.7,310.9l-4.4-0.8l-0.8,4.5l-3.8-0.7l0.8-4.5l-4.4-0.8l0.7-3.8l4.4,0.8l0.8-4.3 l3.8,0.7l-0.8,4.3l4.4,0.8L238.7,310.9L238.7,310.9z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCDBD"
    },
    d: "M968.2,136.5L968.2,136.5c-0.9-5.5,2.9-10.6,8.4-11.6 l100.1-17.2c5.5-0.9,10.7,2.9,11.6,8.4l0,0c0.9,5.5-2.9,10.6-8.4,11.6l-100.1,17.2C974.3,145.8,969.1,142,968.2,136.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCDBD"
    },
    points: "1146.7,104.2 1108.4,63.5 1076.4,93.6  1012.6,116.4 1069.6,176.8  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCDBD"
    },
    d: "M988,110.7L988,110.7c-0.9-5.5,2.9-10.6,8.4-11.6 L1096.5,82c5.5-0.9,10.7,2.9,11.6,8.4l0,0c0.9,5.5-2.9,10.6-8.4,11.6l-100.1,17.2C994,120,988.8,116.2,988,110.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCDBD"
    },
    d: "M939.6,165L939.6,165c-0.9-5.5,2.9-10.6,8.4-11.6 l96.4-16.5c5.5-0.9,10.7,2.9,11.6,8.4l0,0c0.9,5.5-2.9,10.6-8.4,11.6l-96.4,16.5C945.6,174.3,940.4,170.4,939.6,165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201514"
    },
    d: "M961.8,246.7l-34.3-36.4c-6.6-7-6.3-18.2,0.7-24.9l96.6-91 c7-6.6,18.2-6.3,24.9,0.7l34.3,36.4c6.6,7,6.3,18.2-0.7,24.9l-96.6,91C979.6,254.1,968.5,253.8,961.8,246.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M978.8,244.3L931,193.5c-0.1-0.1-0.1-0.3,0-0.3l100.4-94.5 c0.1-0.1,0.3-0.1,0.3,0l47.8,50.7c0.1,0.1,0.1,0.3,0,0.3l-100.4,94.5C979.1,244.4,978.9,244.4,978.8,244.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5085A1"
    },
    d: "M956.6,235.1l-17.7-18.8c-0.5-0.5-0.5-1.3,0.1-1.8l0,0 c0.5-0.5,1.3-0.5,1.8,0.1l17.7,18.8c0.5,0.5,0.5,1.3-0.1,1.8l0,0C957.8,235.6,957,235.6,956.6,235.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5085A1"
    },
    d: "M1058,121.9c-1.6-1.7-1.5-4.5,0.2-6.1 c1.7-1.6,4.5-1.5,6.1,0.2c1.6,1.7,1.5,4.5-0.2,6.1C1062.3,123.7,1059.6,123.6,1058,121.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCDBD"
    },
    d: "M978.6,112.2L978.6,112.2c-0.9-5.5,2.9-10.7,8.4-11.6 l18.6-3c5.5-0.9,10.7,2.9,11.6,8.4l0,0c0.9,5.5-2.9,10.7-8.4,11.6l-18.6,3C984.7,121.4,979.5,117.7,978.6,112.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCDBD"
    },
    d: "M957.6,138.2L957.6,138.2c-0.9-5.5,2.9-10.7,8.4-11.6 l15.9-2.6c5.5-0.9,10.7,2.9,11.6,8.4l0,0c0.9,5.5-2.9,10.7-8.4,11.6l-15.9,2.6C963.7,147.5,958.5,143.7,957.6,138.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1110.4,
    y: 47.8,
    transform: "matrix(0.728 -0.6856 0.6856 0.728 249.9286 796.1574)",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    width: 35.8,
    height: 70.6
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F7555E"
    },
    points: "1182.4,-30.7 1109.6,38.2 1164.2,96.2  1301.1,-30.7  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCDBD"
    },
    d: "M1110,129.3l-4.9-5.2l-5.9,6.6l-47.4,53.1 c-9.9,11-4.4,19.7,2,26.5l55.9-62.7C1114.4,142.4,1114.6,134.2,1110,129.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#213228"
    },
    d: "M984.4,166.9c0.5,0.4,1,0.6,1.6,0.6c0.6,0,1.2-0.3,1.6-0.7l3.1-3.4c3-3.3,6.7-5,11.1-5.2 c4.4-0.2,8.3,1.2,11.6,4.2c3.3,3,5,6.7,5.2,11.1c0.2,4.4-1.2,8.3-4.2,11.6l-3.1,3.4c-0.4,0.5-0.6,1-0.6,1.7 c0,0.6,0.3,1.2,0.7,1.6c0.5,0.4,1,0.6,1.6,0.6c0.6,0,1.2-0.3,1.6-0.7l3.1-3.4c3.6-3.9,5.3-8.5,5.4-13.7c0-5.3-1.7-9.8-5.1-13.8 l3.2-3.5l6.8,6.2c0.5,0.4,1,0.6,1.7,0.6c0.6,0,1.2-0.3,1.6-0.7c0.4-0.5,0.6-1,0.6-1.7c0-0.6-0.3-1.2-0.7-1.6l-16.9-15.4 c-0.5-0.4-1-0.6-1.6-0.6c-0.6,0-1.2,0.3-1.6,0.7c-0.4,0.5-0.6,1-0.6,1.6c0,0.6,0.3,1.2,0.7,1.6l6.8,6.2l-3.2,3.5 c-4.2-3.1-8.9-4.3-14.2-3.8c-5.2,0.5-9.6,2.7-13.2,6.6l-3.1,3.4c-0.4,0.5-0.6,1-0.6,1.6C983.7,165.9,983.9,166.4,984.4,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD01F"
    },
    d: "M1001.5,183.3l4.5,4.1l2.8-3.1l-4.5-4.1c-0.7-0.6-0.7-1.7-0.1-2.4c0.6-0.7,1.7-0.7,2.4-0.1 l4.5,4.1c2.1-2.3,3.1-5,2.9-8.2c-0.1-3.2-1.4-5.8-3.7-7.9c-2.3-2.1-5.1-3.1-8.3-3c-3.1,0.1-5.8,1.4-7.9,3.7l4.3,3.9 c0.7,0.6,0.7,1.7,0.1,2.4c-0.6,0.7-1.7,0.7-2.4,0.1l-4.3-3.9l-2.8,3.1l4.3,3.9c0.7,0.6,0.7,1.7,0.1,2.4 c-0.6,0.7-1.7,0.7-2.4,0.1l-4.3-3.9l-3,3.3l4.3,3.9c0.7,0.6,0.7,1.7,0.1,2.4c-0.6,0.7-1.7,0.7-2.4,0.1l-4.3-3.9 c-2,2.3-2.9,4.9-2.8,8c0.1,3.2,1.4,5.8,3.7,7.9c2.3,2.1,5.1,3.1,8.3,3c3.1-0.1,5.6-1.3,7.7-3.5l-4.5-4.1 c-0.7-0.6-0.7-1.7-0.1-2.4c0.6-0.7,1.7-0.7,2.4-0.1l4.5,4.1l3-3.3l-4.5-4.1c-0.7-0.6-0.7-1.7-0.1-2.4 C999.8,182.7,1000.8,182.7,1001.5,183.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0AD"
    },
    d: "M1199.2,293.2l-19.1,20.8c1.7,1.7,2.8,2.7,2.8,2.7s-34.5,36.4-14.5,56.2 c31.8,31.5,51.6,22.7,51.6,22.7l25.4,24.5l34.8-40.5c0,0-21.6-21-26.8-28.1c-5.2-7.1-18.1-28-40.9-47.1 C1207.8,300.5,1203.4,296.8,1199.2,293.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E2D4"
    },
    d: "M1280.9,378.9l-38.5,42c0,0,4.2,3.9,11.4,10.5l38.7-42.2L1280.9,378.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#027695"
    },
    d: "M1381.7,461.3l-85.8-75.8l-3.4,3.7l-38.7,42.2l-1.5,1.7c0,0,64.7,64.2,129.4,128.7V461.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0AD"
    },
    d: "M1171.4,289.9c-5.8-3.6-8.4-10.9-5.5-16.8c0.1-0.3,0.2-0.4,0.3-0.7c3-5.9,11.4-7.8,18.4-3.5 c25,17.2,42.6,37.4,56.2,64.5c3.4,7.5,0.4,15.6-5.9,17.7c-0.3,0.1-0.4,0.1-0.7,0.2c-6.3,2.1-13.1-1.5-15.9-7.7 C1206.6,320.8,1192.4,304.6,1171.4,289.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1244.5,334.8c6.4,4.6,7.8,13.4,3.3,19.8l-24.1,33.6c-4.6,6.4-13.4,7.8-19.8,3.3l-90.2-64.7 c-6.4-4.6-7.8-13.4-3.3-19.8l24.1-33.6c4.6-6.4,13.4-7.8,19.8-3.3L1244.5,334.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M1110.3,307C1110.3,307,1110.3,307,1110.3,307l113.4,81.1l24-33.5c0,0,0.1-0.1,0.1-0.1 l-113.5-81.1L1110.3,307z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1199,362.8c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1197.7,362.6,1198.5,362.5,1199,362.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1202,358.6c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1200.8,358.3,1201.5,358.2,1202,358.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1205.1,354.4c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1203.8,354.1,1204.6,354,1205.1,354.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1208.1,350.1c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1206.9,349.9,1207.6,349.7,1208.1,350.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1211.2,345.9c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1209.9,345.6,1210.6,345.5,1211.2,345.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1214.2,341.6c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1213,341.4,1213.7,341.3,1214.2,341.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1217.3,337.4c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1216,337.1,1216.7,337,1217.3,337.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1203.3,363.2c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1202.1,362.9,1202.8,362.8,1203.3,363.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1206.4,359c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1205.1,358.7,1205.8,358.6,1206.4,359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1209.4,354.7c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1208.2,354.5,1208.9,354.3,1209.4,354.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1212.5,350.5c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1211.2,350.2,1211.9,350.1,1212.5,350.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1215.5,346.2c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1214.2,346,1215,345.9,1215.5,346.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1218.5,342c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1217.3,341.7,1218,341.6,1218.5,342z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1205.7,367.6c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1204.4,367.4,1205.1,367.2,1205.7,367.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1208.7,363.4c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1207.5,363.1,1208.2,363,1208.7,363.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1211.7,359.1c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1210.5,358.9,1211.2,358.8,1211.7,359.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1214.8,354.9c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1213.5,354.6,1214.3,354.5,1214.8,354.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1217.8,350.7c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1216.6,350.4,1217.3,350.3,1217.8,350.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1220.9,346.4c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1219.6,346.2,1220.3,346,1220.9,346.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1223.9,342.2c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1222.7,341.9,1223.4,341.8,1223.9,342.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1210,368c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1208.7,367.7,1209.5,367.6,1210,368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1213,363.7c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1211.8,363.5,1212.5,363.4,1213,363.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1216.1,359.5c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1214.8,359.2,1215.6,359.1,1216.1,359.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1219.1,355.3c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1217.9,355,1218.6,354.9,1219.1,355.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1222.2,351c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1220.9,350.8,1221.6,350.6,1222.2,351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1225.2,346.8c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1224,346.5,1224.7,346.4,1225.2,346.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1212.3,372.4c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1211.1,372.1,1211.8,372,1212.3,372.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1215.4,368.2c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1214.1,367.9,1214.8,367.8,1215.4,368.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1218.4,363.9c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1217.2,363.7,1217.9,363.5,1218.4,363.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1221.5,359.7c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1220.2,359.4,1220.9,359.3,1221.5,359.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1224.5,355.4c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1223.2,355.2,1224,355.1,1224.5,355.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1227.5,351.2c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1226.3,350.9,1227,350.8,1227.5,351.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1230.6,346.9c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1229.3,346.7,1230.1,346.6,1230.6,346.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1216.7,372.8c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1215.4,372.5,1216.1,372.4,1216.7,372.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1219.7,368.5c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1218.5,368.3,1219.2,368.1,1219.7,368.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1222.7,364.3c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1221.5,364,1222.2,363.9,1222.7,364.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1225.8,360c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1224.5,359.8,1225.3,359.7,1225.8,360z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1228.8,355.8c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1227.6,355.5,1228.3,355.4,1228.8,355.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1231.9,351.5c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1230.6,351.3,1231.3,351.2,1231.9,351.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1219,377.2c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1217.7,376.9,1218.5,376.8,1219,377.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1222,372.9c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1220.8,372.7,1221.5,372.6,1222,372.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1225.1,368.7c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1223.8,368.4,1224.6,368.3,1225.1,368.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1228.1,364.5c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1226.9,364.2,1227.6,364.1,1228.1,364.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1231.2,360.2c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1229.9,360,1230.6,359.8,1231.2,360.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1234.2,356c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1233,355.7,1233.7,355.6,1234.2,356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1237.2,351.7c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1236,351.5,1236.7,351.4,1237.2,351.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1223.3,377.5c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1222.1,377.3,1222.8,377.2,1223.3,377.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1226.4,373.3c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1225.1,373,1225.8,372.9,1226.4,373.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1229.4,369.1c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1228.2,368.8,1228.9,368.7,1229.4,369.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1232.5,364.8c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1231.2,364.6,1231.9,364.4,1232.5,364.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1235.5,360.6c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1234.2,360.3,1235,360.2,1235.5,360.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1238.5,356.3c0.5,0.4,0.6,1.1,0.3,1.6c-0.4,0.5-1.1,0.6-1.6,0.3c-0.5-0.4-0.6-1.1-0.3-1.6 C1237.3,356.1,1238,355.9,1238.5,356.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1195.4,332.7c3.6,2.6,4.4,7.5,1.8,11.1c-2.6,3.6-7.5,4.4-11.1,1.8 c-3.6-2.6-4.4-7.5-1.8-11.1C1186.8,330.9,1191.8,330.1,1195.4,332.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M1195.4,332.7c3.6,2.6,4.4,7.5,1.8,11.1c-2.6,3.6-7.5,4.4-11.1,1.8 c-3.6-2.6-4.4-7.5-1.8-11.1C1186.8,330.9,1191.8,330.1,1195.4,332.7z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD01F"
    },
    points: "1185.6,338 1193.4,335.4 1193.2,343.4  "
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.5827 -0.8127 0.8127 0.5827 1124.7227 308.1844)",
    style: {
      fill: "#424340",
      fontFamily: "'DejaVuSansCondensed-Bold'",
      fontSize: "6.1721px"
    }
  }, "BRAND"), /*#__PURE__*/React.createElement("rect", {
    x: 1128.9,
    y: 286.9,
    transform: "matrix(0.5813 -0.8137 0.8137 0.5813 228.0598 1073.7614)",
    style: {
      fill: "#424340"
    },
    width: 56.8,
    height: 56.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1131.5,
    y: 289.5,
    transform: "matrix(0.5812 -0.8137 0.8137 0.5812 228.0836 1073.7914)",
    style: {
      fill: "#CECFCC"
    },
    width: 51.6,
    height: 51.6
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#E6E7E5"
    },
    points: "1151.3,279.3 1193.3,309.3 1163.3,351.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCDBD"
    },
    d: "M1214,356.4c4-4.4,3.7-11.2-0.7-15.2l-0.3-0.3c-4.4-4-11.2-3.7-15.2,0.7l-32.6,35.5 c-4,4.4-3.7,11.2,0.7,15.2l0.3,0.3c4.4,4,11.2,3.7,15.2-0.7L1214,356.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCDBD"
    },
    d: "M1227.5,374.1c4-4.4,3.7-11.2-0.7-15.2l-0.3-0.3c-4.4-4-11.2-3.7-15.2,0.7l-30,32.7 c-4,4.4-3.7,11.2,0.7,15.2l0.3,0.3c4.4,4,11.2,3.7,15.2-0.7L1227.5,374.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCDBD"
    },
    d: "M1203.1,337.7c4-4.4,3.7-11.2-0.7-15.2l-0.3-0.3c-4.4-4-11.2-3.7-15.2,0.7l-36.9,40.3 c-4,4.4-3.7,11.2,0.7,15.2l0.3,0.3c4.4,4,11.2,3.7,15.2-0.7L1203.1,337.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCDBD"
    },
    d: "M1186.1,325.6c4-4.4,3.7-11.2-0.7-15.2l-0.3-0.3c-4.4-4-11.2-3.7-15.2,0.7l-35.2,38.4 c-4,4.4-3.7,11.2,0.7,15.2l0.3,0.3c4.4,4,11.2,3.7,15.2-0.7L1186.1,325.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M1200.2,344.1c0,0-4.3,2.8-4,4.6c0.7,4.8,2.8,7.7,6.8,11 c2,1.6,5.8-1.3,5.8-1.3C1219.2,352.1,1208.6,338.7,1200.2,344.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M1211.9,361.5c0,0-4.6,2.6-3.6,5.5 c1.5,4.4,3.5,7.1,7.2,9.6c2.3,1.6,6.1-1.6,6.1-1.6C1231.4,368.1,1219.8,355.5,1211.9,361.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M1189.5,324.4c0,0-3.9,1.5-4.1,4.4c-0.2,2.9,4,8.8,5.3,10 c1.4,1.2,1.7,2.7,6.7-0.1C1207.7,333.1,1198.3,319.9,1189.5,324.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M1173.7,313.8c0,0-1.2,0.6-2.6,1.4 c-1.4,0.8-1.4,1.6-1.4,2c-0.2,4.6,2.1,8.1,6.1,11.7c0.4,0.3,1.3,0.9,2.9,0.1c1.6-0.8,2.2-1.3,2.2-1.3 C1191,322.5,1181.9,309.3,1173.7,313.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0AD"
    },
    d: "M1055.5,486.4l-21.1,18.8c1.5,1.9,2.5,3,2.5,3s-38,32.7-20.2,54.4 c28.4,34.6,48.9,27.9,48.9,27.9l22.8,27l38.8-36.7c0,0-19.3-23.1-23.8-30.7c-4.4-7.6-15.1-29.7-35.8-51.1 C1063.4,494.5,1059.3,490.3,1055.5,486.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1123.1,573.2l-41.5,39.1c0,0,3.9,4.2,10.6,11.3l41.7-39.3L1123.1,573.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7543"
    },
    d: "M1280.3,731.3l-142.7-150.4l-3.7,3.4l-41.7,39.3l-1.7,1.6c0,0,102.5,117.6,161.6,184.9h28.1 V731.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0AD"
    },
    d: "M1030.8,473c-4.9-4.7-6.1-12.4-2-17.6c0.2-0.2,0.3-0.3,0.4-0.6c4.1-5.2,12.8-5.3,18.7,0.3 c20.9,21.9,34.1,45.3,41.9,74.6c1.8,8-2.8,15.3-9.4,16.1c-0.3,0-0.4,0.1-0.7,0.1c-6.6,0.8-12.5-4.1-14-10.8 C1058.9,510.4,1048.4,491.6,1030.8,473z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M1086.2,550.8l-68.7-97.6L979,488.6l87.1,82.3c-1.1,1.8-1,4.2,0.6,5.8l0.3,0.3 c1.6,1.6,4.2,1.8,6,0.4l17.7,16.7l18.1-18.1l-16.2-18.2c1.5-1.8,1.6-4.7-0.1-6.4l-0.3-0.3 C1090.7,549.5,1088,549.5,1086.2,550.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212220"
    },
    d: "M1013.4,502c-3.3,3.3-7.1,6-11.4,8.4l24.8,23.4c4.5-2.4,7.6-4.4,14.4-10.2 c6.8-5.8,8.1-8.7,9.1-11.8l-22.4-24.6C1023.1,492.1,1018.2,497,1013.4,502z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BF7100"
    },
    points: "940.2,499.4 973.1,449.4 1011,417.6 993.8,462.2  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M992.2,407.9c18.6,18.7,33.8,64.1,15.1,82.7c-18.7,18.6-64.1,3.3-82.7-15.4 c-18.6-18.7-18.6-48.9,0.1-67.5C943.4,389.2,973.6,389.2,992.2,407.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212220"
    },
    d: "M986.4,440.3c-1.2,1.9-2.4,3.7-3.8,5.5c-5,5.1-10,10.2-15,15.3c-2.7,2.7-5.9,5.1-9.3,7.2 c-7.5,6-15.6,11.1-24.4,14.4c21.6,14.7,57.4,23.9,73.5,7.8c15.6-15.6,7.5-49.9-6.4-71.6C996.9,426.5,992.1,433.7,986.4,440.3z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD01F"
    },
    points: "940.2,499.4 992.4,543.3 1042.7,503.5 990.1,458.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFECA5"
    },
    points: "990.2,458.5 1043,503.8 1063.8,467.3 1011,417.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCDBD"
    },
    d: "M1070.7,550.3c4.1-4.3,3.9-11.1-0.4-15.2l-0.3-0.3c-4.3-4.1-11.1-3.9-15.2,0.4l-33.2,35 c-4.1,4.3-3.9,11.1,0.4,15.2l0.3,0.3c4.3,4.1,11.1,3.9,15.2-0.4L1070.7,550.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCDBD"
    },
    d: "M1083.1,567.3c4.1-4.3,3.9-11.1-0.4-15.2l-0.3-0.3c-4.3-4.1-11.1-3.9-15.2,0.4l-30.5,32.2 c-4.1,4.3-3.9,11.1,0.4,15.2l0.3,0.3c4.3,4.1,11.1,3.9,15.2-0.4L1083.1,567.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCDBD"
    },
    d: "M1060.2,531.4c4.1-4.3,3.9-11.1-0.4-15.2l-0.3-0.3c-4.3-4.1-11.1-3.9-15.2,0.4l-37.6,39.7 c-4.1,4.3-3.9,11.1,0.4,15.2l0.3,0.3c4.3,4.1,11.1,3.9,15.2-0.4L1060.2,531.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCDBD"
    },
    d: "M1043.4,519c4.1-4.3,3.9-11.1-0.4-15.2l-0.3-0.3c-4.3-4.1-11.1-3.9-15.2,0.4l-35.8,37.8 c-4.1,4.3-3.9,11.1,0.4,15.2l0.3,0.3c4.3,4.1,11.1,3.9,15.2-0.4L1043.4,519z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M1058.7,535.8c0,0-4.3,2.8-4,4.6c0.7,4.8,2.8,7.7,6.8,11 c2,1.6,5.8-1.3,5.8-1.3C1077.7,543.9,1067.1,530.4,1058.7,535.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M1070.5,553.3c0,0-4.6,2.6-3.6,5.5 c1.5,4.4,3.5,7.1,7.2,9.6c2.3,1.6,6.1-1.6,6.1-1.6C1089.9,559.8,1078.4,547.3,1070.5,553.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M1048,516.1c0,0-3.9,1.5-4.1,4.4c-0.2,2.9,4,8.8,5.3,10 c1.4,1.2,1.7,2.7,6.7-0.1C1066.2,524.8,1056.9,511.7,1048,516.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M1032.2,505.6c0,0-1.2,0.6-2.6,1.4 c-1.4,0.8-1.4,1.6-1.4,2c-0.2,4.6,2.1,8.1,6.1,11.7c0.4,0.3,1.3,0.9,2.9,0.1c1.6-0.8,2.2-1.3,2.2-1.3 C1049.6,514.2,1040.4,501,1032.2,505.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M997.6,485.3c-4.2-1.6-8.4-1.6-12.6,0.1c-2.1,0.9-3.9,2.1-5.5,3.7c-1.6,1.6-2.8,3.5-3.6,5.6 c-1.6,4.2-1.6,8.4,0,12.6c0.8,2.1,2.1,3.9,3.7,5.5c1.6,1.6,3.5,2.8,5.6,3.6c4.2,1.6,8.4,1.6,12.6-0.1c2.1-0.8,3.9-2.1,5.5-3.7 c1.6-1.6,2.8-3.5,3.6-5.6c1.7-4.2,1.6-8.4-0.1-12.6c-0.8-2.1-2.1-3.9-3.7-5.5C1001.6,487.4,999.7,486.2,997.6,485.3z  M977.9,495.2c0.3,2.3,1.2,4.7,2.7,7.2l-3.1,3.1C976.4,502.2,976.5,498.5,977.9,495.2z M981.1,511.3c-1.1-1.1-2-2.4-2.7-3.8 l3.4-3.4c0.9,1.3,2,2.4,3,3.5c1.1,1.1,2.2,2,3.5,3l-3.4,3.4C983.5,513.3,982.2,512.4,981.1,511.3z M986.9,514.8l3.1-3.1 c2.5,1.5,4.9,2.4,7.2,2.7C993.9,515.7,990.2,515.9,986.9,514.8z M1001,511.8c-1.1,0.6-2.5,0.8-4.2,0.5c-1.7-0.3-3.5-1-5.4-2.1 l3.9-4L1001,511.8z M994,504.8l-4.3,4.3c-1.3-1-2.5-2-3.5-3c-1.1-1.1-2.1-2.3-3-3.5l4.2-4.3L994,504.8L994,504.8z M986,496.9 l-3.9,4c-1.1-1.9-1.8-3.6-2.1-5.4c-0.3-1.7-0.2-3.1,0.4-4.2L986,496.9L986,496.9z M996,486.9l-3.1,3.1 c-2.5-1.5-4.9-2.4-7.2-2.6C988.9,486,992.6,485.8,996,486.9z M981.9,489.9c1.1-0.6,2.5-0.8,4.2-0.5c1.7,0.3,3.5,1,5.4,2l-3.9,4 L981.9,489.9z M988.9,496.9l4.2-4.3c1.3,0.9,2.5,1.9,3.6,3c1,1,2,2.2,3,3.5l-4.3,4.3L988.9,496.9z M1002.5,510.3l-5.7-5.6 l3.9-4c1.1,1.9,1.8,3.7,2.1,5.4C1003.2,507.8,1003.1,509.2,1002.5,510.3z M1005,506.5c-0.3-2.3-1.2-4.7-2.8-7.2l3.1-3.1 C1006.5,499.5,1006.4,503.2,1005,506.5z M1004.5,494.1l-3.4,3.4c-0.9-1.3-1.9-2.4-3-3.5c-1.1-1.1-2.2-2.1-3.5-3l3.4-3.4 c1.4,0.7,2.7,1.6,3.8,2.7C1002.9,491.5,1003.8,492.7,1004.5,494.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#84867F"
    },
    points: "745.4,577.7 703.8,577.7 700.3,554.3 748.9,554.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#201514"
    },
    points: "707.9,578.6 704.2,554.4 744.8,555 741.4,578.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M746.2,556.8l-43.1-0.1c-7.7,0-14-6.3-13.9-14l0.1-42.5c0-7.7,6.3-14,14-13.9l43.1,0.1 c7.7,0,14,6.3,13.9,14l-0.1,42.5C760.2,550.6,753.9,556.9,746.2,556.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M694.9,545.1L695,498c0-3.2,2.6-5.9,5.9-5.9l47.7,0.1c3.2,0,5.9,2.6,5.9,5.9l-0.1,47.1 c0,3.2-2.6,5.9-5.9,5.9l-47.7-0.1C697.5,551,694.9,548.3,694.9,545.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E9B4A4"
    },
    d: "M580.9,686.6c-4.7,0-19.8,2.4-28.1-1.5 c-12.8-2.9-22.4-57.1-11.4-68.4c22.8-23.5,44.5-51.7,55.6-52.7l29-7.2c7.3-0.7,14.8-0.4,26.6,0.9l18.3,5.3 c10.3,1.1,15.3,18.2-3,16.3l-25.2-5.9l-28.4,10.7c-25,25.1-39.7,87.2,10.8,89.7c9.6,0.5,14.5,3.2,16.3,12.6c1,5-1,5.4-5.3,5.4 L580.9,686.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCDBD"
    },
    points: "549.4,597.4 488.6,636.7 488.6,680.5 526.3,686.2  578.6,652.3  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCDBD"
    },
    d: "M572.4,686.2c-5.1,0-21.5,2.6-30.5-1.7 c-13.9-3.1-24.3-62-12.4-74.2c24.8-25.5,48.3-56.2,60.3-57.3l31.5-7.8c7.9-0.7,16.1-0.4,28.8,1l19.9,5.7 c11.1,1.2,16.6,19.8-3.3,17.7l-27.4-6.5l-30.9,11.7c-27.2,27.2-43.1,94.6,11.7,97.4c10.4,0.5,15.7,3.4,17.7,13.7 c1,5.5-1.1,5.9-5.8,5.9L572.4,686.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    points: "519,613.4 488.6,633.2 515.6,705.7 552,688.4  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFF2E8"
    },
    d: "M634,690.1c-0.2,1.9-2.8,2-6.9,1.5l-9.9-1.2 c0.9-0.9,2.2-1.7,3.7-2.5l7,0.8C630.3,689.1,632.3,689.6,634,690.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFF2E8"
    },
    d: "M662.7,550.2c6.7,1.7,14.2,2.1,16.6,9.9 c-2.3,0.9-4.9,1.1-7.6,0.3l-7.1-1.9C663.4,555.6,662.8,552.8,662.7,550.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D565F"
    },
    d: "M768.8,578.6l-17.2-0.1c-1.9,0-3.5-1.6-3.4-3.5l0,0c0-1.9,1.6-3.5,3.5-3.4l17.2,0.1 c1.9,0,3.5,1.6,3.4,3.5l0,0C772.3,577,770.7,578.6,768.8,578.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020927"
    },
    d: "M669.8,576.8L669.8,576.8c-1.9,0-3.5-1.6-3.5-3.5l0-1.2c0-1.9,1.6-3.5,3.5-3.5l0,0 c1.9,0,3.5,1.6,3.5,3.5l0,1.2C673.3,575.3,671.7,576.8,669.8,576.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#717585"
    },
    d: "M673.7,577.8l-7.6,0c-0.8,0-1.5-0.7-1.5-1.5l0,0c0-0.8,0.7-1.5,1.5-1.5l7.6,0 c0.8,0,1.5,0.7,1.5,1.5l0,0C675.1,577.2,674.5,577.9,673.7,577.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84867F"
    },
    d: "M782.3,573.9l-80.3-0.5c-1.5,0-2.7,1.2-2.8,2.7l0,0.7l-74.7-0.5c-1.5,0-2.7,1.2-2.8,2.7 l-0.6,90.6c0,1.5,1.2,2.7,2.7,2.8l157.8,1c1.5,0,2.7-1.2,2.8-2.7l0.5-77.2l0.1-13.3l0-3.5C785.1,575.2,783.8,573.9,782.3,573.9 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.7,
    y: 576.9,
    transform: "matrix(1 6.567664e-03 -6.567664e-03 1 3.8765 -4.8943)",
    style: {
      fill: "#4D565F"
    },
    width: 44.8,
    height: 21.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 726.7,
    y: 578,
    transform: "matrix(1 6.565970e-03 -6.565970e-03 1 3.8755 -4.8931)",
    style: {
      fill: "#B4A7AD"
    },
    width: 41,
    height: 19.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFECA5"
    },
    d: "M758.2,595.3l-23.4-0.2c-1.8,0-3.2-1.5-3.2-3.3l0.1-8.5c0-1.8,1.5-3.2,3.3-3.2l23.4,0.2 c1.8,0,3.2,1.5,3.2,3.3l-0.1,8.5C761.5,593.8,760,595.3,758.2,595.3z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 621.5,
    y: 601,
    transform: "matrix(1 6.566290e-03 -6.566290e-03 1 4.1698 -4.603)",
    style: {
      fill: "#020927"
    },
    width: 163.2,
    height: 63.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.5,
    y: 605.2,
    transform: "matrix(1 6.565765e-03 -6.565765e-03 1 4.1659 -4.6025)",
    style: {
      fill: "#F7555E"
    },
    width: 163.2,
    height: 54
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null)))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#027695"
    },
    points: "415,768.2 527.5,712.8 487,623.4 217.9,768.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.6,
    y: 584.9,
    style: {
      fill: "#B4A7AD"
    },
    width: 21.5,
    height: 10.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C1A16"
    },
    points: "486.4,168.1 522.2,153.4 567,152.1 522.2,170.3  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCDBD"
    },
    d: "M547.5,104.6L547.5,104.6c0.7-4.6-2.6-9.3-7.1-10l-63.7-8.9 c-4.6-0.8-1.2,5.8-1.9,10.3l0,0c-0.7,4.6-7.1,6.9-2.5,7.6l65.2,8.4C542.1,112.8,546.8,109.2,547.5,104.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCDBD"
    },
    d: "M543.2,86.7L543.2,86.7c-0.2-4.1-3.7-7.3-7.9-7.2l-21.2,1.2 c-4.1,0.1-1.7,15-1.7,15l23.6-1.1C540.2,94.5,543.4,90.9,543.2,86.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCDBD"
    },
    d: "M549.8,122.7L549.8,122.7c0.6-4.9-2.6-9.6-7.5-10.3 l-67.8-7.8c-4.9-0.7-1.1,6.1-1.7,11l0,0c-0.6,4.9-7.3,7.4-2.5,8.1l69.4,6.7C544.7,131.1,549.2,127.6,549.8,122.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCDBD"
    },
    d: "M549.9,140L549.9,140c0.4-4.9-3.3-9.2-8.2-9.6l-67.9-4.8 c-4.9-0.5,16.3,15.8,21.1,16.2l45.3,6.3C545.2,148.7,549.5,144.9,549.9,140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFC0AD"
    },
    d: "M532.5,94.3L532.5,94.3c1.3-4.5-1.3-9.1-5.8-10.5 l-56.9-16.5c-4.4-1.3-7,4.9-8.3,9.4l0,0c-1.3,4.5,1.3,9.1,5.8,10.4l54.8,12.9C526.5,101.5,531.3,98.8,532.5,94.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E4B775"
    },
    d: "M519.1,121.2l-36-10.8c-4.4-1.3,0.8,5.4-0.5,9.9l0,0 c-1.3,4.5-1.3,9.3,3.1,10.6l30.4,7.1L519.1,121.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#201514"
    },
    d: "M497.7,43.2c-0.3-1.6,0.7-3.1,2.3-3.4l5.6-1.1c1.6-0.3,3.1,0.7,3.4,2.3l2.5,12.6 c0.3,1.6-0.7,3.1-2.3,3.4l-5.6,1.1c-1.6,0.3-3.1-0.7-3.4-2.3L497.7,43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#353940"
    },
    d: "M494.2,62.9c-0.5-2.6,1.2-5.2,3.8-5.7l15.9-3.1c2.6-0.5,5.2,1.2,5.7,3.8l3.8,19.4 c0.5,2.6-1.2,5.2-3.8,5.7l-15.9,3.1c-2.6,0.5-5.2-1.2-5.7-3.8L494.2,62.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD01F"
    },
    d: "M491.3,79.5c-0.8-4.2,1.9-8.3,6.1-9.1l22.3-4.4c4.2-0.8,8.3,1.9,9.1,6.1l23,116.5 c0.8,4.2-1.9,8.3-6.1,9.1l-22.3,4.4c-4.2,0.8-8.3-1.9-9.1-6.1L491.3,79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#201514"
    },
    d: "M496.3,227.7c-3.3-16.6,3.6-31.9,20.2-35.2l31.9-6.3c16.6-3.3,28.8,8.3,32,24.9l5.8,29.4 c3.3,16.6-8.4,32.9-36,38.3c-27.6,5.5-44.8-5.1-48.1-21.7L496.3,227.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    d: "M498.5,239c28.7-2,56.8-7.6,84.1-16.6c0.7,3.6,0.9,4.4,1.6,7.7 c-27.2,9-55.6,14.6-84.2,16.7C499.3,243.1,499.3,242.7,498.5,239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424340"
    },
    d: "M484.3,171.3c-0.3-1.5,0.7-3,2.2-3.3l80.5-15.9c1.5-0.3,3,0.7,3.3,2.2l8.9,45 c0.3,1.5-0.7,3-2.2,3.3l-80.5,15.9c-1.5,0.3-3-0.7-3.3-2.2L484.3,171.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCDBD"
    },
    d: "M545.7,103.9L545.7,103.9c0.4-4.6-3.2-8.7-7.8-9.1l-13.4-1 c-4.6-0.4-8.7,3.2-9.1,7.8l0,0c-0.3,4.6,3.2,8.7,7.8,9.1l13.4,1C541.3,112,545.4,108.5,545.7,103.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M523.6,109.5c0,0,4.3,0.2,5.1-1.2c1.9-3.7,1.9-6.7,0.8-11 c-0.6-2.1-4.6-2-4.6-2C514.6,94.6,515.2,109.1,523.6,109.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCDBD"
    },
    d: "M542.1,87L542.1,87c0-3.6-3-6.5-6.5-6.5l-12.2,0 c-3.6,0-6.5,2.9-6.5,6.5l0,0c0,3.6,2.9,6.5,6.5,6.5l12.2,0C539.2,93.6,542.1,90.6,542.1,87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M523.8,92.3c0,0,3.4,0.4,4-1.5c0.9-2.9,0.9-5.2-0.1-7.9 c-0.6-1.7-3.8-1.5-3.8-1.5C516,81.3,517.3,92.4,523.8,92.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCDBD"
    },
    d: "M547.9,122.2L547.9,122.2c0.5-4.6-2.8-8.8-7.4-9.3 l-13.3-1.5c-4.6-0.5-8.8,2.8-9.3,7.4l0,0c-0.5,4.6,2.8,8.8,7.4,9.3l13.3,1.5C543.2,130.2,547.4,126.8,547.9,122.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M525.8,126.8c0,0,3.4,0.9,5-1c1.6-1.9,1.6-8,1.3-9.5 c-0.3-1.5,0.2-2.7-4.6-3.3C517.6,111.8,517.5,125.5,525.8,126.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCDBD"
    },
    d: "M548.2,140.3L548.2,140.3c0.6-4.4-2.5-8.5-6.9-9.1 l-12.8-1.8c-4.4-0.6-8.5,2.5-9.1,6.9l0,0c-0.6,4.4,2.5,8.5,6.9,9.1l12.8,1.8C543.4,147.9,547.6,144.8,548.2,140.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M526.8,144.1c0,0,1.1,0.2,2.5,0.3c1.3,0.1,1.7-0.4,2-0.7 c2.4-3.1,2.6-6.6,1.6-11.1c-0.1-0.4-0.5-1.2-1.9-1.5c-1.4-0.2-2.2-0.2-2.2-0.2C519.2,129.6,518.9,143.2,526.8,144.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCDBD"
    },
    d: "M461.2,72.9c0,0-20.7,31.2-24,34.8c6,4,20,13.1,27.7,20c7.7,6.9,11.2,13.7,21.9,21.5 c10.7,7.8,30.9,24.7,36.4,27.1c10.3,4.4,6.5-15.2,0.1-20.9c-8-7.1-13.9-10.4-15.4-12c-1.5-1.7,3.2-19.6-4.9-39.6 C494.8,83.6,461.2,72.9,461.2,72.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M421.6,102l16.1,11.5c1.4,1.3,3.3,1,4.2-0.6L468,66.7c0.9-1.7,0.2-3.5-1.6-4.1l-16.1-8.3 C448.7,53.7,420.2,100.7,421.6,102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#027695"
    },
    d: "M456.4,53.4l-60.5-39.2L205.4-98.4L173.8-19l251.8,127.8c1.1,0.6,2.4,0.2,3-0.9l28.7-51.5 C457.8,55.3,457.4,54,456.4,53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDED4"
    },
    d: "M526.5,178.9c1.4-1.9,0.9-3.9-2.9-7.6 c-3.8-3.7-7.5-6.8-9.2-6.4c-1.7,0.4-2.6,2.9-2.3,4.1C512.5,170.2,526,179.7,526.5,178.9z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderNoticia);
export default __webpack_public_path__ + "static/media/placeholder_noticia.e46bf14155199eab968fe94c9064e29e.svg";
export { ForwardRef as ReactComponent };